/* eslint-disable */ // Auto-generated file (DO NOT EDIT!!!), refer gql-codegen.yml

import { cacheExchange } from '@urql/exchange-graphcache';
import { Resolver as GraphCacheResolver, UpdateResolver as GraphCacheUpdateResolver, OptimisticMutationResolver as GraphCacheOptimisticMutationResolver } from '@urql/exchange-graphcache';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type AiChatModelOption = {
  __typename?: 'AIChatModelOption';
  /** Connection this model belongs to */
  connectionID: Scalars['ID']['output'];
  /** Connection label, shown as the group heading */
  connectionLabel: Scalars['String']['output'];
  /** Whether this is the instance default */
  isDefault: Scalars['Boolean']['output'];
  /** Model identifier to send back with a chat request */
  model: Scalars['String']['output'];
  /** Provider preset, so the picker can show the right mark */
  preset: Scalars['String']['output'];
};

export type AiProviderConnection = {
  __typename?: 'AIProviderConnection';
  /** Endpoint, where it differs from the preset's own */
  baseURL?: Maybe<Scalars['String']['output']>;
  /** Date the connection was added */
  createdOn: Scalars['DateTime']['output'];
  /** Model used when the user picks none */
  defaultModel: Scalars['String']['output'];
  /** Whether the assistant may use this connection */
  enabled: Scalars['Boolean']['output'];
  /** Whether a key is stored; the key itself never leaves */
  hasApiKey: Scalars['Boolean']['output'];
  /** Connection identifier */
  id: Scalars['ID']['output'];
  /** Used when a request names no connection */
  isDefault: Scalars['Boolean']['output'];
  /** Name the user sees in the model picker */
  label: Scalars['String']['output'];
  /** Models this connection offers */
  models: Array<Scalars['String']['output']>;
  /** Provider preset, e.g. anthropic, openai, azure */
  preset: Scalars['String']['output'];
  /** Date the connection was last changed */
  updatedOn: Scalars['DateTime']['output'];
};

export type AiProviderPreset = {
  __typename?: 'AIProviderPreset';
  /** Shape of the endpoint this preset needs spelled out */
  baseURLHint?: Maybe<Scalars['String']['output']>;
  /** Endpoint used when none is given */
  defaultBaseURL?: Maybe<Scalars['String']['output']>;
  /** Request dialect the preset speaks */
  dialect: Scalars['String']['output'];
  /** Preset identifier, sent back when adding a connection */
  name: Scalars['String']['output'];
  /** Whether an endpoint must be supplied */
  requiresBaseURL: Scalars['Boolean']['output'];
  /** Model ids to offer as a starting point, never exhaustive */
  suggestedModels: Array<Scalars['String']['output']>;
  /** Whether these capabilities come from a live call, not docs */
  verified: Scalars['Boolean']['output'];
};

export type AiProviderTestResult = {
  __typename?: 'AIProviderTestResult';
  /** The provider's own message, with the credential removed */
  detail?: Maybe<Scalars['String']['output']>;
  /** Round-trip time in milliseconds */
  latencyMs: Scalars['Int']['output'];
  /** Model this result is about */
  model: Scalars['String']['output'];
  /** Whether the provider served a turn */
  ok: Scalars['Boolean']['output'];
  /** Failure category: auth, not_found, bad_request, and so on */
  reason?: Maybe<Scalars['String']['output']>;
};

export type AiSettings = {
  __typename?: 'AISettings';
  /** When an admin acknowledged that request data goes to providers */
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** False unless the organization is an active enterprise; only deletes are allowed then */
  editable: Scalars['Boolean']['output'];
  /** Whether the assistant is available on this instance */
  enabled: Scalars['Boolean']['output'];
  /** How many times a failed request is retried */
  maxRetries?: Maybe<Scalars['Int']['output']>;
  /** Force prompt caching on or off, or null to follow the preset */
  promptCaching?: Maybe<Scalars['Boolean']['output']>;
  /** Sent as reasoning_effort where the dialect supports it */
  reasoningEffort?: Maybe<Scalars['String']['output']>;
  /** Request timeout in milliseconds */
  timeoutMs?: Maybe<Scalars['Int']['output']>;
  /** Force server-side tool search on or off, or null to follow the preset */
  toolSearch?: Maybe<Scalars['Boolean']['output']>;
};

export type AiSkill = {
  __typename?: 'AISkill';
  /** Date the skill was added */
  createdOn: Scalars['DateTime']['output'];
  /** One line explaining what it does */
  description: Scalars['String']['output'];
  /** Whether the assistant offers it */
  enabled: Scalars['Boolean']['output'];
  /** Skill identifier */
  id: Scalars['ID']['output'];
  /** The instruction dropped into the composer */
  prompt: Scalars['String']['output'];
  /** What the user types after "/" */
  slug: Scalars['String']['output'];
  /** Name shown in the menu */
  title: Scalars['String']['output'];
  /** Date the skill was last changed */
  updatedOn: Scalars['DateTime']['output'];
};

/** Authentication provider available to an organization */
export enum AuthProvider {
  Github = 'GITHUB',
  Google = 'GOOGLE',
  MagicLink = 'MAGIC_LINK',
  Microsoft = 'MICROSOFT',
  Oidc = 'OIDC',
  Saml = 'SAML'
}

export enum BannerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum BannerType {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type CollectionReorderData = {
  __typename?: 'CollectionReorderData';
  /** Team Collection being moved */
  collection: TeamCollection;
  /** Team Collection succeeding the collection being moved in its new position */
  nextCollection?: Maybe<TeamCollection>;
};

export type CreateAiProviderConnectionInput = {
  /** Provider credential. Stored encrypted, never read back */
  apiKey: Scalars['String']['input'];
  /** Endpoint, where the preset needs one */
  baseURL?: InputMaybe<Scalars['String']['input']>;
  /** Model used when the user picks none */
  defaultModel: Scalars['String']['input'];
  /** Whether the assistant may use it */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Make this the instance default */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name the user sees in the model picker */
  label: Scalars['String']['input'];
  /** Models this connection offers */
  models: Array<Scalars['String']['input']>;
  /** Provider preset, e.g. anthropic, openai, azure */
  preset: Scalars['String']['input'];
};

export type CreateAiSkillInput = {
  /** One line explaining what it does */
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The instruction dropped into the composer */
  prompt: Scalars['String']['input'];
  /** What the user types after "/" */
  slug: Scalars['String']['input'];
  /** Name shown in the menu */
  title: Scalars['String']['input'];
};

export type CreateMockServerInput = {
  /** Whether to auto-create a collection for the mock server if collectionID is not provided */
  autoCreateCollection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to auto-create request examples in the collection for the mock server */
  autoCreateRequestExample?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the (team or user) collection to associate with the mock server */
  collectionID?: InputMaybe<Scalars['String']['input']>;
  /** Delay in milliseconds before responding */
  delayInMs?: InputMaybe<Scalars['Float']['input']>;
  /** Whether the mock server is publicly accessible */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the mock server */
  name: Scalars['String']['input'];
  /** ID of the workspace (user or team) to associate with the mock server */
  workspaceID?: InputMaybe<Scalars['String']['input']>;
  /** Type of workspace: USER or TEAM */
  workspaceType: WorkspaceType;
};

export type CreateOrganizationTokenResponse = {
  __typename?: 'CreateOrganizationTokenResponse';
  /** Organization token info */
  info: OrganizationToken;
  /** The organization token, shown only this once */
  token: Scalars['String']['output'];
};

export type CreatePublishedDocsArgs = {
  /** Whether the published document should auto-sync with the source */
  autoSync: Scalars['Boolean']['input'];
  /** ID of the source (personal/team) collection from which to publish */
  collectionID: Scalars['String']['input'];
  /** ID of the environment to associate with the published document */
  environmentID?: InputMaybe<Scalars['String']['input']>;
  /** Metadata associated with the published document */
  metadata: Scalars['String']['input'];
  /** Organization ID to associate with the published document */
  orgID?: InputMaybe<Scalars['String']['input']>;
  /** Title of the published document */
  title: Scalars['String']['input'];
  /** Version of the published document */
  version: Scalars['String']['input'];
  /** ID of the workspace */
  workspaceID: Scalars['String']['input'];
  /** Type of the workspace (e.g., personal, team) */
  workspaceType: WorkspaceType;
};

export type CreateTeamRequestInput = {
  /** JSON string representing the request data */
  request: Scalars['String']['input'];
  /** ID of the team the collection belongs to */
  teamID: Scalars['ID']['input'];
  /** Displayed title of the request */
  title: Scalars['String']['input'];
};

export type DowngradeImpact = {
  __typename?: 'DowngradeImpact';
  /** Organization tokens that will stop working */
  activeTokenCount: Scalars['Int']['output'];
  /** Whether SCIM provisioning is on, and will stop */
  scimEnabled: Scalars['Boolean']['output'];
  /** Members signed in through SSO, who will sign in with the default providers instead */
  ssoMemberCount: Scalars['Int']['output'];
};

export type EnableAndDisableOrgAuthArgs = {
  /** The authentication provider */
  provider: AuthProvider;
  /** Status to apply to the provider */
  status: ServiceStatus;
};

export type InvitedUser = {
  __typename?: 'InvitedUser';
  /** Admin email of the admin who invited the user, NOTE: this value can be updated so may not be accurate */
  adminEmail: Scalars['String']['output'];
  /** Admin Name of the admin who invited the user, NOTE: this value can be updated so may not be accurate */
  adminName?: Maybe<Scalars['String']['output']>;
  /** Admin UID of the admin who invited the user */
  adminUid: Scalars['ID']['output'];
  /** invite ID */
  inviteID: Scalars['ID']['output'];
  /** Date when the user invitation was sent */
  invitedOn: Scalars['DateTime']['output'];
  /** Invitee email */
  inviteeEmail: Scalars['String']['output'];
  /** Org ID */
  orgID: Scalars['ID']['output'];
  /** Organization Name */
  orgName?: Maybe<Scalars['String']['output']>;
};

export type MockServer = {
  __typename?: 'MockServer';
  /** Returns the collection of the mock server */
  collection?: Maybe<MockServerCollection>;
  /** Date and time when the mock server was created */
  createdOn: Scalars['DateTime']['output'];
  /** Returns the creator of the mock server */
  creator?: Maybe<User>;
  /** Delay in milliseconds before responding */
  delayInMs: Scalars['Float']['output'];
  /** ID of the mock server */
  id: Scalars['ID']['output'];
  /** Whether the mock server is active */
  isActive: Scalars['Boolean']['output'];
  /** Whether the mock server is publicly accessible */
  isPublic: Scalars['Boolean']['output'];
  /** Name of the mock server */
  name: Scalars['String']['output'];
  /** Organization ID */
  orgID?: Maybe<Scalars['String']['output']>;
  /** Server URL for the mock server using subdomain pattern (e.g., https://1234.mock.backend-hoppscotch.io) */
  serverUrlDomainBased?: Maybe<Scalars['String']['output']>;
  /** Server URL for the mock server using path pattern (e.g., https://backend.hoppscotch.io/mock/1234) */
  serverUrlPathBased: Scalars['String']['output'];
  /** Subdomain for the mock server (e.g., mock-1234) */
  subdomain: Scalars['String']['output'];
  /** Date and time when the mock server was last updated */
  updatedOn: Scalars['DateTime']['output'];
  /** ID of the workspace (user or team) to associate with the mock server */
  workspaceID?: Maybe<Scalars['String']['output']>;
  /** Type of workspace: USER or TEAM */
  workspaceType: WorkspaceType;
};

export type MockServerCollection = {
  __typename?: 'MockServerCollection';
  /** ID of the collection */
  id: Scalars['ID']['output'];
  /** Title of the collection */
  title: Scalars['String']['output'];
};

export type MockServerLog = {
  __typename?: 'MockServerLog';
  /** Date and time when the request was executed */
  executedAt: Scalars['DateTime']['output'];
  /** ID of the log entry */
  id: Scalars['ID']['output'];
  /** IP address of the requester */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** ID of the mock server */
  mockServerID: Scalars['ID']['output'];
  /** Request body as JSON string */
  requestBody?: Maybe<Scalars['String']['output']>;
  /** Request headers as JSON string */
  requestHeaders: Scalars['String']['output'];
  /** HTTP method of the request */
  requestMethod: Scalars['String']['output'];
  /** Path of the request */
  requestPath: Scalars['String']['output'];
  /** Request query parameters as JSON string */
  requestQuery?: Maybe<Scalars['String']['output']>;
  /** Response body as JSON string */
  responseBody?: Maybe<Scalars['String']['output']>;
  /** Response headers as JSON string */
  responseHeaders: Scalars['String']['output'];
  /** HTTP status code of the response */
  responseStatus: Scalars['Float']['output'];
  /** Response time in milliseconds */
  responseTime: Scalars['Float']['output'];
  /** User agent of the requester */
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept an Organization Invite */
  acceptOrganizationInvitation: OrganizationMember;
  /** Accept an Invitation */
  acceptTeamInvitation: TeamMember;
  /** Create a new organization member. */
  addOrganizationMember: OrganizationMember;
  /**
   * Adds a team member to the team via email
   * @deprecated This is only present for backwards compatibility and will be removed soon use team invitations instead
   */
  addTeamMemberByEmail: TeamMember;
  /** Add a user to a team/workspace with email, org ID and team member role */
  addUserToTeamByAdmin: TeamMember;
  /** Cancel cloud for orgs subscription */
  cancelOrganizationSubscription: Scalars['Boolean']['output'];
  /** Cancel a scheduled tier change; the organization stays on its tier */
  cancelScheduledTierChange: Scalars['Boolean']['output'];
  /** Move the organization to another tier. An upgrade is charged now for the rest of the period, and the tier follows once that is paid. A downgrade is scheduled for the end of the period. */
  changeOrganizationTier: TierChangeResult;
  /** Deletes all variables inside a users global environment */
  clearGlobalEnvironments: UserEnvironment;
  /** Register an AI provider connection */
  createAIProviderConnection: AiProviderConnection;
  /** Add a skill */
  createAISkill: AiSkill;
  /** Create a collection that has a parent collection */
  createChildCollection: TeamCollection;
  /** Create a duplicate of an existing environment */
  createDuplicateEnvironment: TeamEnvironment;
  /** Creates a new child GraphQL user collection */
  createGQLChildUserCollection: UserCollection;
  /** Creates root GraphQL user collection (no parent user collection) */
  createGQLRootUserCollection: UserCollection;
  /** Create a new user GraphQL request */
  createGQLUserRequest: UserRequest;
  /** Create a new mock server */
  createMockServer: MockServer;
  /** Create a new banner for an organization */
  createOrganizationBanner: OrganizationBanner;
  /** Create an organization token */
  createOrganizationToken: CreateOrganizationTokenResponse;
  /** Create a new published document */
  createPublishedDoc: PublishedDocs;
  /** Creates a new child REST user collection */
  createRESTChildUserCollection: UserCollection;
  /** Creates root REST user collection (no parent user collection) */
  createRESTRootUserCollection: UserCollection;
  /** Create a new user REST request */
  createRESTUserRequest: UserRequest;
  /** Create a request in the given collection. */
  createRequestInCollection: TeamRequest;
  /** Creates a collection at the root of the team hierarchy (no parent collection) */
  createRootCollection: TeamCollection;
  /** Create a shortcode for the given request. */
  createShortcode: Shortcode;
  /** Creates a team owned by the executing user */
  createTeam: Team;
  /** Creates an organization team by providing user UID to make OWNER */
  createTeamByAdmin: Team;
  /** Create a new Team Environment for given Team ID */
  createTeamEnvironment: TeamEnvironment;
  /** Creates a Team Invitation */
  createTeamInvitation: TeamInvitation;
  /** Create a new personal user environment for given user uid */
  createUserEnvironment: UserEnvironment;
  /** Create a new global user environment for given user uid */
  createUserGlobalEnvironment: UserEnvironment;
  /** Adds a new REST/GQL request to user history */
  createUserHistory: UserHistory;
  /** Creates a new user setting */
  createUserSettings: UserSettings;
  /** Deactivate an organization member */
  deactivateOrganizationMember: Scalars['Boolean']['output'];
  /** Remove an AI provider connection */
  deleteAIProviderConnection: Scalars['Boolean']['output'];
  /** Remove a skill */
  deleteAISkill: Scalars['Boolean']['output'];
  /** Deletes all history for a user */
  deleteAllUserHistory: UserHistoryDeletedManyData;
  /** Delete all variables from a Team Environment */
  deleteAllVariablesFromTeamEnvironment: TeamEnvironment;
  /** Delete a collection */
  deleteCollection: Scalars['Boolean']['output'];
  /** Delete a mock server */
  deleteMockServer: Scalars['Boolean']['output'];
  /** Delete a mock server log by log ID */
  deleteMockServerLog: Scalars['Boolean']['output'];
  /** Delete a published document by ID */
  deletePublishedDoc: Scalars['Boolean']['output'];
  /** Delete a request with the given ID */
  deleteRequest: Scalars['Boolean']['output'];
  /** Deletes the team */
  deleteTeam: Scalars['Boolean']['output'];
  /** Deletes an organization team by teamID */
  deleteTeamByAdmin: Scalars['Boolean']['output'];
  /** Delete a Team Environment for given Team ID */
  deleteTeamEnvironment: Scalars['Boolean']['output'];
  /** Delete an user account */
  deleteUser: Scalars['Boolean']['output'];
  /** Delete a user collection */
  deleteUserCollection: Scalars['Boolean']['output'];
  /** Deletes a users personal environment */
  deleteUserEnvironment: Scalars['Boolean']['output'];
  /** Deletes all of users personal environments */
  deleteUserEnvironments: Scalars['Float']['output'];
  /** Delete a user request */
  deleteUserRequest: Scalars['Boolean']['output'];
  /** Demote organization members who are admins */
  demoteOrganizationMembersAsAdmin: Scalars['Boolean']['output'];
  /** Duplicate a Team Collection */
  duplicateTeamCollection: Scalars['Boolean']['output'];
  /** Duplicate a User Collection */
  duplicateUserCollection: UserCollectionExportJsonData;
  /** Enable or disable login methods of an organization */
  enableAndDisableOrganizationAuth: Array<OrgAuthProviderStatus>;
  /** Import collection from user firestore */
  importCollectionFromUserFirestore: TeamCollection;
  /** Import collections from JSON string to the specified Team */
  importCollectionsFromJSON: Scalars['Boolean']['output'];
  /** Import collections from JSON string to the specified Team */
  importUserCollectionsFromJSON: UserCollectionExportJsonData;
  /** Initialize organization purchase flow. */
  initiateOrganizationPurchase: Scalars['String']['output'];
  /** Invite a user to the infra using email */
  inviteNewUser: InvitedUser;
  /** Leaves a team the executing user is a part of */
  leaveTeam: Scalars['Boolean']['output'];
  /** Make an organization member admin */
  makeOrganizationMemberAnAdmin: OrganizationMember;
  /** Make organization members admin */
  makeOrganizationMembersAdmin: Scalars['Boolean']['output'];
  /** Move a collection into a new parent collection or the root of the team */
  moveCollection: TeamCollection;
  /** Move a request to the given collection */
  moveRequest: TeamRequest;
  /** Move user collection into new parent or root */
  moveUserCollection: UserCollection;
  /** Move and re-order of a user request within same or across collection */
  moveUserRequest: UserRequest;
  /** Remove a team member from an org team/workspace */
  removeMemberFromTeamByAdmin: Scalars['Boolean']['output'];
  /** Remove a member from an organization. */
  removeOrganizationMember: OrganizationMember;
  /** Removes a REST/GQL request from user history */
  removeRequestFromHistory: UserHistory;
  /** Removes the team member from the team */
  removeTeamMember: Scalars['Boolean']['output'];
  /**
   * Rename a collection
   * @deprecated Deprecated use `updateTeamCollection` mutation instead
   */
  renameCollection: TeamCollection;
  /** Renames a team */
  renameTeam: Team;
  /** Rename an organization team/workspace by teamID */
  renameTeamByAdmin: Team;
  /** Replace existing collections of a specific team with collections in JSON string */
  replaceCollectionsWithJSON: Scalars['Boolean']['output'];
  /** Remove an organization member as admin */
  revokeOrganizationMemberAdminAccess: OrganizationMember;
  /** Revoke organization member invites by invitee emails */
  revokeOrganizationMemberInvitationsByAdmin: Scalars['Boolean']['output'];
  /** Revokes an invitation and deletes it */
  revokeOrganizationTeamInviteByAdmin: Scalars['Boolean']['output'];
  /** Revoke an organization token */
  revokeOrganizationToken: Scalars['Boolean']['output'];
  /** Revoke a user generated shortcode */
  revokeShortcode: Scalars['Boolean']['output'];
  /** Revokes an invitation and deletes it */
  revokeTeamInvitation: Scalars['Boolean']['output'];
  /** Sort team collections */
  sortTeamCollections: Scalars['Boolean']['output'];
  /** Sort user collections */
  sortUserCollections: Scalars['Boolean']['output'];
  /** Send a live probe to each model and report what came back */
  testAIProviderConnection: Array<AiProviderTestResult>;
  /** Turn domain whitelisting on or off for an organization */
  toggleDomainWhitelisting: Scalars['Boolean']['output'];
  /** Stars/Unstars a REST/GQL request in user history */
  toggleHistoryStarStatus: UserHistory;
  /** Change an AI provider connection. Omit apiKey to keep it */
  updateAIProviderConnection: AiProviderConnection;
  /** Change the org-wide assistant settings */
  updateAISettings: AiSettings;
  /** Change a skill */
  updateAISkill: AiSkill;
  /** Update the order of collections */
  updateCollectionOrder: Scalars['Boolean']['output'];
  /** Update a user generated Shortcode */
  updateEmbedProperties: Shortcode;
  /** Update a user GraphQL request */
  updateGQLUserRequest: UserRequest;
  /** Update the order of requests in the lookup table */
  updateLookUpRequestOrder: Scalars['Boolean']['output'];
  /** Update a mock server */
  updateMockServer: MockServer;
  /** Update an existing banner for an organization */
  updateOrganizationBanner: OrganizationBanner;
  /** Update organization billing cycle. */
  updateOrganizationBillingCycle: Scalars['Boolean']['output'];
  /** Update the configuration of an organization */
  updateOrganizationConfigs: Array<OrgConfig>;
  /** Update organization seats. */
  updateOrganizationSeats: Scalars['Boolean']['output'];
  /** Update role of a team member in an org team/workspace */
  updateOrganizationTeamMemberRoleByAdmin: TeamMember;
  /** Update an existing published document */
  updatePublishedDoc: PublishedDocs;
  /** Update a user REST request */
  updateRESTUserRequest: UserRequest;
  /** Update a request with the given ID */
  updateRequest: TeamRequest;
  /** Update Team Collection details */
  updateTeamCollection: TeamCollection;
  /** Add/Edit a single environment variable or variables to a Team Environment */
  updateTeamEnvironment: TeamEnvironment;
  /** Update role of a team member the executing user owns */
  updateTeamMemberRole: TeamMember;
  /** Update a UserCollection */
  updateUserCollection: UserCollection;
  /** Update the order of UserCollections inside parent collection or in root */
  updateUserCollectionOrder: Scalars['Boolean']['output'];
  /** Updates a users personal environment */
  updateUserEnvironment: UserEnvironment;
  /** Updates a users global environment */
  updateUserGlobalEnvironment: UserEnvironment;
  /** Update user setting for a given user */
  updateUserSettings: UserSettings;
  /** Replace the email domains whose people may join the organization without an invite. Returns the list as stored */
  updateWhitelistedDomains: Array<Scalars['String']['output']>;
};


export type MutationAcceptOrganizationInvitationArgs = {
  orgInviteID: Scalars['ID']['input'];
};


export type MutationAcceptTeamInvitationArgs = {
  inviteID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddOrganizationMemberArgs = {
  orgID: Scalars['ID']['input'];
  userUID: Scalars['ID']['input'];
};


export type MutationAddTeamMemberByEmailArgs = {
  teamID: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
  userRole: TeamMemberRole;
};


export type MutationAddUserToTeamByAdminArgs = {
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userEmail: Scalars['ID']['input'];
  userRole: TeamMemberRole;
};


export type MutationCancelOrganizationSubscriptionArgs = {
  orgID: Scalars['ID']['input'];
};


export type MutationCancelScheduledTierChangeArgs = {
  orgID: Scalars['ID']['input'];
};


export type MutationChangeOrganizationTierArgs = {
  orgID: Scalars['ID']['input'];
  targetTier: OrganizationTier;
};


export type MutationClearGlobalEnvironmentsArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateAiProviderConnectionArgs = {
  input: CreateAiProviderConnectionInput;
  orgID: Scalars['ID']['input'];
};


export type MutationCreateAiSkillArgs = {
  input: CreateAiSkillInput;
  orgID: Scalars['ID']['input'];
};


export type MutationCreateChildCollectionArgs = {
  childTitle: Scalars['String']['input'];
  collectionID: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateDuplicateEnvironmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateGqlChildUserCollectionArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  parentUserCollectionID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateGqlRootUserCollectionArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};


export type MutationCreateGqlUserRequestArgs = {
  collectionID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  request: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateMockServerArgs = {
  input: CreateMockServerInput;
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOrganizationBannerArgs = {
  message: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
  type: BannerType;
};


export type MutationCreateOrganizationTokenArgs = {
  expiryInDays?: InputMaybe<Scalars['Int']['input']>;
  label: Scalars['String']['input'];
};


export type MutationCreatePublishedDocArgs = {
  args: CreatePublishedDocsArgs;
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateRestChildUserCollectionArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  parentUserCollectionID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateRestRootUserCollectionArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};


export type MutationCreateRestUserRequestArgs = {
  collectionID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  request: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateRequestInCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  data: CreateTeamRequestInput;
};


export type MutationCreateRootCollectionArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  teamID: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateShortcodeArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  request: Scalars['String']['input'];
};


export type MutationCreateTeamArgs = {
  name: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateTeamByAdminArgs = {
  name: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationCreateTeamEnvironmentArgs = {
  name: Scalars['String']['input'];
  teamID: Scalars['ID']['input'];
  variables: Scalars['String']['input'];
};


export type MutationCreateTeamInvitationArgs = {
  inviteeEmail: Scalars['String']['input'];
  inviteeRole: TeamMemberRole;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationCreateUserEnvironmentArgs = {
  name: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  variables: Scalars['String']['input'];
};


export type MutationCreateUserGlobalEnvironmentArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  variables: Scalars['String']['input'];
};


export type MutationCreateUserHistoryArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  reqData: Scalars['String']['input'];
  reqType: ReqType;
  resMetadata: Scalars['String']['input'];
};


export type MutationCreateUserSettingsArgs = {
  orgID?: InputMaybe<Scalars['String']['input']>;
  properties: Scalars['String']['input'];
};


export type MutationDeactivateOrganizationMemberArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type MutationDeleteAiProviderConnectionArgs = {
  id: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
};


export type MutationDeleteAiSkillArgs = {
  id: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
};


export type MutationDeleteAllUserHistoryArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  reqType: ReqType;
};


export type MutationDeleteAllVariablesFromTeamEnvironmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCollectionArgs = {
  collectionID: Scalars['ID']['input'];
};


export type MutationDeleteMockServerArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteMockServerLogArgs = {
  logID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeletePublishedDocArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteRequestArgs = {
  requestID: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  teamID: Scalars['ID']['input'];
};


export type MutationDeleteTeamByAdminArgs = {
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
};


export type MutationDeleteTeamEnvironmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserCollectionArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  userCollectionID: Scalars['ID']['input'];
};


export type MutationDeleteUserEnvironmentArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteUserEnvironmentsArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteUserRequestArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDemoteOrganizationMembersAsAdminArgs = {
  orgID: Scalars['ID']['input'];
  userUIDs: Array<Scalars['ID']['input']>;
};


export type MutationDuplicateTeamCollectionArgs = {
  collectionID: Scalars['String']['input'];
};


export type MutationDuplicateUserCollectionArgs = {
  collectionID: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  reqType: ReqType;
};


export type MutationEnableAndDisableOrganizationAuthArgs = {
  providerInfo: Array<EnableAndDisableOrgAuthArgs>;
};


export type MutationImportCollectionFromUserFirestoreArgs = {
  fbCollectionPath: Scalars['String']['input'];
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationImportCollectionsFromJsonArgs = {
  jsonString: Scalars['String']['input'];
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationImportUserCollectionsFromJsonArgs = {
  jsonString: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  reqType: ReqType;
};


export type MutationInitiateOrganizationPurchaseArgs = {
  organizationBillingCycle: OrganizationBillingCycle;
  organizationDomain: Scalars['String']['input'];
  organizationMetadata?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
  organizationSeats: Scalars['Float']['input'];
  organizationTier?: InputMaybe<OrganizationTier>;
};


export type MutationInviteNewUserArgs = {
  inviteeEmail: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
};


export type MutationLeaveTeamArgs = {
  teamID: Scalars['ID']['input'];
};


export type MutationMakeOrganizationMemberAnAdminArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type MutationMakeOrganizationMembersAdminArgs = {
  orgID: Scalars['ID']['input'];
  userUIDs: Array<Scalars['ID']['input']>;
};


export type MutationMoveCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMoveRequestArgs = {
  destCollID: Scalars['ID']['input'];
  requestID: Scalars['ID']['input'];
};


export type MutationMoveUserCollectionArgs = {
  destCollectionID?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  userCollectionID: Scalars['ID']['input'];
};


export type MutationMoveUserRequestArgs = {
  destinationCollectionID: Scalars['ID']['input'];
  nextRequestID?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  requestID: Scalars['ID']['input'];
  sourceCollectionID: Scalars['ID']['input'];
};


export type MutationRemoveMemberFromTeamByAdminArgs = {
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationRemoveOrganizationMemberArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type MutationRemoveRequestFromHistoryArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveTeamMemberArgs = {
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationRenameCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  newTitle: Scalars['String']['input'];
};


export type MutationRenameTeamArgs = {
  newName: Scalars['String']['input'];
  teamID: Scalars['ID']['input'];
};


export type MutationRenameTeamByAdminArgs = {
  newTeamName: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
};


export type MutationReplaceCollectionsWithJsonArgs = {
  jsonString: Scalars['String']['input'];
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationRevokeOrganizationMemberAdminAccessArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type MutationRevokeOrganizationMemberInvitationsByAdminArgs = {
  inviteeEmails: Array<Scalars['String']['input']>;
  orgID: Scalars['ID']['input'];
};


export type MutationRevokeOrganizationTeamInviteByAdminArgs = {
  inviteID: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
};


export type MutationRevokeOrganizationTokenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevokeShortcodeArgs = {
  code: Scalars['ID']['input'];
};


export type MutationRevokeTeamInvitationArgs = {
  inviteID: Scalars['ID']['input'];
};


export type MutationSortTeamCollectionsArgs = {
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  sortOption: SortOptions;
  teamID: Scalars['ID']['input'];
};


export type MutationSortUserCollectionsArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  parentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  sortOption: SortOptions;
};


export type MutationTestAiProviderConnectionArgs = {
  input: TestAiProviderConnectionInput;
  orgID: Scalars['ID']['input'];
};


export type MutationToggleDomainWhitelistingArgs = {
  status: ServiceStatus;
};


export type MutationToggleHistoryStarStatusArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateAiProviderConnectionArgs = {
  input: UpdateAiProviderConnectionInput;
  orgID: Scalars['ID']['input'];
};


export type MutationUpdateAiSettingsArgs = {
  input: UpdateAiSettingsInput;
  orgID: Scalars['ID']['input'];
};


export type MutationUpdateAiSkillArgs = {
  input: UpdateAiSkillInput;
  orgID: Scalars['ID']['input'];
};


export type MutationUpdateCollectionOrderArgs = {
  collectionID: Scalars['ID']['input'];
  destCollID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateEmbedPropertiesArgs = {
  code: Scalars['ID']['input'];
  properties: Scalars['String']['input'];
};


export type MutationUpdateGqlUserRequestArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLookUpRequestOrderArgs = {
  collectionID: Scalars['ID']['input'];
  nextRequestID?: InputMaybe<Scalars['ID']['input']>;
  requestID: Scalars['ID']['input'];
};


export type MutationUpdateMockServerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMockServerInput;
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateOrganizationBannerArgs = {
  id: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
  status: BannerStatus;
  type: BannerType;
};


export type MutationUpdateOrganizationBillingCycleArgs = {
  orgBillingCycle: OrganizationBillingCycle;
  orgID: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationConfigsArgs = {
  configs: Array<OrgConfigArgs>;
};


export type MutationUpdateOrganizationSeatsArgs = {
  orgID: Scalars['ID']['input'];
  seats: Scalars['Float']['input'];
};


export type MutationUpdateOrganizationTeamMemberRoleByAdminArgs = {
  newRole: TeamMemberRole;
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationUpdatePublishedDocArgs = {
  args: UpdatePublishedDocsArgs;
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateRestUserRequestArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  request?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRequestArgs = {
  data: UpdateTeamRequestInput;
  requestID: Scalars['ID']['input'];
};


export type MutationUpdateTeamCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
  newTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTeamEnvironmentArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  variables: Scalars['String']['input'];
};


export type MutationUpdateTeamMemberRoleArgs = {
  newRole: TeamMemberRole;
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
};


export type MutationUpdateUserCollectionArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  newTitle?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  userCollectionID: Scalars['ID']['input'];
};


export type MutationUpdateUserCollectionOrderArgs = {
  collectionID: Scalars['ID']['input'];
  nextCollectionID?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateUserEnvironmentArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  variables: Scalars['String']['input'];
};


export type MutationUpdateUserGlobalEnvironmentArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  variables: Scalars['String']['input'];
};


export type MutationUpdateUserSettingsArgs = {
  orgID?: InputMaybe<Scalars['String']['input']>;
  properties: Scalars['String']['input'];
};


export type MutationUpdateWhitelistedDomainsArgs = {
  domains: Array<Scalars['String']['input']>;
};

export type OrgAuthProviderStatus = {
  __typename?: 'OrgAuthProviderStatus';
  /** The authentication provider */
  provider: AuthProvider;
  /** Whether the provider is enabled for the organization */
  status: ServiceStatus;
};

export type OrgConfig = {
  __typename?: 'OrgConfig';
  /** Organization config key */
  name: OrgConfigEnum;
  /** Organization config value, always a string */
  value: Scalars['String']['output'];
};

export type OrgConfigArgs = {
  /** Organization config key */
  name: OrgConfigEnum;
  /** Organization config value, always a string */
  value: Scalars['String']['input'];
};

/** Organization configuration key */
export enum OrgConfigEnum {
  AllowDomainWhitelisting = 'ALLOW_DOMAIN_WHITELISTING',
  GithubClientId = 'GITHUB_CLIENT_ID',
  GithubClientSecret = 'GITHUB_CLIENT_SECRET',
  GithubClientSecretSet = 'GITHUB_CLIENT_SECRET_SET',
  GoogleClientId = 'GOOGLE_CLIENT_ID',
  GoogleClientSecret = 'GOOGLE_CLIENT_SECRET',
  GoogleClientSecretSet = 'GOOGLE_CLIENT_SECRET_SET',
  IsScimEnabled = 'IS_SCIM_ENABLED',
  MicrosoftClientId = 'MICROSOFT_CLIENT_ID',
  MicrosoftClientSecret = 'MICROSOFT_CLIENT_SECRET',
  MicrosoftClientSecretSet = 'MICROSOFT_CLIENT_SECRET_SET',
  OidcClientId = 'OIDC_CLIENT_ID',
  OidcClientSecret = 'OIDC_CLIENT_SECRET',
  OidcDisplayName = 'OIDC_DISPLAY_NAME',
  OidcIssuer = 'OIDC_ISSUER',
  OidcProviderId = 'OIDC_PROVIDER_ID',
  OidcUseCodeFlow = 'OIDC_USE_CODE_FLOW',
  OnboardingCompleted = 'ONBOARDING_COMPLETED',
  SamlCallbackUrl = 'SAML_CALLBACK_URL',
  SamlCertificates = 'SAML_CERTIFICATES',
  SamlDisplayName = 'SAML_DISPLAY_NAME',
  SamlIdpEntityId = 'SAML_IDP_ENTITY_ID',
  SamlProviderId = 'SAML_PROVIDER_ID',
  SamlRpEntityId = 'SAML_RP_ENTITY_ID',
  SamlSsoUrl = 'SAML_SSO_URL',
  WhitelistedDomains = 'WHITELISTED_DOMAINS'
}

export type Organization = {
  __typename?: 'Organization';
  /** The organization billing address */
  billingAddress?: Maybe<OrganizationBillingAddress>;
  /** The billing cycle opted for */
  billingCycle?: Maybe<OrganizationBillingCycle>;
  /** The organization billing email */
  billingEmail?: Maybe<Scalars['String']['output']>;
  /** Stripe checkout session URL */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the organization was created */
  createdOn: Scalars['DateTime']['output'];
  /** The current organization billing end date */
  nextBillingDate?: Maybe<Scalars['Float']['output']>;
  /** The domain of the organization */
  orgDomain: Scalars['String']['output'];
  /** The organization ID */
  orgID: Scalars['ID']['output'];
  /** URL to the organization logo/profile image */
  orgLogo?: Maybe<Scalars['String']['output']>;
  /** JSON string representing the metadata of the organization */
  orgMetadata?: Maybe<Scalars['String']['output']>;
  /** The name of the organization */
  orgName: Scalars['String']['output'];
  /** The organization subscription status */
  orgStatus: OrganizationStatus;
  /** The number of seats available in the organization */
  seats: Scalars['Float']['output'];
  /** The subscription tier the organization is on */
  tier: OrganizationTier;
};

export type OrganizationBanner = {
  __typename?: 'OrganizationBanner';
  /** Timestamp of when the banner was created */
  createdOn: Scalars['DateTime']['output'];
  /** ID of the banner */
  id: Scalars['ID']['output'];
  /** Message of the banner */
  message: Scalars['String']['output'];
  /** ID of the organization the banner belongs to */
  orgID: Scalars['ID']['output'];
  /** Status of the banner */
  status: BannerStatus;
  /** Type of the banner */
  type: BannerType;
};

export type OrganizationBillingAddress = {
  __typename?: 'OrganizationBillingAddress';
  /** The city of the billing address */
  city?: Maybe<Scalars['String']['output']>;
  /** The country of the billing address */
  country?: Maybe<Scalars['String']['output']>;
  /** The first line of the billing address */
  line1?: Maybe<Scalars['String']['output']>;
  /** The second line of the billing address */
  line2?: Maybe<Scalars['String']['output']>;
  /** The postal code of the billing address */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** The state of the billing address */
  state?: Maybe<Scalars['String']['output']>;
};

export enum OrganizationBillingCycle {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  /** Timestamp of when the user was created */
  createdOn: Scalars['DateTime']['output'];
  /** Organization member ID */
  id: Scalars['ID']['output'];
  /** Timestamp of when the member was invited */
  invitedOn: Scalars['DateTime']['output'];
  /** The UID of the user who invited this member (doesn`t apply to the first member) */
  inviteeUserUID?: Maybe<Scalars['ID']['output']>;
  /** Indicates if the member is an admin */
  isAdmin: Scalars['Boolean']['output'];
  /** Timestamp of when the member last signed in, null if they never have */
  lastActiveOn?: Maybe<Scalars['DateTime']['output']>;
  /** Active status of the member in the given organization */
  membershipStatus: OrganizationMembershipStatus;
  /** The organization ID the member belongs to */
  orgID: Scalars['String']['output'];
  /** URL to the profile photo of the user (if fetched) */
  photoURL?: Maybe<Scalars['String']['output']>;
  /** The user email of the organization member (if fetched) */
  userEmail?: Maybe<Scalars['String']['output']>;
  /** The username of the organization member (if fetched) */
  userName?: Maybe<Scalars['String']['output']>;
  /** The user UID of the organization member */
  userUID: Scalars['String']['output'];
};

export enum OrganizationMembershipStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type OrganizationScimSettings = {
  __typename?: 'OrganizationScimSettings';
  /** The SCIM base URL to configure in the identity provider, null if the backend's public URL is not configured */
  baseUrl?: Maybe<Scalars['String']['output']>;
  /** Whether SCIM provisioning is on */
  enabled: Scalars['Boolean']['output'];
};

export enum OrganizationStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Inactive = 'INACTIVE'
}

export type OrganizationSummary = {
  __typename?: 'OrganizationSummary';
  /** The organization ID */
  orgID: Scalars['ID']['output'];
  /** The subscription tier the organization is on */
  tier: OrganizationTier;
};

export enum OrganizationTier {
  Business = 'BUSINESS',
  Enterprise = 'ENTERPRISE',
  Free = 'FREE'
}

export type OrganizationToken = {
  __typename?: 'OrganizationToken';
  /** Date when the organization token was created */
  createdOn: Scalars['DateTime']['output'];
  /** Date when the organization token expires */
  expiresOn?: Maybe<Scalars['DateTime']['output']>;
  /** ID of the organization token */
  id: Scalars['ID']['output'];
  /** Label of the organization token */
  label: Scalars['String']['output'];
  /** Date when the organization token was last used */
  lastUsedOn: Scalars['DateTime']['output'];
};

export type PendingTierChange = {
  __typename?: 'PendingTierChange';
  /** When the change takes effect */
  effectiveAt: Scalars['DateTime']['output'];
  /** The tier being moved to */
  tier: OrganizationTier;
};

export type PublishedDocs = {
  __typename?: 'PublishedDocs';
  /** Indicates if the documentation is set to auto-sync */
  autoSync: Scalars['Boolean']['output'];
  /** Returns the collection of the published document */
  collection: PublishedDocsCollection;
  /** Timestamp when the documentation was created */
  createdOn: Scalars['DateTime']['output'];
  /** Returns the creator of the published document */
  creator: User;
  /** Document tree structure associated with the documentation */
  documentTree: Scalars['String']['output'];
  /** Name of the environment associated with the documentation */
  environmentName?: Maybe<Scalars['String']['output']>;
  /** Stringified JSON of the environment variables associated with the documentation */
  environmentVariables?: Maybe<Scalars['String']['output']>;
  /** ID of the published API documentation */
  id: Scalars['ID']['output'];
  /** Metadata of the documentation */
  metadata: Scalars['String']['output'];
  /** Organization ID associated with the published documentation */
  orgID?: Maybe<Scalars['String']['output']>;
  /** Slug of the published API documentation (unique with version) */
  slug: Scalars['ID']['output'];
  /** Title of the published API documentation */
  title: Scalars['String']['output'];
  /** Timestamp when the documentation was last updated */
  updatedOn: Scalars['DateTime']['output'];
  /** URL where the published API documentation can be accessed */
  url: Scalars['String']['output'];
  /** Version of the published API documentation */
  version: Scalars['String']['output'];
  /** All available versions of this published documentation */
  versions?: Maybe<Array<PublishedDocsVersion>>;
  /** Workspace ID (of team/user ID) associated with the published documentation */
  workspaceID?: Maybe<Scalars['String']['output']>;
  /** Type of workspace associated with the published documentation */
  workspaceType: Scalars['String']['output'];
};

export type PublishedDocsCollection = {
  __typename?: 'PublishedDocsCollection';
  /** ID of the collection */
  id: Scalars['ID']['output'];
  /** Title of the collection */
  title: Scalars['String']['output'];
};

export type PublishedDocsVersion = {
  __typename?: 'PublishedDocsVersion';
  /** Indicates if the documentation is set to auto-sync */
  autoSync: Scalars['Boolean']['output'];
  /** ID of the published document version */
  id: Scalars['ID']['output'];
  /** Slug of the published document */
  slug: Scalars['String']['output'];
  /** Title of the API documentation */
  title: Scalars['String']['output'];
  /** URL where the published API documentation can be accessed */
  url: Scalars['String']['output'];
  /** Version string */
  version: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Whether the AI assistant is enabled for this org */
  aiChatEnabled: Scalars['Boolean']['output'];
  /** Models the signed-in user may choose between in the chat */
  aiChatModelOptions: Array<AiChatModelOption>;
  /** Skills the assistant offers in the composer */
  aiChatSkills: Array<AiSkill>;
  /** Get the AI provider connections registered for this org */
  aiProviderConnections: Array<AiProviderConnection>;
  /** Provider presets this build supports */
  aiProviderPresets: Array<AiProviderPreset>;
  /** Org-wide assistant settings */
  aiSettings: AiSettings;
  /** Every skill, for managing them */
  aiSkills: Array<AiSkill>;
  /** Get a collection with the given ID or null (if not exists) */
  collection?: Maybe<TeamCollection>;
  /**
   * Returns the collections of the team
   * @deprecated Deprecated because of no practical use. Use `rootCollectionsOfTeam` instead.
   */
  collectionsOfTeam: Array<TeamCollection>;
  /** Returns a JSON string of all the contents of a Team Collection */
  exportCollectionToJSON: Scalars['String']['output'];
  /** Returns the JSON string giving the collections and their contents of the team */
  exportCollectionsToJSON: Scalars['String']['output'];
  /** Returns a JSON string of all the contents of a User Collection */
  exportUserCollectionToJSON: Scalars['String']['output'];
  /** Returns the JSON string giving the collections and their contents of a user */
  exportUserCollectionsToJSON: UserCollectionExportJsonData;
  /** Returns an `InvitedUser` with additional org info based on a valid organization invite id */
  getOrgInviteDetails: InvitedUser;
  /** Returns the invited members details in an organization */
  invitedOrganizationMembers: Array<InvitedUser>;
  /** Gives details of the user executing this query (pass Authorization 'Bearer' header) */
  me: User;
  /** Get a specific mock server by ID */
  mockServer: MockServer;
  /** Get logs for a specific mock server with pagination, sorted by execution time (most recent first) */
  mockServerLogs: Array<MockServerLog>;
  /** Get all mock servers for the authenticated user */
  myMockServers: Array<MockServer>;
  /** Returns all organizations that the authenticated user is an active member of (excludes pending/invited memberships) */
  myOrganizations: Array<UserOrganizationMembership>;
  /** List all shortcodes the current user has generated */
  myShortcodes: Array<Shortcode>;
  /** List of teams that the executing user belongs to. */
  myTeams: Array<Team>;
  /** Returns the organization info */
  organization: Organization;
  /** Get the last active banner for an organization */
  organizationActiveBanner?: Maybe<OrganizationBanner>;
  /** Fetch the login methods of an organization */
  organizationAllowedAuthProviders: Array<OrgAuthProviderStatus>;
  /**
   * Returns the organization ID by resolving org domain
   * @deprecated Use organizationByDomainV2, which also returns the tier
   */
  organizationByDomain: Scalars['String']['output'];
  /** Returns the organization behind a subdomain */
  organizationByDomainV2: OrganizationSummary;
  /** Fetch the configuration of an organization */
  organizationConfigs: Array<OrgConfig>;
  /** Returns the organization member details */
  organizationMember: OrganizationMember;
  /** Returns the organization members */
  organizationMembers: Array<OrganizationMember>;
  /** Returns member count in an organization */
  organizationMembersCount: Scalars['Float']['output'];
  /** The tier change the organization has scheduled, if any */
  organizationPendingTierChange?: Maybe<PendingTierChange>;
  /** The organization's SCIM provisioning settings */
  organizationScimSettings: OrganizationScimSettings;
  /** Returns team collections count in an organization */
  organizationTeamCollectionsCount: Scalars['Float']['output'];
  /** Returns org team/workspace detail */
  organizationTeamInfo: Team;
  /** Returns team requests count in an organization */
  organizationTeamRequestsCount: Scalars['Float']['output'];
  /** Returns the teams/workspaces in an organization */
  organizationTeams: Array<Team>;
  /** Returns teams count in an organization */
  organizationTeamsCount: Scalars['Float']['output'];
  /** List the organization's tokens */
  organizationTokens: Array<OrganizationToken>;
  /** Get the working banner (last banner whether active or inactive) for the admin dashboard */
  organizationWorkingBanner?: Maybe<OrganizationBanner>;
  /** What moving the organization to another tier would cost */
  previewOrganizationTierChange: TierChangePreview;
  /** Get a published document by ID */
  publishedDoc: PublishedDocs;
  /** Gives a request with the given ID or null (if not exists) */
  request?: Maybe<TeamRequest>;
  /** Gives a list of requests in the collection */
  requestsInCollection: Array<TeamRequest>;
  /** Returns the collections of the team */
  rootCollectionsOfTeam: Array<TeamCollection>;
  /** Get the root GraphQL user collections for a user */
  rootGQLUserCollections: Array<UserCollection>;
  /** Get the root REST user collections for a user */
  rootRESTUserCollections: Array<UserCollection>;
  /** Search the team for a specific request with title */
  searchForRequest: Array<TeamRequest>;
  /** Resolves and returns a shortcode data */
  shortcode?: Maybe<Shortcode>;
  /** Returns the detail of the team with the given ID */
  team?: Maybe<Team>;
  /** Gets the Team Invitation with the given ID, or null if not exists */
  teamInvitation: TeamInvitation;
  /** Get all mock servers for a specific team */
  teamMockServers: Array<MockServer>;
  /** Get all published documents for a team collection */
  teamPublishedDocsList: Array<PublishedDocs>;
  /**
   * Finds a user by their UID or null if no match
   * @deprecated Deprecated due to privacy concerns. Try to get the user from the context-relevant queries
   */
  user?: Maybe<User>;
  /** Get user collection with ID */
  userCollection: UserCollection;
  /** Get GraphQL user requests */
  userGQLRequests: Array<UserRequest>;
  /** Get all published documents of a user */
  userPublishedDocsList: Array<PublishedDocs>;
  /** Get REST user requests */
  userRESTRequests: Array<UserRequest>;
  /** Get a user request by ID */
  userRequest: UserRequest;
};


export type QueryAiProviderConnectionsArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryAiProviderPresetsArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryAiSettingsArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryAiSkillsArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryCollectionArgs = {
  collectionID: Scalars['ID']['input'];
};


export type QueryCollectionsOfTeamArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type QueryExportCollectionToJsonArgs = {
  collectionID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
};


export type QueryExportCollectionsToJsonArgs = {
  teamID: Scalars['ID']['input'];
};


export type QueryExportUserCollectionToJsonArgs = {
  collectionID: Scalars['ID']['input'];
  collectionType: ReqType;
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExportUserCollectionsToJsonArgs = {
  collectionID?: InputMaybe<Scalars['ID']['input']>;
  collectionType: ReqType;
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetOrgInviteDetailsArgs = {
  inviteID: Scalars['ID']['input'];
};


export type QueryInvitedOrganizationMembersArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryMockServerArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMockServerLogsArgs = {
  mockServerID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyMockServersArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyShortcodesArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyTeamsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrganizationArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationActiveBannerArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationByDomainArgs = {
  orgDomain: Scalars['ID']['input'];
};


export type QueryOrganizationByDomainV2Args = {
  orgDomain: Scalars['ID']['input'];
};


export type QueryOrganizationConfigsArgs = {
  names?: InputMaybe<Array<OrgConfigEnum>>;
};


export type QueryOrganizationMemberArgs = {
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
};


export type QueryOrganizationMembersArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationMembersCountArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationPendingTierChangeArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamCollectionsCountArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamInfoArgs = {
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamRequestsCountArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamsArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTeamsCountArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryOrganizationTokensArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationWorkingBannerArgs = {
  orgID: Scalars['ID']['input'];
};


export type QueryPreviewOrganizationTierChangeArgs = {
  orgID: Scalars['ID']['input'];
  targetTier: OrganizationTier;
};


export type QueryPublishedDocArgs = {
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRequestArgs = {
  requestID: Scalars['ID']['input'];
};


export type QueryRequestsInCollectionArgs = {
  collectionID: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRootCollectionsOfTeamArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type QueryRootGqlUserCollectionsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRootRestUserCollectionsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchForRequestArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  searchTerm: Scalars['String']['input'];
  teamID: Scalars['ID']['input'];
};


export type QueryShortcodeArgs = {
  code: Scalars['ID']['input'];
};


export type QueryTeamArgs = {
  teamID: Scalars['ID']['input'];
};


export type QueryTeamInvitationArgs = {
  inviteID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTeamMockServersArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  teamID: Scalars['ID']['input'];
};


export type QueryTeamPublishedDocsListArgs = {
  collectionID?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  teamID: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  uid: Scalars['ID']['input'];
};


export type QueryUserCollectionArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  userCollectionID: Scalars['ID']['input'];
};


export type QueryUserGqlRequestsArgs = {
  collectionID: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserPublishedDocsListArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserRestRequestsArgs = {
  collectionID: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserRequestArgs = {
  id: Scalars['ID']['input'];
};

export enum ReqType {
  Gql = 'GQL',
  Rest = 'REST'
}

export type RequestReorderData = {
  __typename?: 'RequestReorderData';
  /** Team Request succeeding the request being moved in its new position */
  nextRequest?: Maybe<TeamRequest>;
  /** Team Request being moved */
  request: TeamRequest;
};

/** Whether a service is enabled or disabled */
export enum ServiceStatus {
  Disable = 'DISABLE',
  Enable = 'ENABLE'
}

export type Shortcode = {
  __typename?: 'Shortcode';
  /** Timestamp of when the Shortcode was created */
  createdOn: Scalars['DateTime']['output'];
  /** The 12 digit alphanumeric code */
  id: Scalars['ID']['output'];
  /** Organization ID */
  orgID?: Maybe<Scalars['String']['output']>;
  /** JSON string representing the properties for an embed */
  properties?: Maybe<Scalars['String']['output']>;
  /** JSON string representing the request data */
  request: Scalars['String']['output'];
};

export enum SortOptions {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Listen to when a collections position has changed */
  collectionOrderUpdated: CollectionReorderData;
  /** Listen for shortcode creation */
  myShortcodesCreated: Shortcode;
  /** Listen for shortcode deletion */
  myShortcodesRevoked: Shortcode;
  /** Listen for Shortcode updates */
  myShortcodesUpdated: Shortcode;
  /** Listen for organization creation event following payment completion */
  organizationCreated: Scalars['String']['output'];
  /** Listen to when a new org member is added to an organization */
  organizationMemberAdded: OrganizationMember;
  /** Listen to when a org member is removed from an organization */
  organizationMemberRemoved: OrganizationMember;
  /** Listen for the organization's tier changing, e.g. once an upgrade is paid */
  organizationTierChanged: OrganizationTier;
  /** Emitted when a request has been moved from one collection into another */
  requestMoved: TeamRequest;
  /** Emitted when a requests position has been changed in its collection */
  requestOrderUpdated: RequestReorderData;
  /** Listen for Team Child Collection Sort Events */
  teamChildCollectionsSorted: Scalars['ID']['output'];
  /** Listen to when a collection has been added to a team. The emitted value is the team added */
  teamCollectionAdded: TeamCollection;
  /** Listen to when a collection has been moved */
  teamCollectionMoved: TeamCollection;
  /** Listen to when a collection has been removed */
  teamCollectionRemoved: Scalars['ID']['output'];
  /** Listen to when a collection has been updated. */
  teamCollectionUpdated: TeamCollection;
  /** Listen for Team Environment Creation Messages */
  teamEnvironmentCreated: TeamEnvironment;
  /** Listen for Team Environment Deletion Messages */
  teamEnvironmentDeleted: TeamEnvironment;
  /** Listen for Team Environment Updates */
  teamEnvironmentUpdated: TeamEnvironment;
  /** Listens to when a Team Invitation is added */
  teamInvitationAdded: TeamInvitation;
  /** Listens to when a Team Invitation is removed */
  teamInvitationRemoved: Scalars['ID']['output'];
  /** Listen to when a new team member being added to the team. The emitted value is the new team member added. */
  teamMemberAdded: TeamMember;
  /** Listen to when a team member has been removed. The emitted value is the uid of the user removed */
  teamMemberRemoved: Scalars['ID']['output'];
  /** Listen to when a team member status has been updated. The emitted value is the new team member status */
  teamMemberUpdated: TeamMember;
  /** Emits when a new request is added to a team */
  teamRequestAdded: TeamRequest;
  /** Emitted when a request has been deleted. Only the id of the request is emitted. */
  teamRequestDeleted: Scalars['ID']['output'];
  /** Emitted when a request has been updated */
  teamRequestUpdated: TeamRequest;
  /** Listen for Team Root Collection Sort Events */
  teamRootCollectionsSorted: Scalars['Boolean']['output'];
  /** Listen for user collection creation */
  userCollectionCreated: UserCollection;
  /** Listen for user collection duplication */
  userCollectionDuplicated: UserCollectionDuplicatedData;
  /** Listen for user collection move */
  userCollectionMoved: UserCollection;
  /** Listen for user collection order update */
  userCollectionOrderUpdated: UserCollectionOrderUpdatedData;
  /** Listen for user collection removal */
  userCollectionRemoved: UserCollectionRemovedData;
  /** Listen for user collection update */
  userCollectionUpdated: UserCollection;
  /** Listen for user deletion */
  userDeleted: User;
  /** Listen for User Environment Creation */
  userEnvironmentCreated: UserEnvironment;
  /** Listen for User Environment DeleteMany */
  userEnvironmentDeleteMany: Scalars['Float']['output'];
  /** Listen for User Environment deletion */
  userEnvironmentDeleted: UserEnvironment;
  /** Listen for User Environment updates */
  userEnvironmentUpdated: UserEnvironment;
  /** Listen for User History Creation */
  userHistoryCreated: UserHistory;
  /** Listen for User History deletion */
  userHistoryDeleted: UserHistory;
  /** Listen for User History deleted many */
  userHistoryDeletedMany: UserHistoryDeletedManyData;
  /** Listen for User History update */
  userHistoryUpdated: UserHistory;
  /** Listen for Organization user invitation */
  userInvited: InvitedUser;
  /** Listen for user request creation */
  userRequestCreated: UserRequest;
  /** Listen for user request deletion */
  userRequestDeleted: UserRequest;
  /** Listen for user request move */
  userRequestMoved: UserRequestReorderData;
  /** Listen for user request update */
  userRequestUpdated: UserRequest;
  /** Listen for user setting creation */
  userSettingsCreated: UserSettings;
  /** Listen for user setting updates */
  userSettingsUpdated: UserSettings;
};


export type SubscriptionCollectionOrderUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionOrganizationMemberAddedArgs = {
  orgID: Scalars['ID']['input'];
};


export type SubscriptionOrganizationMemberRemovedArgs = {
  orgID: Scalars['ID']['input'];
};


export type SubscriptionOrganizationTierChangedArgs = {
  orgID: Scalars['ID']['input'];
};


export type SubscriptionRequestMovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionRequestOrderUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamChildCollectionsSortedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamCollectionAddedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamCollectionMovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamCollectionRemovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamCollectionUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamEnvironmentCreatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamEnvironmentDeletedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamEnvironmentUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamInvitationAddedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamInvitationRemovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamMemberAddedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamMemberRemovedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamMemberUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamRequestAddedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamRequestDeletedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamRequestUpdatedArgs = {
  teamID: Scalars['ID']['input'];
};


export type SubscriptionTeamRootCollectionsSortedArgs = {
  teamID: Scalars['ID']['input'];
};

export type Team = {
  __typename?: 'Team';
  /** The number of users with the EDITOR role in the team */
  editorsCount: Scalars['Int']['output'];
  /** ID of the team */
  id: Scalars['ID']['output'];
  /** Returns the list of members of a team */
  members: Array<TeamMember>;
  /** The role of the current user in the team */
  myRole: TeamMemberRole;
  /** Displayed name of the team */
  name: Scalars['String']['output'];
  /** Organization domain */
  orgDomain?: Maybe<Scalars['String']['output']>;
  /** Organization ID where the team belongs to */
  orgID?: Maybe<Scalars['String']['output']>;
  /** Organization name */
  orgName?: Maybe<Scalars['String']['output']>;
  /** The number of users with the OWNER role in the team */
  ownersCount: Scalars['Int']['output'];
  /** Returns all Team Environments for the given Team */
  teamEnvironments: Array<TeamEnvironment>;
  /** Get all the active invites in the team */
  teamInvitations: Array<TeamInvitation>;
  /** Returns the list of members of a team */
  teamMembers: Array<TeamMember>;
  /** The number of users with the VIEWER role in the team */
  viewersCount: Scalars['Int']['output'];
};


export type TeamMembersArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
};

export type TeamCollection = {
  __typename?: 'TeamCollection';
  /** List of children collection */
  children: Array<TeamCollection>;
  /** JSON string representing the collection data */
  data?: Maybe<Scalars['String']['output']>;
  /** ID of the collection */
  id: Scalars['ID']['output'];
  /** The collection whom is the parent of this collection (null if this is root collection) */
  parent?: Maybe<TeamCollection>;
  /** Team the collection belongs to */
  team: Team;
  /** Displayed title of the collection */
  title: Scalars['String']['output'];
};


export type TeamCollectionChildrenArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
};

export type TeamEnvironment = {
  __typename?: 'TeamEnvironment';
  /** ID of the Team Environment */
  id: Scalars['ID']['output'];
  /** Name of the environment */
  name: Scalars['String']['output'];
  /** ID of the team this environment belongs to */
  teamID: Scalars['ID']['output'];
  /** All variables present in the environment */
  variables: Scalars['String']['output'];
};

export type TeamInvitation = {
  __typename?: 'TeamInvitation';
  /** Get the creator of the invite */
  creator: User;
  /** UID of the creator of the invite */
  creatorUid: Scalars['ID']['output'];
  /** ID of the invite */
  id: Scalars['ID']['output'];
  /** Email of the invitee */
  inviteeEmail: Scalars['ID']['output'];
  /** The role that will be given to the invitee */
  inviteeRole: TeamMemberRole;
  /** Get the team associated to the invite */
  team: Team;
  /** ID of the team the invite is to */
  teamID: Scalars['ID']['output'];
};

export type TeamMember = {
  __typename?: 'TeamMember';
  /** Membership ID of the Team Member */
  membershipID: Scalars['ID']['output'];
  /** Role of the given team member in the given team */
  role: TeamMemberRole;
  user: User;
};

export enum TeamMemberRole {
  Editor = 'EDITOR',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type TeamRequest = {
  __typename?: 'TeamRequest';
  /** Collection the request belongs to */
  collection: TeamCollection;
  /** ID of the collection the request belongs to. */
  collectionID: Scalars['ID']['output'];
  /** ID of the request */
  id: Scalars['ID']['output'];
  /** JSON string representing the request data */
  request: Scalars['String']['output'];
  /** Team the request belongs to */
  team: Team;
  /** ID of the team the request belongs to. */
  teamID: Scalars['ID']['output'];
  /** Displayed title of the request */
  title: Scalars['String']['output'];
};

export type TestAiProviderConnectionInput = {
  /** Omit to test with the stored key of the named connection */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseURL?: InputMaybe<Scalars['String']['input']>;
  /** Existing connection, to fall back on its stored values */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Models to try; defaults to the connection's own */
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Required when no id is given */
  preset?: InputMaybe<Scalars['String']['input']>;
};

export type TierChangePreview = {
  __typename?: 'TierChangePreview';
  /** Charged now for the rest of the current period, in the minor unit of currency */
  amountDueNow: Scalars['Int']['output'];
  /** Three-letter ISO currency code, lowercase */
  currency: Scalars['String']['output'];
  /** What a downgrade switches off; nothing is deleted, and a re-upgrade restores it */
  downgradeImpact?: Maybe<DowngradeImpact>;
  /** When the new tier takes effect */
  effectiveAt: Scalars['DateTime']['output'];
  /** What each following period costs on the new tier, in the minor unit of currency */
  nextPeriodAmount?: Maybe<Scalars['Int']['output']>;
  /** The tier being moved to */
  targetTier: OrganizationTier;
};

export type TierChangeResult = {
  __typename?: 'TierChangeResult';
  /** When a scheduled change takes effect */
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** Hosted invoice to pay, when payment is required */
  paymentURL?: Maybe<Scalars['String']['output']>;
  /** Where the change stands */
  status: TierChangeStatus;
};

export enum TierChangeStatus {
  Applied = 'APPLIED',
  PaymentRequired = 'PAYMENT_REQUIRED',
  Scheduled = 'SCHEDULED'
}

export type UpdateAiProviderConnectionInput = {
  /** Replace the credential. Omit to keep it */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  baseURL?: InputMaybe<Scalars['String']['input']>;
  defaultModel?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connection to change */
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  models?: InputMaybe<Array<Scalars['String']['input']>>;
  preset?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAiSettingsInput = {
  /** Acknowledge that request data goes to the configured providers; needed once, on the first enable */
  acknowledgeDataSharing?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxRetries?: InputMaybe<Scalars['Int']['input']>;
  /** Null follows the preset */
  promptCaching?: InputMaybe<Scalars['Boolean']['input']>;
  reasoningEffort?: InputMaybe<Scalars['String']['input']>;
  timeoutMs?: InputMaybe<Scalars['Int']['input']>;
  /** Null follows the preset */
  toolSearch?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAiSkillInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  prompt?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMockServerInput = {
  /** Delay in milliseconds before responding */
  delayInMs?: InputMaybe<Scalars['Float']['input']>;
  /** Whether the mock server is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the mock server is publicly accessible */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the mock server */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePublishedDocsArgs = {
  /** Whether the published document should auto-sync with the source */
  autoSync?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the environment to associate with the published document. Pass null to remove the environment. */
  environmentID?: InputMaybe<Scalars['String']['input']>;
  /** Metadata associated with the published document */
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Title of the published document */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Version of the published document */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamRequestInput = {
  /** JSON string representing the request data */
  request?: InputMaybe<Scalars['String']['input']>;
  /** Displayed title of the request */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  /** Returns a users GraphQL history */
  GQLHistory: Array<UserHistory>;
  /** Returns a users REST history */
  RESTHistory: Array<UserHistory>;
  /** Displayed name of the user (if given) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Email of the user (if given) */
  email?: Maybe<Scalars['String']['output']>;
  /** Returns a list of users personal environments */
  environments: Array<UserEnvironment>;
  /** Returns the users global environments */
  globalEnvironments: UserEnvironment;
  /** URL to the profile photo of the user (if given) */
  photoURL?: Maybe<Scalars['String']['output']>;
  /** Returns user settings */
  settings: UserSettings;
  /** Firebase UID of the user */
  uid: Scalars['ID']['output'];
};


export type UserGqlHistoryArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type UserRestHistoryArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCollection = {
  __typename?: 'UserCollection';
  /** List of children GraphQL user collection */
  childrenGQL: Array<UserCollection>;
  /** List of children REST user collection */
  childrenREST: Array<UserCollection>;
  /** JSON string representing the collection data */
  data?: Maybe<Scalars['String']['output']>;
  /** ID of the collection */
  id: Scalars['ID']['output'];
  /** Parent user collection (null if root) */
  parent?: Maybe<UserCollection>;
  /** Returns user requests of a user collection */
  requests: Array<UserRequest>;
  /** Displayed title of the collection */
  title: Scalars['String']['output'];
  /** Type of the user collection */
  type: ReqType;
  /** User the collection belongs to */
  user: User;
};


export type UserCollectionChildrenGqlArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCollectionChildrenRestArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCollectionParentArgs = {
  orgID?: InputMaybe<Scalars['ID']['input']>;
};


export type UserCollectionRequestsArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type UserCollectionDuplicatedData = {
  __typename?: 'UserCollectionDuplicatedData';
  /** Child collections of the duplicated User Collection */
  childCollections: Scalars['String']['output'];
  /** JSON string representing the collection data */
  data?: Maybe<Scalars['String']['output']>;
  /** ID of the user collection */
  id: Scalars['ID']['output'];
  /** Parent ID of the duplicated User Collection */
  parentID?: Maybe<Scalars['ID']['output']>;
  /** Requests of the duplicated User Collection */
  requests: Array<UserRequest>;
  /** Displayed title of the user collection */
  title: Scalars['String']['output'];
  /** Type of the user collection */
  type: ReqType;
  /** User ID of the duplicated User Collection */
  userID: Scalars['String']['output'];
};

export type UserCollectionExportJsonData = {
  __typename?: 'UserCollectionExportJSONData';
  /** Type of the user collection */
  collectionType: ReqType;
  /** Stringified contents of the collection */
  exportedCollection: Scalars['ID']['output'];
};

export type UserCollectionOrderUpdatedData = {
  __typename?: 'UserCollectionOrderUpdatedData';
  /** User collection succeeding the reordered collection in its new position */
  nextUserCollection?: Maybe<UserCollection>;
  /** User collection being reordered */
  userCollection: UserCollection;
};

export type UserCollectionRemovedData = {
  __typename?: 'UserCollectionRemovedData';
  /** ID of User Collection being removed */
  id: Scalars['ID']['output'];
  /** Type of the user collection */
  type: ReqType;
};

export type UserEnvironment = {
  __typename?: 'UserEnvironment';
  /** ID of the User Environment */
  id: Scalars['ID']['output'];
  /** Flag to indicate the environment is global or not */
  isGlobal: Scalars['Boolean']['output'];
  /** Name of the environment */
  name?: Maybe<Scalars['String']['output']>;
  /** ID of the user this environment belongs to */
  userUid: Scalars['ID']['output'];
  /** All variables present in the environment as a JSON string */
  variables: Scalars['String']['output'];
};

export type UserHistory = {
  __typename?: 'UserHistory';
  /** Timestamp of when the request was executed or history was created */
  executedOn: Scalars['DateTime']['output'];
  /** ID of the user request in history */
  id: Scalars['ID']['output'];
  /** If the request in the history is starred */
  isStarred: Scalars['Boolean']['output'];
  /** Type of the request in the history */
  reqType: ReqType;
  /** JSON string representing the request data */
  request: Scalars['String']['output'];
  /** JSON string representing the response meta-data */
  responseMetadata: Scalars['String']['output'];
  /** ID of the user this history belongs to */
  userUid: Scalars['ID']['output'];
};

export type UserHistoryDeletedManyData = {
  __typename?: 'UserHistoryDeletedManyData';
  /** Number of user histories deleted */
  count: Scalars['Float']['output'];
  /** Type of the request in the history */
  reqType: ReqType;
};

export type UserOrganizationMembership = {
  __typename?: 'UserOrganizationMembership';
  /** When the user was invited to the organization */
  invitedOn: Scalars['DateTime']['output'];
  /** Whether the user is an admin in this organization */
  isAdmin: Scalars['Boolean']['output'];
  /** Organization member ID */
  membershipID: Scalars['ID']['output'];
  /** Current membership status (ACTIVE or INACTIVE) */
  membershipStatus: OrganizationMembershipStatus;
  /** Organization details */
  organization: Organization;
};

export type UserRequest = {
  __typename?: 'UserRequest';
  /** ID of the parent collection ID */
  collectionID: Scalars['ID']['output'];
  /** Date of the user request creation */
  createdOn: Scalars['DateTime']['output'];
  /** ID of the user request */
  id: Scalars['ID']['output'];
  /** Content/Body of the user request */
  request: Scalars['String']['output'];
  /** Title of the user request */
  title: Scalars['String']['output'];
  /** Type (GRAPHQL/REST) of the user request */
  type: ReqType;
  /** Returns the user of the user request */
  user: User;
};

export type UserRequestReorderData = {
  __typename?: 'UserRequestReorderData';
  /** User request succeeding the request being moved in its new position */
  nextRequest?: Maybe<UserRequest>;
  /** User request being moved */
  request: UserRequest;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  /** ID of the User Setting */
  id: Scalars['ID']['output'];
  /** Stringified JSON settings object */
  properties: Scalars['String']['output'];
  /** Last updated on */
  updatedOn: Scalars['DateTime']['output'];
  /** ID of the user this setting belongs to */
  userUid: Scalars['ID']['output'];
};

export enum WorkspaceType {
  Team = 'TEAM',
  User = 'USER'
}

export type AcceptOrganizationInvitationMutationVariables = Exact<{
  orgInviteID: Scalars['ID']['input'];
}>;


export type AcceptOrganizationInvitationMutation = { __typename?: 'Mutation', acceptOrganizationInvitation: { __typename?: 'OrganizationMember', userUID: string } };

export type AddUserToTeamByAdminMutationVariables = Exact<{
  userEmail: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userRole: TeamMemberRole;
}>;


export type AddUserToTeamByAdminMutation = { __typename?: 'Mutation', addUserToTeamByAdmin: { __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', uid: string } } };

export type CreateAiProviderConnectionMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  input: CreateAiProviderConnectionInput;
}>;


export type CreateAiProviderConnectionMutation = { __typename?: 'Mutation', createAIProviderConnection: { __typename?: 'AIProviderConnection', id: string, label: string, preset: string, baseURL?: string | null, models: Array<string>, defaultModel: string, enabled: boolean, isDefault: boolean, hasApiKey: boolean, createdOn: any, updatedOn: any } };

export type CreateAiSkillMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  input: CreateAiSkillInput;
}>;


export type CreateAiSkillMutation = { __typename?: 'Mutation', createAISkill: { __typename?: 'AISkill', id: string, slug: string, title: string, description: string, prompt: string, enabled: boolean } };

export type CreateTeamByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type CreateTeamByAdminMutation = { __typename?: 'Mutation', createTeamByAdmin: { __typename?: 'Team', id: string } };

export type DeactivateOrganizationMemberMutationVariables = Exact<{
  orgMemberID: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type DeactivateOrganizationMemberMutation = { __typename?: 'Mutation', deactivateOrganizationMember: boolean };

export type DeleteAiProviderConnectionMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteAiProviderConnectionMutation = { __typename?: 'Mutation', deleteAIProviderConnection: boolean };

export type DeleteAiSkillMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type DeleteAiSkillMutation = { __typename?: 'Mutation', deleteAISkill: boolean };

export type DeleteTeamByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
}>;


export type DeleteTeamByAdminMutation = { __typename?: 'Mutation', deleteTeamByAdmin: boolean };

export type DemoteOrganizationMembersAdminMutationVariables = Exact<{
  userUIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type DemoteOrganizationMembersAdminMutation = { __typename?: 'Mutation', demoteOrganizationMembersAsAdmin: boolean };

export type InviteNewUserMutationVariables = Exact<{
  inviteeEmail: Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type InviteNewUserMutation = { __typename?: 'Mutation', inviteNewUser: { __typename?: 'InvitedUser', inviteID: string } };

export type MakeOrganizationMembersAdminMutationVariables = Exact<{
  userUIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type MakeOrganizationMembersAdminMutation = { __typename?: 'Mutation', makeOrganizationMembersAdmin: boolean };

export type RemoveMemberFromTeamByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
}>;


export type RemoveMemberFromTeamByAdminMutation = { __typename?: 'Mutation', removeMemberFromTeamByAdmin: boolean };

export type RemoveOrganizationMemberMutationVariables = Exact<{
  orgMemberID: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type RemoveOrganizationMemberMutation = { __typename?: 'Mutation', removeOrganizationMember: { __typename?: 'OrganizationMember', userUID: string } };

export type RenameTeamByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  newTeamName: Scalars['String']['input'];
}>;


export type RenameTeamByAdminMutation = { __typename?: 'Mutation', renameTeamByAdmin: { __typename?: 'Team', id: string, name: string } };

export type RevokeOrganizationMemberInvitationsByAdminMutationVariables = Exact<{
  inviteeEmails: Array<Scalars['String']['input']> | Scalars['String']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type RevokeOrganizationMemberInvitationsByAdminMutation = { __typename?: 'Mutation', revokeOrganizationMemberInvitationsByAdmin: boolean };

export type RevokeOrganizationTeamInviteByAdminMutationVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  orgID: Scalars['ID']['input'];
}>;


export type RevokeOrganizationTeamInviteByAdminMutation = { __typename?: 'Mutation', revokeOrganizationTeamInviteByAdmin: boolean };

export type TestAiProviderConnectionMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  input: TestAiProviderConnectionInput;
}>;


export type TestAiProviderConnectionMutation = { __typename?: 'Mutation', testAIProviderConnection: Array<{ __typename?: 'AIProviderTestResult', model: string, ok: boolean, latencyMs: number, reason?: string | null, detail?: string | null }> };

export type UpdateAiProviderConnectionMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  input: UpdateAiProviderConnectionInput;
}>;


export type UpdateAiProviderConnectionMutation = { __typename?: 'Mutation', updateAIProviderConnection: { __typename?: 'AIProviderConnection', id: string, label: string, preset: string, baseURL?: string | null, models: Array<string>, defaultModel: string, enabled: boolean, isDefault: boolean, hasApiKey: boolean, createdOn: any, updatedOn: any } };

export type UpdateAiSettingsMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  input: UpdateAiSettingsInput;
}>;


export type UpdateAiSettingsMutation = { __typename?: 'Mutation', updateAISettings: { __typename?: 'AISettings', enabled: boolean, timeoutMs?: number | null, maxRetries?: number | null, toolSearch?: boolean | null, promptCaching?: boolean | null, reasoningEffort?: string | null, acknowledgedAt?: any | null, editable: boolean } };

export type UpdateAiSkillMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  input: UpdateAiSkillInput;
}>;


export type UpdateAiSkillMutation = { __typename?: 'Mutation', updateAISkill: { __typename?: 'AISkill', id: string, slug: string, title: string, description: string, prompt: string, enabled: boolean } };

export type UpdateOrganizationTeamMemberRoleByAdminMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
  userUid: Scalars['ID']['input'];
  newRole: TeamMemberRole;
}>;


export type UpdateOrganizationTeamMemberRoleByAdminMutation = { __typename?: 'Mutation', updateOrganizationTeamMemberRoleByAdmin: { __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole } };

export type CreateOrganizationBannerMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  type: BannerType;
  message: Scalars['String']['input'];
}>;


export type CreateOrganizationBannerMutation = { __typename?: 'Mutation', createOrganizationBanner: { __typename?: 'OrganizationBanner', id: string, orgID: string, type: BannerType, status: BannerStatus, message: string, createdOn: any } };

export type EnableAndDisableOrganizationAuthMutationVariables = Exact<{
  providerInfo: Array<EnableAndDisableOrgAuthArgs> | EnableAndDisableOrgAuthArgs;
}>;


export type EnableAndDisableOrganizationAuthMutation = { __typename?: 'Mutation', enableAndDisableOrganizationAuth: Array<{ __typename?: 'OrgAuthProviderStatus', provider: AuthProvider, status: ServiceStatus }> };

export type ToggleDomainWhitelistingMutationVariables = Exact<{
  status: ServiceStatus;
}>;


export type ToggleDomainWhitelistingMutation = { __typename?: 'Mutation', toggleDomainWhitelisting: boolean };

export type UpdateOrganizationBannerMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  type: BannerType;
  message: Scalars['String']['input'];
  status: BannerStatus;
}>;


export type UpdateOrganizationBannerMutation = { __typename?: 'Mutation', updateOrganizationBanner: { __typename?: 'OrganizationBanner', id: string, orgID: string, type: BannerType, status: BannerStatus, message: string, createdOn: any } };

export type UpdateOrganizationConfigsMutationVariables = Exact<{
  configs: Array<OrgConfigArgs> | OrgConfigArgs;
}>;


export type UpdateOrganizationConfigsMutation = { __typename?: 'Mutation', updateOrganizationConfigs: Array<{ __typename?: 'OrgConfig', name: OrgConfigEnum, value: string }> };

export type UpdateWhitelistedDomainsMutationVariables = Exact<{
  domains: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateWhitelistedDomainsMutation = { __typename?: 'Mutation', updateWhitelistedDomains: Array<string> };

export type AiProviderConnectionsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type AiProviderConnectionsQuery = { __typename?: 'Query', aiProviderConnections: Array<{ __typename?: 'AIProviderConnection', id: string, label: string, preset: string, baseURL?: string | null, models: Array<string>, defaultModel: string, enabled: boolean, isDefault: boolean, hasApiKey: boolean, createdOn: any, updatedOn: any }> };

export type AiProviderPresetsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type AiProviderPresetsQuery = { __typename?: 'Query', aiProviderPresets: Array<{ __typename?: 'AIProviderPreset', name: string, dialect: string, baseURLHint?: string | null, defaultBaseURL?: string | null, requiresBaseURL: boolean, suggestedModels: Array<string>, verified: boolean }> };

export type AiSettingsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type AiSettingsQuery = { __typename?: 'Query', aiSettings: { __typename?: 'AISettings', enabled: boolean, timeoutMs?: number | null, maxRetries?: number | null, toolSearch?: boolean | null, promptCaching?: boolean | null, reasoningEffort?: string | null, acknowledgedAt?: any | null, editable: boolean } };

export type AiSkillsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type AiSkillsQuery = { __typename?: 'Query', aiSkills: Array<{ __typename?: 'AISkill', id: string, slug: string, title: string, description: string, prompt: string, enabled: boolean }> };

export type AiStoredDataQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type AiStoredDataQuery = { __typename?: 'Query', aiProviderConnections: Array<{ __typename?: 'AIProviderConnection', id: string }>, aiSkills: Array<{ __typename?: 'AISkill', id: string }> };

export type GetInvitedOrganizationMembersQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetInvitedOrganizationMembersQuery = { __typename?: 'Query', invitedOrganizationMembers: Array<{ __typename?: 'InvitedUser', inviteID: string, adminEmail: string, inviteeEmail: string, invitedOn: any }> };

export type GetOrganizationInviteDetailsQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
}>;


export type GetOrganizationInviteDetailsQuery = { __typename?: 'Query', getOrgInviteDetails: { __typename?: 'InvitedUser', adminEmail: string, adminName?: string | null, orgName?: string | null } };

export type GetOrganizationMemberDetailsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  orgMemberID: Scalars['ID']['input'];
}>;


export type GetOrganizationMemberDetailsQuery = { __typename?: 'Query', organizationMember: { __typename?: 'OrganizationMember', userUID: string, userName?: string | null, userEmail?: string | null, orgID: string, invitedOn: any, isAdmin: boolean, inviteeUserUID?: string | null, lastActiveOn?: any | null, createdOn: any, photoURL?: string | null } };

export type GetOrganizationMembersQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationMembersQuery = { __typename?: 'Query', organizationMembers: Array<{ __typename?: 'OrganizationMember', userUID: string, userName?: string | null, userEmail?: string | null, orgID: string, invitedOn: any, isAdmin: boolean, inviteeUserUID?: string | null, lastActiveOn?: any | null, createdOn: any }> };

export type GetOrganizationMembersCountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationMembersCountQuery = { __typename?: 'Query', organizationMembersCount: number };

export type GetOrganizationTeamCollectionsCountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamCollectionsCountQuery = { __typename?: 'Query', organizationTeamCollectionsCount: number };

export type GetOrganizationTeamInfoQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
  teamID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamInfoQuery = { __typename?: 'Query', organizationTeamInfo: { __typename?: 'Team', id: string, name: string, teamMembers: Array<{ __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', uid: string, email?: string | null } }>, teamInvitations: Array<{ __typename?: 'TeamInvitation', id: string, inviteeEmail: string, inviteeRole: TeamMemberRole }> } };

export type GetOrganizationTeamRequestsCountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamRequestsCountQuery = { __typename?: 'Query', organizationTeamRequestsCount: number };

export type GetOrganizationTeamsQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamsQuery = { __typename?: 'Query', organizationTeams: Array<{ __typename?: 'Team', id: string, name: string, members: Array<{ __typename?: 'TeamMember', user: { __typename?: 'User', uid: string, email?: string | null } }> }> };

export type GetOrganizationTeamsCountQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationTeamsCountQuery = { __typename?: 'Query', organizationTeamsCount: number };

export type UpdateOrganizationBillingCycleMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  orgBillingCycle: OrganizationBillingCycle;
}>;


export type UpdateOrganizationBillingCycleMutation = { __typename?: 'Mutation', updateOrganizationBillingCycle: boolean };

export type UpdateOrganizationSeatsMutationVariables = Exact<{
  orgID: Scalars['ID']['input'];
  seats: Scalars['Float']['input'];
}>;


export type UpdateOrganizationSeatsMutation = { __typename?: 'Mutation', updateOrganizationSeats: boolean };

export type OrganizationActiveBannerQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type OrganizationActiveBannerQuery = { __typename?: 'Query', organizationActiveBanner?: { __typename?: 'OrganizationBanner', id: string, orgID: string, type: BannerType, status: BannerStatus, message: string, createdOn: any } | null };

export type OrganizationAllowedAuthProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationAllowedAuthProvidersQuery = { __typename?: 'Query', organizationAllowedAuthProviders: Array<{ __typename?: 'OrgAuthProviderStatus', provider: AuthProvider, status: ServiceStatus }> };

export type OrganizationConfigsQueryVariables = Exact<{
  names?: InputMaybe<Array<OrgConfigEnum> | OrgConfigEnum>;
}>;


export type OrganizationConfigsQuery = { __typename?: 'Query', organizationConfigs: Array<{ __typename?: 'OrgConfig', name: OrgConfigEnum, value: string }> };

export type OrganizationWorkingBannerQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type OrganizationWorkingBannerQuery = { __typename?: 'Query', organizationWorkingBanner?: { __typename?: 'OrganizationBanner', id: string, orgID: string, type: BannerType, status: BannerStatus, message: string, createdOn: any } | null };

export type OrganizationMemberAddedSubscriptionVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type OrganizationMemberAddedSubscription = { __typename?: 'Subscription', organizationMemberAdded: { __typename?: 'OrganizationMember', userUID: string, userName?: string | null, userEmail?: string | null, orgID: string, invitedOn: any, isAdmin: boolean, inviteeUserUID?: string | null, lastActiveOn?: any | null, createdOn: any } };

export type AcceptTeamInvitationMutationVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AcceptTeamInvitationMutation = { __typename?: 'Mutation', acceptTeamInvitation: { __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', uid: string, displayName?: string | null, photoURL?: string | null, email?: string | null } } };

export type CreateMockServerMutationVariables = Exact<{
  input: CreateMockServerInput;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateMockServerMutation = { __typename?: 'Mutation', createMockServer: { __typename?: 'MockServer', id: string, name: string, subdomain: string, serverUrlPathBased: string, serverUrlDomainBased?: string | null, workspaceType: WorkspaceType, workspaceID?: string | null, delayInMs: number, isPublic: boolean, isActive: boolean, createdOn: any, updatedOn: any, creator?: { __typename?: 'User', uid: string } | null, collection?: { __typename?: 'MockServerCollection', id: string, title: string } | null } };

export type CreatePublishedDocMutationVariables = Exact<{
  args: CreatePublishedDocsArgs;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreatePublishedDocMutation = { __typename?: 'Mutation', createPublishedDoc: { __typename?: 'PublishedDocs', id: string, title: string, version: string, autoSync: boolean, url: string, environmentName?: string | null, createdOn: any, updatedOn: any, workspaceType: string, workspaceID?: string | null } };

export type CreateShortcodeMutationVariables = Exact<{
  request: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateShortcodeMutation = { __typename?: 'Mutation', createShortcode: { __typename?: 'Shortcode', id: string, request: string, createdOn: any, properties?: string | null } };

export type CreateTeamMutationVariables = Exact<{
  name: Scalars['String']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, myRole: TeamMemberRole, ownersCount: number, editorsCount: number, viewersCount: number, members: Array<{ __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', uid: string, displayName?: string | null, email?: string | null, photoURL?: string | null } }> } };

export type CreateTeamInvitationMutationVariables = Exact<{
  inviteeEmail: Scalars['String']['input'];
  inviteeRole: TeamMemberRole;
  teamID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTeamInvitationMutation = { __typename?: 'Mutation', createTeamInvitation: { __typename?: 'TeamInvitation', id: string, teamID: string, creatorUid: string, inviteeEmail: string, inviteeRole: TeamMemberRole } };

export type DeleteMockServerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteMockServerMutation = { __typename?: 'Mutation', deleteMockServer: boolean };

export type DeleteMockServerLogMutationVariables = Exact<{
  logID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteMockServerLogMutation = { __typename?: 'Mutation', deleteMockServerLog: boolean };

export type DeletePublishedDocMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeletePublishedDocMutation = { __typename?: 'Mutation', deletePublishedDoc: boolean };

export type InitiateOrganizationPurchaseMutationVariables = Exact<{
  organizationName: Scalars['String']['input'];
  organizationDomain: Scalars['String']['input'];
  organizationSeats: Scalars['Float']['input'];
  organizationMetadata?: InputMaybe<Scalars['String']['input']>;
  organizationBillingCycle: OrganizationBillingCycle;
  organizationTier?: InputMaybe<OrganizationTier>;
}>;


export type InitiateOrganizationPurchaseMutation = { __typename?: 'Mutation', initiateOrganizationPurchase: string };

export type UpdateMockServerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateMockServerInput;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateMockServerMutation = { __typename?: 'Mutation', updateMockServer: { __typename?: 'MockServer', id: string, name: string, subdomain: string, serverUrlPathBased: string, serverUrlDomainBased?: string | null, workspaceType: WorkspaceType, workspaceID?: string | null, delayInMs: number, isPublic: boolean, isActive: boolean, createdOn: any, updatedOn: any, creator?: { __typename?: 'User', uid: string } | null, collection?: { __typename?: 'MockServerCollection', id: string, title: string } | null } };

export type UpdatePublishedDocMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  args: UpdatePublishedDocsArgs;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdatePublishedDocMutation = { __typename?: 'Mutation', updatePublishedDoc: { __typename?: 'PublishedDocs', id: string, title: string, version: string, autoSync: boolean, url: string, environmentName?: string | null, createdOn: any, updatedOn: any } };

export type UpdateUserGlobalEnvironmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  variables: Scalars['String']['input'];
}>;


export type UpdateUserGlobalEnvironmentMutation = { __typename?: 'Mutation', updateUserGlobalEnvironment: { __typename?: 'UserEnvironment', id: string, userUid: string, name?: string | null, variables: string, isGlobal: boolean } };

export type AiChatAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type AiChatAvailabilityQuery = { __typename?: 'Query', aiChatEnabled: boolean, aiChatModelOptions: Array<{ __typename?: 'AIChatModelOption', connectionID: string, connectionLabel: string, preset: string, model: string, isDefault: boolean }>, aiChatSkills: Array<{ __typename?: 'AISkill', slug: string, title: string, description: string, prompt: string }> };

export type GetInviteDetailsQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetInviteDetailsQuery = { __typename?: 'Query', teamInvitation: { __typename?: 'TeamInvitation', id: string, inviteeEmail: string, inviteeRole: TeamMemberRole, team: { __typename?: 'Team', id: string, name: string }, creator: { __typename?: 'User', uid: string, displayName?: string | null, email?: string | null } } };

export type GetMockServerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMockServerQuery = { __typename?: 'Query', mockServer: { __typename?: 'MockServer', id: string, name: string, subdomain: string, serverUrlPathBased: string, serverUrlDomainBased?: string | null, workspaceType: WorkspaceType, workspaceID?: string | null, delayInMs: number, isPublic: boolean, isActive: boolean, createdOn: any, updatedOn: any, creator?: { __typename?: 'User', uid: string } | null, collection?: { __typename?: 'MockServerCollection', id: string, title: string } | null } };

export type GetMockServerLogsQueryVariables = Exact<{
  mockServerID: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMockServerLogsQuery = { __typename?: 'Query', mockServerLogs: Array<{ __typename?: 'MockServerLog', id: string, mockServerID: string, requestMethod: string, requestPath: string, requestHeaders: string, requestBody?: string | null, requestQuery?: string | null, responseStatus: number, responseHeaders: string, responseBody?: string | null, responseTime: number, ipAddress?: string | null, userAgent?: string | null, executedAt: any }> };

export type GetMyMockServersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMyMockServersQuery = { __typename?: 'Query', myMockServers: Array<{ __typename?: 'MockServer', id: string, name: string, subdomain: string, serverUrlPathBased: string, serverUrlDomainBased?: string | null, workspaceType: WorkspaceType, workspaceID?: string | null, delayInMs: number, isPublic: boolean, isActive: boolean, createdOn: any, updatedOn: any, creator?: { __typename?: 'User', uid: string } | null, collection?: { __typename?: 'MockServerCollection', id: string, title: string } | null }> };

export type GetMyOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrganizationsQuery = { __typename?: 'Query', myOrganizations: Array<{ __typename?: 'UserOrganizationMembership', isAdmin: boolean, invitedOn: any, membershipID: string, organization: { __typename?: 'Organization', orgID: string, orgName: string, orgDomain: string, orgStatus: OrganizationStatus, orgLogo?: string | null } }> };

export type GetUserShortcodesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUserShortcodesQuery = { __typename?: 'Query', myShortcodes: Array<{ __typename?: 'Shortcode', id: string, request: string, createdOn: any, properties?: string | null }> };

export type GetMyTeamsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['ID']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMyTeamsQuery = { __typename?: 'Query', myTeams: Array<{ __typename?: 'Team', id: string, name: string, myRole: TeamMemberRole, ownersCount: number, orgDomain?: string | null, orgName?: string | null, teamMembers: Array<{ __typename?: 'TeamMember', membershipID: string, role: TeamMemberRole, user: { __typename?: 'User', photoURL?: string | null, displayName?: string | null, email?: string | null, uid: string } }> }> };

export type GetOrganizationInfoByDomainQueryVariables = Exact<{
  orgDomain: Scalars['ID']['input'];
}>;


export type GetOrganizationInfoByDomainQuery = { __typename?: 'Query', organizationByDomainV2: { __typename?: 'OrganizationSummary', orgID: string, tier: OrganizationTier } };

export type GetOrganizationInfoByIdQueryVariables = Exact<{
  orgID: Scalars['ID']['input'];
}>;


export type GetOrganizationInfoByIdQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', orgID: string, orgName: string, orgDomain: string, orgLogo?: string | null, createdOn: any, seats: number, orgMetadata?: string | null, tier: OrganizationTier, billingEmail?: string | null, billingCycle?: OrganizationBillingCycle | null, nextBillingDate?: number | null, orgStatus: OrganizationStatus, billingAddress?: { __typename?: 'OrganizationBillingAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, country?: string | null, postal_code?: string | null } | null } };

export type GetTeamMockServersQueryVariables = Exact<{
  teamID: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetTeamMockServersQuery = { __typename?: 'Query', teamMockServers: Array<{ __typename?: 'MockServer', id: string, name: string, subdomain: string, serverUrlPathBased: string, serverUrlDomainBased?: string | null, workspaceType: WorkspaceType, workspaceID?: string | null, delayInMs: number, isPublic: boolean, isActive: boolean, createdOn: any, updatedOn: any, creator?: { __typename?: 'User', uid: string } | null, collection?: { __typename?: 'MockServerCollection', id: string, title: string } | null }> };

export type PublishedDocQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PublishedDocQuery = { __typename?: 'Query', publishedDoc: { __typename?: 'PublishedDocs', id: string, title: string, version: string, autoSync: boolean, url: string, metadata: string, environmentName?: string | null, environmentVariables?: string | null, createdOn: any, updatedOn: any, creator: { __typename?: 'User', uid: string, displayName?: string | null, email?: string | null, photoURL?: string | null }, collection: { __typename?: 'PublishedDocsCollection', id: string, title: string } } };

export type TeamPublishedDocsListQueryVariables = Exact<{
  teamID: Scalars['ID']['input'];
  collectionID?: InputMaybe<Scalars['ID']['input']>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TeamPublishedDocsListQuery = { __typename?: 'Query', teamPublishedDocsList: Array<{ __typename?: 'PublishedDocs', id: string, title: string, version: string, autoSync: boolean, url: string, documentTree: string, environmentName?: string | null, createdOn: any, updatedOn: any, collection: { __typename?: 'PublishedDocsCollection', id: string } }> };

export type UserPublishedDocsListQueryVariables = Exact<{
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  orgID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserPublishedDocsListQuery = { __typename?: 'Query', userPublishedDocsList: Array<{ __typename?: 'PublishedDocs', id: string, title: string, version: string, autoSync: boolean, url: string, documentTree: string, environmentName?: string | null, createdOn: any, updatedOn: any, collection: { __typename?: 'PublishedDocsCollection', id: string } }> };


export const AcceptOrganizationInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"acceptOrganizationInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgInviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptOrganizationInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgInviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgInviteID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}}]}}]}}]} as unknown as DocumentNode<AcceptOrganizationInvitationMutation, AcceptOrganizationInvitationMutationVariables>;
export const AddUserToTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUserToTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberRole"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserToTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"userRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}}]}}]}}]} as unknown as DocumentNode<AddUserToTeamByAdminMutation, AddUserToTeamByAdminMutationVariables>;
export const CreateAiProviderConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAIProviderConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAIProviderConnectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAIProviderConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"baseURL"}},{"kind":"Field","name":{"kind":"Name","value":"models"}},{"kind":"Field","name":{"kind":"Name","value":"defaultModel"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"hasApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}}]}}]}}]} as unknown as DocumentNode<CreateAiProviderConnectionMutation, CreateAiProviderConnectionMutationVariables>;
export const CreateAiSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAISkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAISkillInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAISkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<CreateAiSkillMutation, CreateAiSkillMutationVariables>;
export const CreateTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"userUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTeamByAdminMutation, CreateTeamByAdminMutationVariables>;
export const DeactivateOrganizationMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeactivateOrganizationMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivateOrganizationMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgMemberID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<DeactivateOrganizationMemberMutation, DeactivateOrganizationMemberMutationVariables>;
export const DeleteAiProviderConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAIProviderConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAIProviderConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteAiProviderConnectionMutation, DeleteAiProviderConnectionMutationVariables>;
export const DeleteAiSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAISkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAISkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteAiSkillMutation, DeleteAiSkillMutationVariables>;
export const DeleteTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}}]}]}}]} as unknown as DocumentNode<DeleteTeamByAdminMutation, DeleteTeamByAdminMutationVariables>;
export const DemoteOrganizationMembersAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DemoteOrganizationMembersAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"demoteOrganizationMembersAsAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userUIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUIDs"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<DemoteOrganizationMembersAdminMutation, DemoteOrganizationMembersAdminMutationVariables>;
export const InviteNewUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteNewUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteNewUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteeEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteID"}}]}}]}}]} as unknown as DocumentNode<InviteNewUserMutation, InviteNewUserMutationVariables>;
export const MakeOrganizationMembersAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeOrganizationMembersAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeOrganizationMembersAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userUIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUIDs"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<MakeOrganizationMembersAdminMutation, MakeOrganizationMembersAdminMutationVariables>;
export const RemoveMemberFromTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMemberFromTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMemberFromTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"userUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}}}]}]}}]} as unknown as DocumentNode<RemoveMemberFromTeamByAdminMutation, RemoveMemberFromTeamByAdminMutationVariables>;
export const RemoveOrganizationMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveOrganizationMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOrganizationMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgMemberID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}}]}}]}}]} as unknown as DocumentNode<RemoveOrganizationMemberMutation, RemoveOrganizationMemberMutationVariables>;
export const RenameTeamByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameTeamByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTeamName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameTeamByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"newTeamName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newTeamName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RenameTeamByAdminMutation, RenameTeamByAdminMutationVariables>;
export const RevokeOrganizationMemberInvitationsByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revokeOrganizationMemberInvitationsByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeOrganizationMemberInvitationsByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteeEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmails"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<RevokeOrganizationMemberInvitationsByAdminMutation, RevokeOrganizationMemberInvitationsByAdminMutationVariables>;
export const RevokeOrganizationTeamInviteByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeOrganizationTeamInviteByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeOrganizationTeamInviteByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<RevokeOrganizationTeamInviteByAdminMutation, RevokeOrganizationTeamInviteByAdminMutationVariables>;
export const TestAiProviderConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TestAIProviderConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TestAIProviderConnectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testAIProviderConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"latencyMs"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}}]}}]}}]} as unknown as DocumentNode<TestAiProviderConnectionMutation, TestAiProviderConnectionMutationVariables>;
export const UpdateAiProviderConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAIProviderConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAIProviderConnectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAIProviderConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"baseURL"}},{"kind":"Field","name":{"kind":"Name","value":"models"}},{"kind":"Field","name":{"kind":"Name","value":"defaultModel"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"hasApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}}]}}]}}]} as unknown as DocumentNode<UpdateAiProviderConnectionMutation, UpdateAiProviderConnectionMutationVariables>;
export const UpdateAiSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAISettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAISettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAISettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"timeoutMs"}},{"kind":"Field","name":{"kind":"Name","value":"maxRetries"}},{"kind":"Field","name":{"kind":"Name","value":"toolSearch"}},{"kind":"Field","name":{"kind":"Name","value":"promptCaching"}},{"kind":"Field","name":{"kind":"Name","value":"reasoningEffort"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}}]}}]}}]} as unknown as DocumentNode<UpdateAiSettingsMutation, UpdateAiSettingsMutationVariables>;
export const UpdateAiSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAISkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAISkillInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAISkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<UpdateAiSkillMutation, UpdateAiSkillMutationVariables>;
export const UpdateOrganizationTeamMemberRoleByAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationTeamMemberRoleByAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberRole"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationTeamMemberRoleByAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"userUid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"newRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationTeamMemberRoleByAdminMutation, UpdateOrganizationTeamMemberRoleByAdminMutationVariables>;
export const CreateOrganizationBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganizationBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BannerType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrganizationBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<CreateOrganizationBannerMutation, CreateOrganizationBannerMutationVariables>;
export const EnableAndDisableOrganizationAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableAndDisableOrganizationAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerInfo"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnableAndDisableOrgAuthArgs"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableAndDisableOrganizationAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerInfo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<EnableAndDisableOrganizationAuthMutation, EnableAndDisableOrganizationAuthMutationVariables>;
export const ToggleDomainWhitelistingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleDomainWhitelisting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleDomainWhitelisting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}]}}]} as unknown as DocumentNode<ToggleDomainWhitelistingMutation, ToggleDomainWhitelistingMutationVariables>;
export const UpdateOrganizationBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BannerType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BannerStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationBannerMutation, UpdateOrganizationBannerMutationVariables>;
export const UpdateOrganizationConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"configs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrgConfigArgs"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"configs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"configs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationConfigsMutation, UpdateOrganizationConfigsMutationVariables>;
export const UpdateWhitelistedDomainsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWhitelistedDomains"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"domains"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWhitelistedDomains"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"domains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"domains"}}}]}]}}]} as unknown as DocumentNode<UpdateWhitelistedDomainsMutation, UpdateWhitelistedDomainsMutationVariables>;
export const AiProviderConnectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AIProviderConnections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiProviderConnections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"baseURL"}},{"kind":"Field","name":{"kind":"Name","value":"models"}},{"kind":"Field","name":{"kind":"Name","value":"defaultModel"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"hasApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}}]}}]}}]} as unknown as DocumentNode<AiProviderConnectionsQuery, AiProviderConnectionsQueryVariables>;
export const AiProviderPresetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AIProviderPresets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiProviderPresets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dialect"}},{"kind":"Field","name":{"kind":"Name","value":"baseURLHint"}},{"kind":"Field","name":{"kind":"Name","value":"defaultBaseURL"}},{"kind":"Field","name":{"kind":"Name","value":"requiresBaseURL"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedModels"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<AiProviderPresetsQuery, AiProviderPresetsQueryVariables>;
export const AiSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AISettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"timeoutMs"}},{"kind":"Field","name":{"kind":"Name","value":"maxRetries"}},{"kind":"Field","name":{"kind":"Name","value":"toolSearch"}},{"kind":"Field","name":{"kind":"Name","value":"promptCaching"}},{"kind":"Field","name":{"kind":"Name","value":"reasoningEffort"}},{"kind":"Field","name":{"kind":"Name","value":"acknowledgedAt"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}}]}}]}}]} as unknown as DocumentNode<AiSettingsQuery, AiSettingsQueryVariables>;
export const AiSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AISkills"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiSkills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<AiSkillsQuery, AiSkillsQueryVariables>;
export const AiStoredDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AIStoredData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiProviderConnections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiSkills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AiStoredDataQuery, AiStoredDataQueryVariables>;
export const GetInvitedOrganizationMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvitedOrganizationMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitedOrganizationMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteID"}},{"kind":"Field","name":{"kind":"Name","value":"adminEmail"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}}]}}]}}]} as unknown as DocumentNode<GetInvitedOrganizationMembersQuery, GetInvitedOrganizationMembersQueryVariables>;
export const GetOrganizationInviteDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationInviteDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrgInviteDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminEmail"}},{"kind":"Field","name":{"kind":"Name","value":"adminName"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationInviteDetailsQuery, GetOrganizationInviteDetailsQueryVariables>;
export const GetOrganizationMemberDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationMemberDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgMemberID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgMemberID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeUserUID"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"photoURL"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationMemberDetailsQuery, GetOrganizationMemberDetailsQueryVariables>;
export const GetOrganizationMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMembers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeUserUID"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>;
export const GetOrganizationMembersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationMembersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMembersCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationMembersCountQuery, GetOrganizationMembersCountQueryVariables>;
export const GetOrganizationTeamCollectionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeamCollectionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamCollectionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationTeamCollectionsCountQuery, GetOrganizationTeamCollectionsCountQueryVariables>;
export const GetOrganizationTeamInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeamInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamInvitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeRole"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationTeamInfoQuery, GetOrganizationTeamInfoQueryVariables>;
export const GetOrganizationTeamRequestsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeamRequestsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamRequestsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationTeamRequestsCountQuery, GetOrganizationTeamRequestsCountQueryVariables>;
export const GetOrganizationTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationTeamsQuery, GetOrganizationTeamsQueryVariables>;
export const GetOrganizationTeamsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationTeamsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationTeamsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<GetOrganizationTeamsCountQuery, GetOrganizationTeamsCountQueryVariables>;
export const UpdateOrganizationBillingCycleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganizationBillingCycle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgBillingCycle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationBillingCycle"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationBillingCycle"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgBillingCycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgBillingCycle"}}}]}]}}]} as unknown as DocumentNode<UpdateOrganizationBillingCycleMutation, UpdateOrganizationBillingCycleMutationVariables>;
export const UpdateOrganizationSeatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOrganizationSeats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seats"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationSeats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}},{"kind":"Argument","name":{"kind":"Name","value":"seats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seats"}}}]}]}}]} as unknown as DocumentNode<UpdateOrganizationSeatsMutation, UpdateOrganizationSeatsMutationVariables>;
export const OrganizationActiveBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationActiveBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationActiveBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<OrganizationActiveBannerQuery, OrganizationActiveBannerQueryVariables>;
export const OrganizationAllowedAuthProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationAllowedAuthProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationAllowedAuthProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<OrganizationAllowedAuthProvidersQuery, OrganizationAllowedAuthProvidersQueryVariables>;
export const OrganizationConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"names"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrgConfigEnum"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"names"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<OrganizationConfigsQuery, OrganizationConfigsQueryVariables>;
export const OrganizationWorkingBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationWorkingBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationWorkingBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<OrganizationWorkingBannerQuery, OrganizationWorkingBannerQueryVariables>;
export const OrganizationMemberAddedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"OrganizationMemberAdded"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationMemberAdded"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUID"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeUserUID"}},{"kind":"Field","name":{"kind":"Name","value":"lastActiveOn"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}}]}}]}}]} as unknown as DocumentNode<OrganizationMemberAddedSubscription, OrganizationMemberAddedSubscriptionVariables>;
export const AcceptTeamInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptTeamInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptTeamInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"photoURL"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<AcceptTeamInvitationMutation, AcceptTeamInvitationMutationVariables>;
export const CreateMockServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMockServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMockServerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMockServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlPathBased"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlDomainBased"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceType"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceID"}},{"kind":"Field","name":{"kind":"Name","value":"delayInMs"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMockServerMutation, CreateMockServerMutationVariables>;
export const CreatePublishedDocDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePublishedDoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePublishedDocsArgs"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPublishedDoc"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"autoSync"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceType"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceID"}}]}}]}}]} as unknown as DocumentNode<CreatePublishedDocMutation, CreatePublishedDocMutationVariables>;
export const CreateShortcodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShortcode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"properties"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShortcode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}},{"kind":"Argument","name":{"kind":"Name","value":"properties"},"value":{"kind":"Variable","name":{"kind":"Name","value":"properties"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"request"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}}]}}]}}]} as unknown as DocumentNode<CreateShortcodeMutation, CreateShortcodeMutationVariables>;
export const CreateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"photoURL"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRole"}},{"kind":"Field","name":{"kind":"Name","value":"ownersCount"}},{"kind":"Field","name":{"kind":"Name","value":"editorsCount"}},{"kind":"Field","name":{"kind":"Name","value":"viewersCount"}}]}}]}}]} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const CreateTeamInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeamInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteeRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TeamMemberRole"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTeamInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteeRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteeRole"}}},{"kind":"Argument","name":{"kind":"Name","value":"inviteeEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteeEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamID"}},{"kind":"Field","name":{"kind":"Name","value":"creatorUid"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeRole"}}]}}]}}]} as unknown as DocumentNode<CreateTeamInvitationMutation, CreateTeamInvitationMutationVariables>;
export const DeleteMockServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMockServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMockServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<DeleteMockServerMutation, DeleteMockServerMutationVariables>;
export const DeleteMockServerLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMockServerLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMockServerLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"logID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<DeleteMockServerLogMutation, DeleteMockServerLogMutationVariables>;
export const DeletePublishedDocDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePublishedDoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePublishedDoc"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}]}]}}]} as unknown as DocumentNode<DeletePublishedDocMutation, DeletePublishedDocMutationVariables>;
export const InitiateOrganizationPurchaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"initiateOrganizationPurchase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationDomain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationSeats"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationMetadata"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationBillingCycle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationBillingCycle"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationTier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationTier"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateOrganizationPurchase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationName"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationDomain"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationSeats"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationSeats"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationMetadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationMetadata"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationBillingCycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationBillingCycle"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationTier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationTier"}}}]}]}}]} as unknown as DocumentNode<InitiateOrganizationPurchaseMutation, InitiateOrganizationPurchaseMutationVariables>;
export const UpdateMockServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMockServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMockServerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMockServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlPathBased"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlDomainBased"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceType"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceID"}},{"kind":"Field","name":{"kind":"Name","value":"delayInMs"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMockServerMutation, UpdateMockServerMutationVariables>;
export const UpdatePublishedDocDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePublishedDoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePublishedDocsArgs"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePublishedDoc"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"autoSync"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}}]}}]}}]} as unknown as DocumentNode<UpdatePublishedDocMutation, UpdatePublishedDocMutationVariables>;
export const UpdateUserGlobalEnvironmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserGlobalEnvironment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variables"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserGlobalEnvironment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"variables"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variables"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userUid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"variables"}},{"kind":"Field","name":{"kind":"Name","value":"isGlobal"}}]}}]}}]} as unknown as DocumentNode<UpdateUserGlobalEnvironmentMutation, UpdateUserGlobalEnvironmentMutationVariables>;
export const AiChatAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AIChatAvailability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiChatEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"aiChatModelOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectionID"}},{"kind":"Field","name":{"kind":"Name","value":"connectionLabel"}},{"kind":"Field","name":{"kind":"Name","value":"preset"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiChatSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}}]} as unknown as DocumentNode<AiChatAvailabilityQuery, AiChatAvailabilityQueryVariables>;
export const GetInviteDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInviteDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteID"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"inviteeRole"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetInviteDetailsQuery, GetInviteDetailsQueryVariables>;
export const GetMockServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMockServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mockServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlPathBased"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlDomainBased"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceType"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceID"}},{"kind":"Field","name":{"kind":"Name","value":"delayInMs"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetMockServerQuery, GetMockServerQueryVariables>;
export const GetMockServerLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMockServerLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mockServerID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mockServerLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mockServerID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mockServerID"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mockServerID"}},{"kind":"Field","name":{"kind":"Name","value":"requestMethod"}},{"kind":"Field","name":{"kind":"Name","value":"requestPath"}},{"kind":"Field","name":{"kind":"Name","value":"requestHeaders"}},{"kind":"Field","name":{"kind":"Name","value":"requestBody"}},{"kind":"Field","name":{"kind":"Name","value":"requestQuery"}},{"kind":"Field","name":{"kind":"Name","value":"responseStatus"}},{"kind":"Field","name":{"kind":"Name","value":"responseHeaders"}},{"kind":"Field","name":{"kind":"Name","value":"responseBody"}},{"kind":"Field","name":{"kind":"Name","value":"responseTime"}},{"kind":"Field","name":{"kind":"Name","value":"ipAddress"}},{"kind":"Field","name":{"kind":"Name","value":"userAgent"}},{"kind":"Field","name":{"kind":"Name","value":"executedAt"}}]}}]}}]} as unknown as DocumentNode<GetMockServerLogsQuery, GetMockServerLogsQueryVariables>;
export const GetMyMockServersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyMockServers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myMockServers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlPathBased"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlDomainBased"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceType"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceID"}},{"kind":"Field","name":{"kind":"Name","value":"delayInMs"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyMockServersQuery, GetMyMockServersQueryVariables>;
export const GetMyOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}},{"kind":"Field","name":{"kind":"Name","value":"orgDomain"}},{"kind":"Field","name":{"kind":"Name","value":"orgStatus"}},{"kind":"Field","name":{"kind":"Name","value":"orgLogo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"invitedOn"}},{"kind":"Field","name":{"kind":"Name","value":"membershipID"}}]}}]}}]} as unknown as DocumentNode<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>;
export const GetUserShortcodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserShortcodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myShortcodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"request"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}}]}}]}}]} as unknown as DocumentNode<GetUserShortcodesQuery, GetUserShortcodesQueryVariables>;
export const GetMyTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"myRole"}},{"kind":"Field","name":{"kind":"Name","value":"ownersCount"}},{"kind":"Field","name":{"kind":"Name","value":"orgDomain"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}},{"kind":"Field","name":{"kind":"Name","value":"teamMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipID"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"photoURL"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyTeamsQuery, GetMyTeamsQueryVariables>;
export const GetOrganizationInfoByDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationInfoByDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgDomain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationByDomainV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgDomain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationInfoByDomainQuery, GetOrganizationInfoByDomainQueryVariables>;
export const GetOrganizationInfoByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationInfoByID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgID"}},{"kind":"Field","name":{"kind":"Name","value":"orgName"}},{"kind":"Field","name":{"kind":"Name","value":"orgDomain"}},{"kind":"Field","name":{"kind":"Name","value":"orgLogo"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"seats"}},{"kind":"Field","name":{"kind":"Name","value":"orgMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"tier"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postal_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"billingCycle"}},{"kind":"Field","name":{"kind":"Name","value":"nextBillingDate"}},{"kind":"Field","name":{"kind":"Name","value":"orgStatus"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationInfoByIdQuery, GetOrganizationInfoByIdQueryVariables>;
export const GetTeamMockServersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamMockServers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMockServers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subdomain"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlPathBased"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrlDomainBased"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceType"}},{"kind":"Field","name":{"kind":"Name","value":"workspaceID"}},{"kind":"Field","name":{"kind":"Name","value":"delayInMs"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamMockServersQuery, GetTeamMockServersQueryVariables>;
export const PublishedDocDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublishedDoc"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishedDoc"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"autoSync"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"environmentVariables"}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"photoURL"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<PublishedDocQuery, PublishedDocQueryVariables>;
export const TeamPublishedDocsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamPublishedDocsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamPublishedDocsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamID"}}},{"kind":"Argument","name":{"kind":"Name","value":"collectionID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionID"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"autoSync"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"documentTree"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}}]}}]}}]} as unknown as DocumentNode<TeamPublishedDocsListQuery, TeamPublishedDocsListQueryVariables>;
export const UserPublishedDocsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPublishedDocsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPublishedDocsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orgID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"autoSync"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"documentTree"}},{"kind":"Field","name":{"kind":"Name","value":"environmentName"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdOn"}},{"kind":"Field","name":{"kind":"Name","value":"updatedOn"}}]}}]}}]} as unknown as DocumentNode<UserPublishedDocsListQuery, UserPublishedDocsListQueryVariables>;
export type WithTypename<T extends { __typename?: any }> = Partial<T> & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  AIChatModelOption?: (data: WithTypename<AiChatModelOption>) => null | string,
  AIProviderConnection?: (data: WithTypename<AiProviderConnection>) => null | string,
  AIProviderPreset?: (data: WithTypename<AiProviderPreset>) => null | string,
  AIProviderTestResult?: (data: WithTypename<AiProviderTestResult>) => null | string,
  AISettings?: (data: WithTypename<AiSettings>) => null | string,
  AISkill?: (data: WithTypename<AiSkill>) => null | string,
  CollectionReorderData?: (data: WithTypename<CollectionReorderData>) => null | string,
  CreateOrganizationTokenResponse?: (data: WithTypename<CreateOrganizationTokenResponse>) => null | string,
  DowngradeImpact?: (data: WithTypename<DowngradeImpact>) => null | string,
  InvitedUser?: (data: WithTypename<InvitedUser>) => null | string,
  MockServer?: (data: WithTypename<MockServer>) => null | string,
  MockServerCollection?: (data: WithTypename<MockServerCollection>) => null | string,
  MockServerLog?: (data: WithTypename<MockServerLog>) => null | string,
  OrgAuthProviderStatus?: (data: WithTypename<OrgAuthProviderStatus>) => null | string,
  OrgConfig?: (data: WithTypename<OrgConfig>) => null | string,
  Organization?: (data: WithTypename<Organization>) => null | string,
  OrganizationBanner?: (data: WithTypename<OrganizationBanner>) => null | string,
  OrganizationBillingAddress?: (data: WithTypename<OrganizationBillingAddress>) => null | string,
  OrganizationMember?: (data: WithTypename<OrganizationMember>) => null | string,
  OrganizationScimSettings?: (data: WithTypename<OrganizationScimSettings>) => null | string,
  OrganizationSummary?: (data: WithTypename<OrganizationSummary>) => null | string,
  OrganizationToken?: (data: WithTypename<OrganizationToken>) => null | string,
  PendingTierChange?: (data: WithTypename<PendingTierChange>) => null | string,
  PublishedDocs?: (data: WithTypename<PublishedDocs>) => null | string,
  PublishedDocsCollection?: (data: WithTypename<PublishedDocsCollection>) => null | string,
  PublishedDocsVersion?: (data: WithTypename<PublishedDocsVersion>) => null | string,
  RequestReorderData?: (data: WithTypename<RequestReorderData>) => null | string,
  Shortcode?: (data: WithTypename<Shortcode>) => null | string,
  Team?: (data: WithTypename<Team>) => null | string,
  TeamCollection?: (data: WithTypename<TeamCollection>) => null | string,
  TeamEnvironment?: (data: WithTypename<TeamEnvironment>) => null | string,
  TeamInvitation?: (data: WithTypename<TeamInvitation>) => null | string,
  TeamMember?: (data: WithTypename<TeamMember>) => null | string,
  TeamRequest?: (data: WithTypename<TeamRequest>) => null | string,
  TierChangePreview?: (data: WithTypename<TierChangePreview>) => null | string,
  TierChangeResult?: (data: WithTypename<TierChangeResult>) => null | string,
  User?: (data: WithTypename<User>) => null | string,
  UserCollection?: (data: WithTypename<UserCollection>) => null | string,
  UserCollectionDuplicatedData?: (data: WithTypename<UserCollectionDuplicatedData>) => null | string,
  UserCollectionExportJSONData?: (data: WithTypename<UserCollectionExportJsonData>) => null | string,
  UserCollectionOrderUpdatedData?: (data: WithTypename<UserCollectionOrderUpdatedData>) => null | string,
  UserCollectionRemovedData?: (data: WithTypename<UserCollectionRemovedData>) => null | string,
  UserEnvironment?: (data: WithTypename<UserEnvironment>) => null | string,
  UserHistory?: (data: WithTypename<UserHistory>) => null | string,
  UserHistoryDeletedManyData?: (data: WithTypename<UserHistoryDeletedManyData>) => null | string,
  UserOrganizationMembership?: (data: WithTypename<UserOrganizationMembership>) => null | string,
  UserRequest?: (data: WithTypename<UserRequest>) => null | string,
  UserRequestReorderData?: (data: WithTypename<UserRequestReorderData>) => null | string,
  UserSettings?: (data: WithTypename<UserSettings>) => null | string
}

export type GraphCacheResolvers = {
  Query?: {
    aiChatEnabled?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Scalars['Boolean'] | string>,
    aiChatModelOptions?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<AiChatModelOption> | string>>,
    aiChatSkills?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<AiSkill> | string>>,
    aiProviderConnections?: GraphCacheResolver<WithTypename<Query>, QueryAiProviderConnectionsArgs, Array<WithTypename<AiProviderConnection> | string>>,
    aiProviderPresets?: GraphCacheResolver<WithTypename<Query>, QueryAiProviderPresetsArgs, Array<WithTypename<AiProviderPreset> | string>>,
    aiSettings?: GraphCacheResolver<WithTypename<Query>, QueryAiSettingsArgs, WithTypename<AiSettings> | string>,
    aiSkills?: GraphCacheResolver<WithTypename<Query>, QueryAiSkillsArgs, Array<WithTypename<AiSkill> | string>>,
    collection?: GraphCacheResolver<WithTypename<Query>, QueryCollectionArgs, WithTypename<TeamCollection> | string>,
    collectionsOfTeam?: GraphCacheResolver<WithTypename<Query>, QueryCollectionsOfTeamArgs, Array<WithTypename<TeamCollection> | string>>,
    exportCollectionToJSON?: GraphCacheResolver<WithTypename<Query>, QueryExportCollectionToJsonArgs, Scalars['String'] | string>,
    exportCollectionsToJSON?: GraphCacheResolver<WithTypename<Query>, QueryExportCollectionsToJsonArgs, Scalars['String'] | string>,
    exportUserCollectionToJSON?: GraphCacheResolver<WithTypename<Query>, QueryExportUserCollectionToJsonArgs, Scalars['String'] | string>,
    exportUserCollectionsToJSON?: GraphCacheResolver<WithTypename<Query>, QueryExportUserCollectionsToJsonArgs, WithTypename<UserCollectionExportJsonData> | string>,
    getOrgInviteDetails?: GraphCacheResolver<WithTypename<Query>, QueryGetOrgInviteDetailsArgs, WithTypename<InvitedUser> | string>,
    invitedOrganizationMembers?: GraphCacheResolver<WithTypename<Query>, QueryInvitedOrganizationMembersArgs, Array<WithTypename<InvitedUser> | string>>,
    me?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<User> | string>,
    mockServer?: GraphCacheResolver<WithTypename<Query>, QueryMockServerArgs, WithTypename<MockServer> | string>,
    mockServerLogs?: GraphCacheResolver<WithTypename<Query>, QueryMockServerLogsArgs, Array<WithTypename<MockServerLog> | string>>,
    myMockServers?: GraphCacheResolver<WithTypename<Query>, QueryMyMockServersArgs, Array<WithTypename<MockServer> | string>>,
    myOrganizations?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<UserOrganizationMembership> | string>>,
    myShortcodes?: GraphCacheResolver<WithTypename<Query>, QueryMyShortcodesArgs, Array<WithTypename<Shortcode> | string>>,
    myTeams?: GraphCacheResolver<WithTypename<Query>, QueryMyTeamsArgs, Array<WithTypename<Team> | string>>,
    organization?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationArgs, WithTypename<Organization> | string>,
    organizationActiveBanner?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationActiveBannerArgs, WithTypename<OrganizationBanner> | string>,
    organizationAllowedAuthProviders?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, Array<WithTypename<OrgAuthProviderStatus> | string>>,
    organizationByDomain?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationByDomainArgs, Scalars['String'] | string>,
    organizationByDomainV2?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationByDomainV2Args, WithTypename<OrganizationSummary> | string>,
    organizationConfigs?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationConfigsArgs, Array<WithTypename<OrgConfig> | string>>,
    organizationMember?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationMemberArgs, WithTypename<OrganizationMember> | string>,
    organizationMembers?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationMembersArgs, Array<WithTypename<OrganizationMember> | string>>,
    organizationMembersCount?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationMembersCountArgs, Scalars['Float'] | string>,
    organizationPendingTierChange?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationPendingTierChangeArgs, WithTypename<PendingTierChange> | string>,
    organizationScimSettings?: GraphCacheResolver<WithTypename<Query>, Record<string, never>, WithTypename<OrganizationScimSettings> | string>,
    organizationTeamCollectionsCount?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamCollectionsCountArgs, Scalars['Float'] | string>,
    organizationTeamInfo?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamInfoArgs, WithTypename<Team> | string>,
    organizationTeamRequestsCount?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamRequestsCountArgs, Scalars['Float'] | string>,
    organizationTeams?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamsArgs, Array<WithTypename<Team> | string>>,
    organizationTeamsCount?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTeamsCountArgs, Scalars['Float'] | string>,
    organizationTokens?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationTokensArgs, Array<WithTypename<OrganizationToken> | string>>,
    organizationWorkingBanner?: GraphCacheResolver<WithTypename<Query>, QueryOrganizationWorkingBannerArgs, WithTypename<OrganizationBanner> | string>,
    previewOrganizationTierChange?: GraphCacheResolver<WithTypename<Query>, QueryPreviewOrganizationTierChangeArgs, WithTypename<TierChangePreview> | string>,
    publishedDoc?: GraphCacheResolver<WithTypename<Query>, QueryPublishedDocArgs, WithTypename<PublishedDocs> | string>,
    request?: GraphCacheResolver<WithTypename<Query>, QueryRequestArgs, WithTypename<TeamRequest> | string>,
    requestsInCollection?: GraphCacheResolver<WithTypename<Query>, QueryRequestsInCollectionArgs, Array<WithTypename<TeamRequest> | string>>,
    rootCollectionsOfTeam?: GraphCacheResolver<WithTypename<Query>, QueryRootCollectionsOfTeamArgs, Array<WithTypename<TeamCollection> | string>>,
    rootGQLUserCollections?: GraphCacheResolver<WithTypename<Query>, QueryRootGqlUserCollectionsArgs, Array<WithTypename<UserCollection> | string>>,
    rootRESTUserCollections?: GraphCacheResolver<WithTypename<Query>, QueryRootRestUserCollectionsArgs, Array<WithTypename<UserCollection> | string>>,
    searchForRequest?: GraphCacheResolver<WithTypename<Query>, QuerySearchForRequestArgs, Array<WithTypename<TeamRequest> | string>>,
    shortcode?: GraphCacheResolver<WithTypename<Query>, QueryShortcodeArgs, WithTypename<Shortcode> | string>,
    team?: GraphCacheResolver<WithTypename<Query>, QueryTeamArgs, WithTypename<Team> | string>,
    teamInvitation?: GraphCacheResolver<WithTypename<Query>, QueryTeamInvitationArgs, WithTypename<TeamInvitation> | string>,
    teamMockServers?: GraphCacheResolver<WithTypename<Query>, QueryTeamMockServersArgs, Array<WithTypename<MockServer> | string>>,
    teamPublishedDocsList?: GraphCacheResolver<WithTypename<Query>, QueryTeamPublishedDocsListArgs, Array<WithTypename<PublishedDocs> | string>>,
    user?: GraphCacheResolver<WithTypename<Query>, QueryUserArgs, WithTypename<User> | string>,
    userCollection?: GraphCacheResolver<WithTypename<Query>, QueryUserCollectionArgs, WithTypename<UserCollection> | string>,
    userGQLRequests?: GraphCacheResolver<WithTypename<Query>, QueryUserGqlRequestsArgs, Array<WithTypename<UserRequest> | string>>,
    userPublishedDocsList?: GraphCacheResolver<WithTypename<Query>, QueryUserPublishedDocsListArgs, Array<WithTypename<PublishedDocs> | string>>,
    userRESTRequests?: GraphCacheResolver<WithTypename<Query>, QueryUserRestRequestsArgs, Array<WithTypename<UserRequest> | string>>,
    userRequest?: GraphCacheResolver<WithTypename<Query>, QueryUserRequestArgs, WithTypename<UserRequest> | string>
  },
  AIChatModelOption?: {
    connectionID?: GraphCacheResolver<WithTypename<AiChatModelOption>, Record<string, never>, Scalars['ID'] | string>,
    connectionLabel?: GraphCacheResolver<WithTypename<AiChatModelOption>, Record<string, never>, Scalars['String'] | string>,
    isDefault?: GraphCacheResolver<WithTypename<AiChatModelOption>, Record<string, never>, Scalars['Boolean'] | string>,
    model?: GraphCacheResolver<WithTypename<AiChatModelOption>, Record<string, never>, Scalars['String'] | string>,
    preset?: GraphCacheResolver<WithTypename<AiChatModelOption>, Record<string, never>, Scalars['String'] | string>
  },
  AIProviderConnection?: {
    baseURL?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['String'] | string>,
    createdOn?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['DateTime'] | string>,
    defaultModel?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['String'] | string>,
    enabled?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['Boolean'] | string>,
    hasApiKey?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['ID'] | string>,
    isDefault?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['Boolean'] | string>,
    label?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['String'] | string>,
    models?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Array<Scalars['String'] | string>>,
    preset?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['String'] | string>,
    updatedOn?: GraphCacheResolver<WithTypename<AiProviderConnection>, Record<string, never>, Scalars['DateTime'] | string>
  },
  AIProviderPreset?: {
    baseURLHint?: GraphCacheResolver<WithTypename<AiProviderPreset>, Record<string, never>, Scalars['String'] | string>,
    defaultBaseURL?: GraphCacheResolver<WithTypename<AiProviderPreset>, Record<string, never>, Scalars['String'] | string>,
    dialect?: GraphCacheResolver<WithTypename<AiProviderPreset>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<AiProviderPreset>, Record<string, never>, Scalars['String'] | string>,
    requiresBaseURL?: GraphCacheResolver<WithTypename<AiProviderPreset>, Record<string, never>, Scalars['Boolean'] | string>,
    suggestedModels?: GraphCacheResolver<WithTypename<AiProviderPreset>, Record<string, never>, Array<Scalars['String'] | string>>,
    verified?: GraphCacheResolver<WithTypename<AiProviderPreset>, Record<string, never>, Scalars['Boolean'] | string>
  },
  AIProviderTestResult?: {
    detail?: GraphCacheResolver<WithTypename<AiProviderTestResult>, Record<string, never>, Scalars['String'] | string>,
    latencyMs?: GraphCacheResolver<WithTypename<AiProviderTestResult>, Record<string, never>, Scalars['Int'] | string>,
    model?: GraphCacheResolver<WithTypename<AiProviderTestResult>, Record<string, never>, Scalars['String'] | string>,
    ok?: GraphCacheResolver<WithTypename<AiProviderTestResult>, Record<string, never>, Scalars['Boolean'] | string>,
    reason?: GraphCacheResolver<WithTypename<AiProviderTestResult>, Record<string, never>, Scalars['String'] | string>
  },
  AISettings?: {
    acknowledgedAt?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['DateTime'] | string>,
    editable?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['Boolean'] | string>,
    enabled?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['Boolean'] | string>,
    maxRetries?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['Int'] | string>,
    promptCaching?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['Boolean'] | string>,
    reasoningEffort?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['String'] | string>,
    timeoutMs?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['Int'] | string>,
    toolSearch?: GraphCacheResolver<WithTypename<AiSettings>, Record<string, never>, Scalars['Boolean'] | string>
  },
  AISkill?: {
    createdOn?: GraphCacheResolver<WithTypename<AiSkill>, Record<string, never>, Scalars['DateTime'] | string>,
    description?: GraphCacheResolver<WithTypename<AiSkill>, Record<string, never>, Scalars['String'] | string>,
    enabled?: GraphCacheResolver<WithTypename<AiSkill>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<AiSkill>, Record<string, never>, Scalars['ID'] | string>,
    prompt?: GraphCacheResolver<WithTypename<AiSkill>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<AiSkill>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<AiSkill>, Record<string, never>, Scalars['String'] | string>,
    updatedOn?: GraphCacheResolver<WithTypename<AiSkill>, Record<string, never>, Scalars['DateTime'] | string>
  },
  CollectionReorderData?: {
    collection?: GraphCacheResolver<WithTypename<CollectionReorderData>, Record<string, never>, WithTypename<TeamCollection> | string>,
    nextCollection?: GraphCacheResolver<WithTypename<CollectionReorderData>, Record<string, never>, WithTypename<TeamCollection> | string>
  },
  CreateOrganizationTokenResponse?: {
    info?: GraphCacheResolver<WithTypename<CreateOrganizationTokenResponse>, Record<string, never>, WithTypename<OrganizationToken> | string>,
    token?: GraphCacheResolver<WithTypename<CreateOrganizationTokenResponse>, Record<string, never>, Scalars['String'] | string>
  },
  DowngradeImpact?: {
    activeTokenCount?: GraphCacheResolver<WithTypename<DowngradeImpact>, Record<string, never>, Scalars['Int'] | string>,
    scimEnabled?: GraphCacheResolver<WithTypename<DowngradeImpact>, Record<string, never>, Scalars['Boolean'] | string>,
    ssoMemberCount?: GraphCacheResolver<WithTypename<DowngradeImpact>, Record<string, never>, Scalars['Int'] | string>
  },
  InvitedUser?: {
    adminEmail?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['String'] | string>,
    adminName?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['String'] | string>,
    adminUid?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['ID'] | string>,
    inviteID?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['ID'] | string>,
    invitedOn?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['DateTime'] | string>,
    inviteeEmail?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['ID'] | string>,
    orgName?: GraphCacheResolver<WithTypename<InvitedUser>, Record<string, never>, Scalars['String'] | string>
  },
  MockServer?: {
    collection?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, WithTypename<MockServerCollection> | string>,
    createdOn?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['DateTime'] | string>,
    creator?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, WithTypename<User> | string>,
    delayInMs?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['Float'] | string>,
    id?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['ID'] | string>,
    isActive?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['Boolean'] | string>,
    isPublic?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['String'] | string>,
    serverUrlDomainBased?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['String'] | string>,
    serverUrlPathBased?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['String'] | string>,
    subdomain?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['String'] | string>,
    updatedOn?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['DateTime'] | string>,
    workspaceID?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, Scalars['String'] | string>,
    workspaceType?: GraphCacheResolver<WithTypename<MockServer>, Record<string, never>, WorkspaceType | string>
  },
  MockServerCollection?: {
    id?: GraphCacheResolver<WithTypename<MockServerCollection>, Record<string, never>, Scalars['ID'] | string>,
    title?: GraphCacheResolver<WithTypename<MockServerCollection>, Record<string, never>, Scalars['String'] | string>
  },
  MockServerLog?: {
    executedAt?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['ID'] | string>,
    ipAddress?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>,
    mockServerID?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['ID'] | string>,
    requestBody?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>,
    requestHeaders?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>,
    requestMethod?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>,
    requestPath?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>,
    requestQuery?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>,
    responseBody?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>,
    responseHeaders?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>,
    responseStatus?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['Float'] | string>,
    responseTime?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['Float'] | string>,
    userAgent?: GraphCacheResolver<WithTypename<MockServerLog>, Record<string, never>, Scalars['String'] | string>
  },
  OrgAuthProviderStatus?: {
    provider?: GraphCacheResolver<WithTypename<OrgAuthProviderStatus>, Record<string, never>, AuthProvider | string>,
    status?: GraphCacheResolver<WithTypename<OrgAuthProviderStatus>, Record<string, never>, ServiceStatus | string>
  },
  OrgConfig?: {
    name?: GraphCacheResolver<WithTypename<OrgConfig>, Record<string, never>, OrgConfigEnum | string>,
    value?: GraphCacheResolver<WithTypename<OrgConfig>, Record<string, never>, Scalars['String'] | string>
  },
  Organization?: {
    billingAddress?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, WithTypename<OrganizationBillingAddress> | string>,
    billingCycle?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, OrganizationBillingCycle | string>,
    billingEmail?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    checkoutUrl?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    createdOn?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['DateTime'] | string>,
    nextBillingDate?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['Float'] | string>,
    orgDomain?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['ID'] | string>,
    orgLogo?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    orgMetadata?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    orgName?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['String'] | string>,
    orgStatus?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, OrganizationStatus | string>,
    seats?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, Scalars['Float'] | string>,
    tier?: GraphCacheResolver<WithTypename<Organization>, Record<string, never>, OrganizationTier | string>
  },
  OrganizationBanner?: {
    createdOn?: GraphCacheResolver<WithTypename<OrganizationBanner>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<OrganizationBanner>, Record<string, never>, Scalars['ID'] | string>,
    message?: GraphCacheResolver<WithTypename<OrganizationBanner>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<OrganizationBanner>, Record<string, never>, Scalars['ID'] | string>,
    status?: GraphCacheResolver<WithTypename<OrganizationBanner>, Record<string, never>, BannerStatus | string>,
    type?: GraphCacheResolver<WithTypename<OrganizationBanner>, Record<string, never>, BannerType | string>
  },
  OrganizationBillingAddress?: {
    city?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    country?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    line1?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    line2?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    postal_code?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>,
    state?: GraphCacheResolver<WithTypename<OrganizationBillingAddress>, Record<string, never>, Scalars['String'] | string>
  },
  OrganizationMember?: {
    createdOn?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['ID'] | string>,
    invitedOn?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['DateTime'] | string>,
    inviteeUserUID?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['ID'] | string>,
    isAdmin?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['Boolean'] | string>,
    lastActiveOn?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['DateTime'] | string>,
    membershipStatus?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, OrganizationMembershipStatus | string>,
    orgID?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>,
    photoURL?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>,
    userEmail?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>,
    userName?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>,
    userUID?: GraphCacheResolver<WithTypename<OrganizationMember>, Record<string, never>, Scalars['String'] | string>
  },
  OrganizationScimSettings?: {
    baseUrl?: GraphCacheResolver<WithTypename<OrganizationScimSettings>, Record<string, never>, Scalars['String'] | string>,
    enabled?: GraphCacheResolver<WithTypename<OrganizationScimSettings>, Record<string, never>, Scalars['Boolean'] | string>
  },
  OrganizationSummary?: {
    orgID?: GraphCacheResolver<WithTypename<OrganizationSummary>, Record<string, never>, Scalars['ID'] | string>,
    tier?: GraphCacheResolver<WithTypename<OrganizationSummary>, Record<string, never>, OrganizationTier | string>
  },
  OrganizationToken?: {
    createdOn?: GraphCacheResolver<WithTypename<OrganizationToken>, Record<string, never>, Scalars['DateTime'] | string>,
    expiresOn?: GraphCacheResolver<WithTypename<OrganizationToken>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<OrganizationToken>, Record<string, never>, Scalars['ID'] | string>,
    label?: GraphCacheResolver<WithTypename<OrganizationToken>, Record<string, never>, Scalars['String'] | string>,
    lastUsedOn?: GraphCacheResolver<WithTypename<OrganizationToken>, Record<string, never>, Scalars['DateTime'] | string>
  },
  PendingTierChange?: {
    effectiveAt?: GraphCacheResolver<WithTypename<PendingTierChange>, Record<string, never>, Scalars['DateTime'] | string>,
    tier?: GraphCacheResolver<WithTypename<PendingTierChange>, Record<string, never>, OrganizationTier | string>
  },
  PublishedDocs?: {
    autoSync?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['Boolean'] | string>,
    collection?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, WithTypename<PublishedDocsCollection> | string>,
    createdOn?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['DateTime'] | string>,
    creator?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, WithTypename<User> | string>,
    documentTree?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    environmentName?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    environmentVariables?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['ID'] | string>,
    metadata?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    slug?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['ID'] | string>,
    title?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    updatedOn?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['DateTime'] | string>,
    url?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    version?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    versions?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Array<WithTypename<PublishedDocsVersion> | string>>,
    workspaceID?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>,
    workspaceType?: GraphCacheResolver<WithTypename<PublishedDocs>, Record<string, never>, Scalars['String'] | string>
  },
  PublishedDocsCollection?: {
    id?: GraphCacheResolver<WithTypename<PublishedDocsCollection>, Record<string, never>, Scalars['ID'] | string>,
    title?: GraphCacheResolver<WithTypename<PublishedDocsCollection>, Record<string, never>, Scalars['String'] | string>
  },
  PublishedDocsVersion?: {
    autoSync?: GraphCacheResolver<WithTypename<PublishedDocsVersion>, Record<string, never>, Scalars['Boolean'] | string>,
    id?: GraphCacheResolver<WithTypename<PublishedDocsVersion>, Record<string, never>, Scalars['ID'] | string>,
    slug?: GraphCacheResolver<WithTypename<PublishedDocsVersion>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<PublishedDocsVersion>, Record<string, never>, Scalars['String'] | string>,
    url?: GraphCacheResolver<WithTypename<PublishedDocsVersion>, Record<string, never>, Scalars['String'] | string>,
    version?: GraphCacheResolver<WithTypename<PublishedDocsVersion>, Record<string, never>, Scalars['String'] | string>
  },
  RequestReorderData?: {
    nextRequest?: GraphCacheResolver<WithTypename<RequestReorderData>, Record<string, never>, WithTypename<TeamRequest> | string>,
    request?: GraphCacheResolver<WithTypename<RequestReorderData>, Record<string, never>, WithTypename<TeamRequest> | string>
  },
  Shortcode?: {
    createdOn?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['ID'] | string>,
    orgID?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['String'] | string>,
    properties?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['String'] | string>,
    request?: GraphCacheResolver<WithTypename<Shortcode>, Record<string, never>, Scalars['String'] | string>
  },
  Team?: {
    editorsCount?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['ID'] | string>,
    members?: GraphCacheResolver<WithTypename<Team>, TeamMembersArgs, Array<WithTypename<TeamMember> | string>>,
    myRole?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, TeamMemberRole | string>,
    name?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    orgDomain?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    orgID?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    orgName?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    ownersCount?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['Int'] | string>,
    teamEnvironments?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Array<WithTypename<TeamEnvironment> | string>>,
    teamInvitations?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Array<WithTypename<TeamInvitation> | string>>,
    teamMembers?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Array<WithTypename<TeamMember> | string>>,
    viewersCount?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['Int'] | string>
  },
  TeamCollection?: {
    children?: GraphCacheResolver<WithTypename<TeamCollection>, TeamCollectionChildrenArgs, Array<WithTypename<TeamCollection> | string>>,
    data?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, Scalars['ID'] | string>,
    parent?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, WithTypename<TeamCollection> | string>,
    team?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, WithTypename<Team> | string>,
    title?: GraphCacheResolver<WithTypename<TeamCollection>, Record<string, never>, Scalars['String'] | string>
  },
  TeamEnvironment?: {
    id?: GraphCacheResolver<WithTypename<TeamEnvironment>, Record<string, never>, Scalars['ID'] | string>,
    name?: GraphCacheResolver<WithTypename<TeamEnvironment>, Record<string, never>, Scalars['String'] | string>,
    teamID?: GraphCacheResolver<WithTypename<TeamEnvironment>, Record<string, never>, Scalars['ID'] | string>,
    variables?: GraphCacheResolver<WithTypename<TeamEnvironment>, Record<string, never>, Scalars['String'] | string>
  },
  TeamInvitation?: {
    creator?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, WithTypename<User> | string>,
    creatorUid?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, Scalars['ID'] | string>,
    id?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, Scalars['ID'] | string>,
    inviteeEmail?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, Scalars['ID'] | string>,
    inviteeRole?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, TeamMemberRole | string>,
    team?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, WithTypename<Team> | string>,
    teamID?: GraphCacheResolver<WithTypename<TeamInvitation>, Record<string, never>, Scalars['ID'] | string>
  },
  TeamMember?: {
    membershipID?: GraphCacheResolver<WithTypename<TeamMember>, Record<string, never>, Scalars['ID'] | string>,
    role?: GraphCacheResolver<WithTypename<TeamMember>, Record<string, never>, TeamMemberRole | string>,
    user?: GraphCacheResolver<WithTypename<TeamMember>, Record<string, never>, WithTypename<User> | string>
  },
  TeamRequest?: {
    collection?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, WithTypename<TeamCollection> | string>,
    collectionID?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['ID'] | string>,
    id?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['ID'] | string>,
    request?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['String'] | string>,
    team?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, WithTypename<Team> | string>,
    teamID?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['ID'] | string>,
    title?: GraphCacheResolver<WithTypename<TeamRequest>, Record<string, never>, Scalars['String'] | string>
  },
  TierChangePreview?: {
    amountDueNow?: GraphCacheResolver<WithTypename<TierChangePreview>, Record<string, never>, Scalars['Int'] | string>,
    currency?: GraphCacheResolver<WithTypename<TierChangePreview>, Record<string, never>, Scalars['String'] | string>,
    downgradeImpact?: GraphCacheResolver<WithTypename<TierChangePreview>, Record<string, never>, WithTypename<DowngradeImpact> | string>,
    effectiveAt?: GraphCacheResolver<WithTypename<TierChangePreview>, Record<string, never>, Scalars['DateTime'] | string>,
    nextPeriodAmount?: GraphCacheResolver<WithTypename<TierChangePreview>, Record<string, never>, Scalars['Int'] | string>,
    targetTier?: GraphCacheResolver<WithTypename<TierChangePreview>, Record<string, never>, OrganizationTier | string>
  },
  TierChangeResult?: {
    effectiveAt?: GraphCacheResolver<WithTypename<TierChangeResult>, Record<string, never>, Scalars['DateTime'] | string>,
    paymentURL?: GraphCacheResolver<WithTypename<TierChangeResult>, Record<string, never>, Scalars['String'] | string>,
    status?: GraphCacheResolver<WithTypename<TierChangeResult>, Record<string, never>, TierChangeStatus | string>
  },
  User?: {
    GQLHistory?: GraphCacheResolver<WithTypename<User>, UserGqlHistoryArgs, Array<WithTypename<UserHistory> | string>>,
    RESTHistory?: GraphCacheResolver<WithTypename<User>, UserRestHistoryArgs, Array<WithTypename<UserHistory> | string>>,
    displayName?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    email?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    environments?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Array<WithTypename<UserEnvironment> | string>>,
    globalEnvironments?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<UserEnvironment> | string>,
    photoURL?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['String'] | string>,
    settings?: GraphCacheResolver<WithTypename<User>, Record<string, never>, WithTypename<UserSettings> | string>,
    uid?: GraphCacheResolver<WithTypename<User>, Record<string, never>, Scalars['ID'] | string>
  },
  UserCollection?: {
    childrenGQL?: GraphCacheResolver<WithTypename<UserCollection>, UserCollectionChildrenGqlArgs, Array<WithTypename<UserCollection> | string>>,
    childrenREST?: GraphCacheResolver<WithTypename<UserCollection>, UserCollectionChildrenRestArgs, Array<WithTypename<UserCollection> | string>>,
    data?: GraphCacheResolver<WithTypename<UserCollection>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<UserCollection>, Record<string, never>, Scalars['ID'] | string>,
    parent?: GraphCacheResolver<WithTypename<UserCollection>, UserCollectionParentArgs, WithTypename<UserCollection> | string>,
    requests?: GraphCacheResolver<WithTypename<UserCollection>, UserCollectionRequestsArgs, Array<WithTypename<UserRequest> | string>>,
    title?: GraphCacheResolver<WithTypename<UserCollection>, Record<string, never>, Scalars['String'] | string>,
    type?: GraphCacheResolver<WithTypename<UserCollection>, Record<string, never>, ReqType | string>,
    user?: GraphCacheResolver<WithTypename<UserCollection>, Record<string, never>, WithTypename<User> | string>
  },
  UserCollectionDuplicatedData?: {
    childCollections?: GraphCacheResolver<WithTypename<UserCollectionDuplicatedData>, Record<string, never>, Scalars['String'] | string>,
    data?: GraphCacheResolver<WithTypename<UserCollectionDuplicatedData>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<UserCollectionDuplicatedData>, Record<string, never>, Scalars['ID'] | string>,
    parentID?: GraphCacheResolver<WithTypename<UserCollectionDuplicatedData>, Record<string, never>, Scalars['ID'] | string>,
    requests?: GraphCacheResolver<WithTypename<UserCollectionDuplicatedData>, Record<string, never>, Array<WithTypename<UserRequest> | string>>,
    title?: GraphCacheResolver<WithTypename<UserCollectionDuplicatedData>, Record<string, never>, Scalars['String'] | string>,
    type?: GraphCacheResolver<WithTypename<UserCollectionDuplicatedData>, Record<string, never>, ReqType | string>,
    userID?: GraphCacheResolver<WithTypename<UserCollectionDuplicatedData>, Record<string, never>, Scalars['String'] | string>
  },
  UserCollectionExportJSONData?: {
    collectionType?: GraphCacheResolver<WithTypename<UserCollectionExportJsonData>, Record<string, never>, ReqType | string>,
    exportedCollection?: GraphCacheResolver<WithTypename<UserCollectionExportJsonData>, Record<string, never>, Scalars['ID'] | string>
  },
  UserCollectionOrderUpdatedData?: {
    nextUserCollection?: GraphCacheResolver<WithTypename<UserCollectionOrderUpdatedData>, Record<string, never>, WithTypename<UserCollection> | string>,
    userCollection?: GraphCacheResolver<WithTypename<UserCollectionOrderUpdatedData>, Record<string, never>, WithTypename<UserCollection> | string>
  },
  UserCollectionRemovedData?: {
    id?: GraphCacheResolver<WithTypename<UserCollectionRemovedData>, Record<string, never>, Scalars['ID'] | string>,
    type?: GraphCacheResolver<WithTypename<UserCollectionRemovedData>, Record<string, never>, ReqType | string>
  },
  UserEnvironment?: {
    id?: GraphCacheResolver<WithTypename<UserEnvironment>, Record<string, never>, Scalars['ID'] | string>,
    isGlobal?: GraphCacheResolver<WithTypename<UserEnvironment>, Record<string, never>, Scalars['Boolean'] | string>,
    name?: GraphCacheResolver<WithTypename<UserEnvironment>, Record<string, never>, Scalars['String'] | string>,
    userUid?: GraphCacheResolver<WithTypename<UserEnvironment>, Record<string, never>, Scalars['ID'] | string>,
    variables?: GraphCacheResolver<WithTypename<UserEnvironment>, Record<string, never>, Scalars['String'] | string>
  },
  UserHistory?: {
    executedOn?: GraphCacheResolver<WithTypename<UserHistory>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<UserHistory>, Record<string, never>, Scalars['ID'] | string>,
    isStarred?: GraphCacheResolver<WithTypename<UserHistory>, Record<string, never>, Scalars['Boolean'] | string>,
    reqType?: GraphCacheResolver<WithTypename<UserHistory>, Record<string, never>, ReqType | string>,
    request?: GraphCacheResolver<WithTypename<UserHistory>, Record<string, never>, Scalars['String'] | string>,
    responseMetadata?: GraphCacheResolver<WithTypename<UserHistory>, Record<string, never>, Scalars['String'] | string>,
    userUid?: GraphCacheResolver<WithTypename<UserHistory>, Record<string, never>, Scalars['ID'] | string>
  },
  UserHistoryDeletedManyData?: {
    count?: GraphCacheResolver<WithTypename<UserHistoryDeletedManyData>, Record<string, never>, Scalars['Float'] | string>,
    reqType?: GraphCacheResolver<WithTypename<UserHistoryDeletedManyData>, Record<string, never>, ReqType | string>
  },
  UserOrganizationMembership?: {
    invitedOn?: GraphCacheResolver<WithTypename<UserOrganizationMembership>, Record<string, never>, Scalars['DateTime'] | string>,
    isAdmin?: GraphCacheResolver<WithTypename<UserOrganizationMembership>, Record<string, never>, Scalars['Boolean'] | string>,
    membershipID?: GraphCacheResolver<WithTypename<UserOrganizationMembership>, Record<string, never>, Scalars['ID'] | string>,
    membershipStatus?: GraphCacheResolver<WithTypename<UserOrganizationMembership>, Record<string, never>, OrganizationMembershipStatus | string>,
    organization?: GraphCacheResolver<WithTypename<UserOrganizationMembership>, Record<string, never>, WithTypename<Organization> | string>
  },
  UserRequest?: {
    collectionID?: GraphCacheResolver<WithTypename<UserRequest>, Record<string, never>, Scalars['ID'] | string>,
    createdOn?: GraphCacheResolver<WithTypename<UserRequest>, Record<string, never>, Scalars['DateTime'] | string>,
    id?: GraphCacheResolver<WithTypename<UserRequest>, Record<string, never>, Scalars['ID'] | string>,
    request?: GraphCacheResolver<WithTypename<UserRequest>, Record<string, never>, Scalars['String'] | string>,
    title?: GraphCacheResolver<WithTypename<UserRequest>, Record<string, never>, Scalars['String'] | string>,
    type?: GraphCacheResolver<WithTypename<UserRequest>, Record<string, never>, ReqType | string>,
    user?: GraphCacheResolver<WithTypename<UserRequest>, Record<string, never>, WithTypename<User> | string>
  },
  UserRequestReorderData?: {
    nextRequest?: GraphCacheResolver<WithTypename<UserRequestReorderData>, Record<string, never>, WithTypename<UserRequest> | string>,
    request?: GraphCacheResolver<WithTypename<UserRequestReorderData>, Record<string, never>, WithTypename<UserRequest> | string>
  },
  UserSettings?: {
    id?: GraphCacheResolver<WithTypename<UserSettings>, Record<string, never>, Scalars['ID'] | string>,
    properties?: GraphCacheResolver<WithTypename<UserSettings>, Record<string, never>, Scalars['String'] | string>,
    updatedOn?: GraphCacheResolver<WithTypename<UserSettings>, Record<string, never>, Scalars['DateTime'] | string>,
    userUid?: GraphCacheResolver<WithTypename<UserSettings>, Record<string, never>, Scalars['ID'] | string>
  }
};

export type GraphCacheOptimisticUpdaters = {
  acceptOrganizationInvitation?: GraphCacheOptimisticMutationResolver<MutationAcceptOrganizationInvitationArgs, WithTypename<OrganizationMember>>,
  acceptTeamInvitation?: GraphCacheOptimisticMutationResolver<MutationAcceptTeamInvitationArgs, WithTypename<TeamMember>>,
  addOrganizationMember?: GraphCacheOptimisticMutationResolver<MutationAddOrganizationMemberArgs, WithTypename<OrganizationMember>>,
  addTeamMemberByEmail?: GraphCacheOptimisticMutationResolver<MutationAddTeamMemberByEmailArgs, WithTypename<TeamMember>>,
  addUserToTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationAddUserToTeamByAdminArgs, WithTypename<TeamMember>>,
  cancelOrganizationSubscription?: GraphCacheOptimisticMutationResolver<MutationCancelOrganizationSubscriptionArgs, Scalars['Boolean']>,
  cancelScheduledTierChange?: GraphCacheOptimisticMutationResolver<MutationCancelScheduledTierChangeArgs, Scalars['Boolean']>,
  changeOrganizationTier?: GraphCacheOptimisticMutationResolver<MutationChangeOrganizationTierArgs, WithTypename<TierChangeResult>>,
  clearGlobalEnvironments?: GraphCacheOptimisticMutationResolver<MutationClearGlobalEnvironmentsArgs, WithTypename<UserEnvironment>>,
  createAIProviderConnection?: GraphCacheOptimisticMutationResolver<MutationCreateAiProviderConnectionArgs, WithTypename<AiProviderConnection>>,
  createAISkill?: GraphCacheOptimisticMutationResolver<MutationCreateAiSkillArgs, WithTypename<AiSkill>>,
  createChildCollection?: GraphCacheOptimisticMutationResolver<MutationCreateChildCollectionArgs, WithTypename<TeamCollection>>,
  createDuplicateEnvironment?: GraphCacheOptimisticMutationResolver<MutationCreateDuplicateEnvironmentArgs, WithTypename<TeamEnvironment>>,
  createGQLChildUserCollection?: GraphCacheOptimisticMutationResolver<MutationCreateGqlChildUserCollectionArgs, WithTypename<UserCollection>>,
  createGQLRootUserCollection?: GraphCacheOptimisticMutationResolver<MutationCreateGqlRootUserCollectionArgs, WithTypename<UserCollection>>,
  createGQLUserRequest?: GraphCacheOptimisticMutationResolver<MutationCreateGqlUserRequestArgs, WithTypename<UserRequest>>,
  createMockServer?: GraphCacheOptimisticMutationResolver<MutationCreateMockServerArgs, WithTypename<MockServer>>,
  createOrganizationBanner?: GraphCacheOptimisticMutationResolver<MutationCreateOrganizationBannerArgs, WithTypename<OrganizationBanner>>,
  createOrganizationToken?: GraphCacheOptimisticMutationResolver<MutationCreateOrganizationTokenArgs, WithTypename<CreateOrganizationTokenResponse>>,
  createPublishedDoc?: GraphCacheOptimisticMutationResolver<MutationCreatePublishedDocArgs, WithTypename<PublishedDocs>>,
  createRESTChildUserCollection?: GraphCacheOptimisticMutationResolver<MutationCreateRestChildUserCollectionArgs, WithTypename<UserCollection>>,
  createRESTRootUserCollection?: GraphCacheOptimisticMutationResolver<MutationCreateRestRootUserCollectionArgs, WithTypename<UserCollection>>,
  createRESTUserRequest?: GraphCacheOptimisticMutationResolver<MutationCreateRestUserRequestArgs, WithTypename<UserRequest>>,
  createRequestInCollection?: GraphCacheOptimisticMutationResolver<MutationCreateRequestInCollectionArgs, WithTypename<TeamRequest>>,
  createRootCollection?: GraphCacheOptimisticMutationResolver<MutationCreateRootCollectionArgs, WithTypename<TeamCollection>>,
  createShortcode?: GraphCacheOptimisticMutationResolver<MutationCreateShortcodeArgs, WithTypename<Shortcode>>,
  createTeam?: GraphCacheOptimisticMutationResolver<MutationCreateTeamArgs, WithTypename<Team>>,
  createTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationCreateTeamByAdminArgs, WithTypename<Team>>,
  createTeamEnvironment?: GraphCacheOptimisticMutationResolver<MutationCreateTeamEnvironmentArgs, WithTypename<TeamEnvironment>>,
  createTeamInvitation?: GraphCacheOptimisticMutationResolver<MutationCreateTeamInvitationArgs, WithTypename<TeamInvitation>>,
  createUserEnvironment?: GraphCacheOptimisticMutationResolver<MutationCreateUserEnvironmentArgs, WithTypename<UserEnvironment>>,
  createUserGlobalEnvironment?: GraphCacheOptimisticMutationResolver<MutationCreateUserGlobalEnvironmentArgs, WithTypename<UserEnvironment>>,
  createUserHistory?: GraphCacheOptimisticMutationResolver<MutationCreateUserHistoryArgs, WithTypename<UserHistory>>,
  createUserSettings?: GraphCacheOptimisticMutationResolver<MutationCreateUserSettingsArgs, WithTypename<UserSettings>>,
  deactivateOrganizationMember?: GraphCacheOptimisticMutationResolver<MutationDeactivateOrganizationMemberArgs, Scalars['Boolean']>,
  deleteAIProviderConnection?: GraphCacheOptimisticMutationResolver<MutationDeleteAiProviderConnectionArgs, Scalars['Boolean']>,
  deleteAISkill?: GraphCacheOptimisticMutationResolver<MutationDeleteAiSkillArgs, Scalars['Boolean']>,
  deleteAllUserHistory?: GraphCacheOptimisticMutationResolver<MutationDeleteAllUserHistoryArgs, WithTypename<UserHistoryDeletedManyData>>,
  deleteAllVariablesFromTeamEnvironment?: GraphCacheOptimisticMutationResolver<MutationDeleteAllVariablesFromTeamEnvironmentArgs, WithTypename<TeamEnvironment>>,
  deleteCollection?: GraphCacheOptimisticMutationResolver<MutationDeleteCollectionArgs, Scalars['Boolean']>,
  deleteMockServer?: GraphCacheOptimisticMutationResolver<MutationDeleteMockServerArgs, Scalars['Boolean']>,
  deleteMockServerLog?: GraphCacheOptimisticMutationResolver<MutationDeleteMockServerLogArgs, Scalars['Boolean']>,
  deletePublishedDoc?: GraphCacheOptimisticMutationResolver<MutationDeletePublishedDocArgs, Scalars['Boolean']>,
  deleteRequest?: GraphCacheOptimisticMutationResolver<MutationDeleteRequestArgs, Scalars['Boolean']>,
  deleteTeam?: GraphCacheOptimisticMutationResolver<MutationDeleteTeamArgs, Scalars['Boolean']>,
  deleteTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationDeleteTeamByAdminArgs, Scalars['Boolean']>,
  deleteTeamEnvironment?: GraphCacheOptimisticMutationResolver<MutationDeleteTeamEnvironmentArgs, Scalars['Boolean']>,
  deleteUser?: GraphCacheOptimisticMutationResolver<Record<string, never>, Scalars['Boolean']>,
  deleteUserCollection?: GraphCacheOptimisticMutationResolver<MutationDeleteUserCollectionArgs, Scalars['Boolean']>,
  deleteUserEnvironment?: GraphCacheOptimisticMutationResolver<MutationDeleteUserEnvironmentArgs, Scalars['Boolean']>,
  deleteUserEnvironments?: GraphCacheOptimisticMutationResolver<MutationDeleteUserEnvironmentsArgs, Scalars['Float']>,
  deleteUserRequest?: GraphCacheOptimisticMutationResolver<MutationDeleteUserRequestArgs, Scalars['Boolean']>,
  demoteOrganizationMembersAsAdmin?: GraphCacheOptimisticMutationResolver<MutationDemoteOrganizationMembersAsAdminArgs, Scalars['Boolean']>,
  duplicateTeamCollection?: GraphCacheOptimisticMutationResolver<MutationDuplicateTeamCollectionArgs, Scalars['Boolean']>,
  duplicateUserCollection?: GraphCacheOptimisticMutationResolver<MutationDuplicateUserCollectionArgs, WithTypename<UserCollectionExportJsonData>>,
  enableAndDisableOrganizationAuth?: GraphCacheOptimisticMutationResolver<MutationEnableAndDisableOrganizationAuthArgs, Array<WithTypename<OrgAuthProviderStatus>>>,
  importCollectionFromUserFirestore?: GraphCacheOptimisticMutationResolver<MutationImportCollectionFromUserFirestoreArgs, WithTypename<TeamCollection>>,
  importCollectionsFromJSON?: GraphCacheOptimisticMutationResolver<MutationImportCollectionsFromJsonArgs, Scalars['Boolean']>,
  importUserCollectionsFromJSON?: GraphCacheOptimisticMutationResolver<MutationImportUserCollectionsFromJsonArgs, WithTypename<UserCollectionExportJsonData>>,
  initiateOrganizationPurchase?: GraphCacheOptimisticMutationResolver<MutationInitiateOrganizationPurchaseArgs, Scalars['String']>,
  inviteNewUser?: GraphCacheOptimisticMutationResolver<MutationInviteNewUserArgs, WithTypename<InvitedUser>>,
  leaveTeam?: GraphCacheOptimisticMutationResolver<MutationLeaveTeamArgs, Scalars['Boolean']>,
  makeOrganizationMemberAnAdmin?: GraphCacheOptimisticMutationResolver<MutationMakeOrganizationMemberAnAdminArgs, WithTypename<OrganizationMember>>,
  makeOrganizationMembersAdmin?: GraphCacheOptimisticMutationResolver<MutationMakeOrganizationMembersAdminArgs, Scalars['Boolean']>,
  moveCollection?: GraphCacheOptimisticMutationResolver<MutationMoveCollectionArgs, WithTypename<TeamCollection>>,
  moveRequest?: GraphCacheOptimisticMutationResolver<MutationMoveRequestArgs, WithTypename<TeamRequest>>,
  moveUserCollection?: GraphCacheOptimisticMutationResolver<MutationMoveUserCollectionArgs, WithTypename<UserCollection>>,
  moveUserRequest?: GraphCacheOptimisticMutationResolver<MutationMoveUserRequestArgs, WithTypename<UserRequest>>,
  removeMemberFromTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationRemoveMemberFromTeamByAdminArgs, Scalars['Boolean']>,
  removeOrganizationMember?: GraphCacheOptimisticMutationResolver<MutationRemoveOrganizationMemberArgs, WithTypename<OrganizationMember>>,
  removeRequestFromHistory?: GraphCacheOptimisticMutationResolver<MutationRemoveRequestFromHistoryArgs, WithTypename<UserHistory>>,
  removeTeamMember?: GraphCacheOptimisticMutationResolver<MutationRemoveTeamMemberArgs, Scalars['Boolean']>,
  renameCollection?: GraphCacheOptimisticMutationResolver<MutationRenameCollectionArgs, WithTypename<TeamCollection>>,
  renameTeam?: GraphCacheOptimisticMutationResolver<MutationRenameTeamArgs, WithTypename<Team>>,
  renameTeamByAdmin?: GraphCacheOptimisticMutationResolver<MutationRenameTeamByAdminArgs, WithTypename<Team>>,
  replaceCollectionsWithJSON?: GraphCacheOptimisticMutationResolver<MutationReplaceCollectionsWithJsonArgs, Scalars['Boolean']>,
  revokeOrganizationMemberAdminAccess?: GraphCacheOptimisticMutationResolver<MutationRevokeOrganizationMemberAdminAccessArgs, WithTypename<OrganizationMember>>,
  revokeOrganizationMemberInvitationsByAdmin?: GraphCacheOptimisticMutationResolver<MutationRevokeOrganizationMemberInvitationsByAdminArgs, Scalars['Boolean']>,
  revokeOrganizationTeamInviteByAdmin?: GraphCacheOptimisticMutationResolver<MutationRevokeOrganizationTeamInviteByAdminArgs, Scalars['Boolean']>,
  revokeOrganizationToken?: GraphCacheOptimisticMutationResolver<MutationRevokeOrganizationTokenArgs, Scalars['Boolean']>,
  revokeShortcode?: GraphCacheOptimisticMutationResolver<MutationRevokeShortcodeArgs, Scalars['Boolean']>,
  revokeTeamInvitation?: GraphCacheOptimisticMutationResolver<MutationRevokeTeamInvitationArgs, Scalars['Boolean']>,
  sortTeamCollections?: GraphCacheOptimisticMutationResolver<MutationSortTeamCollectionsArgs, Scalars['Boolean']>,
  sortUserCollections?: GraphCacheOptimisticMutationResolver<MutationSortUserCollectionsArgs, Scalars['Boolean']>,
  testAIProviderConnection?: GraphCacheOptimisticMutationResolver<MutationTestAiProviderConnectionArgs, Array<WithTypename<AiProviderTestResult>>>,
  toggleDomainWhitelisting?: GraphCacheOptimisticMutationResolver<MutationToggleDomainWhitelistingArgs, Scalars['Boolean']>,
  toggleHistoryStarStatus?: GraphCacheOptimisticMutationResolver<MutationToggleHistoryStarStatusArgs, WithTypename<UserHistory>>,
  updateAIProviderConnection?: GraphCacheOptimisticMutationResolver<MutationUpdateAiProviderConnectionArgs, WithTypename<AiProviderConnection>>,
  updateAISettings?: GraphCacheOptimisticMutationResolver<MutationUpdateAiSettingsArgs, WithTypename<AiSettings>>,
  updateAISkill?: GraphCacheOptimisticMutationResolver<MutationUpdateAiSkillArgs, WithTypename<AiSkill>>,
  updateCollectionOrder?: GraphCacheOptimisticMutationResolver<MutationUpdateCollectionOrderArgs, Scalars['Boolean']>,
  updateEmbedProperties?: GraphCacheOptimisticMutationResolver<MutationUpdateEmbedPropertiesArgs, WithTypename<Shortcode>>,
  updateGQLUserRequest?: GraphCacheOptimisticMutationResolver<MutationUpdateGqlUserRequestArgs, WithTypename<UserRequest>>,
  updateLookUpRequestOrder?: GraphCacheOptimisticMutationResolver<MutationUpdateLookUpRequestOrderArgs, Scalars['Boolean']>,
  updateMockServer?: GraphCacheOptimisticMutationResolver<MutationUpdateMockServerArgs, WithTypename<MockServer>>,
  updateOrganizationBanner?: GraphCacheOptimisticMutationResolver<MutationUpdateOrganizationBannerArgs, WithTypename<OrganizationBanner>>,
  updateOrganizationBillingCycle?: GraphCacheOptimisticMutationResolver<MutationUpdateOrganizationBillingCycleArgs, Scalars['Boolean']>,
  updateOrganizationConfigs?: GraphCacheOptimisticMutationResolver<MutationUpdateOrganizationConfigsArgs, Array<WithTypename<OrgConfig>>>,
  updateOrganizationSeats?: GraphCacheOptimisticMutationResolver<MutationUpdateOrganizationSeatsArgs, Scalars['Boolean']>,
  updateOrganizationTeamMemberRoleByAdmin?: GraphCacheOptimisticMutationResolver<MutationUpdateOrganizationTeamMemberRoleByAdminArgs, WithTypename<TeamMember>>,
  updatePublishedDoc?: GraphCacheOptimisticMutationResolver<MutationUpdatePublishedDocArgs, WithTypename<PublishedDocs>>,
  updateRESTUserRequest?: GraphCacheOptimisticMutationResolver<MutationUpdateRestUserRequestArgs, WithTypename<UserRequest>>,
  updateRequest?: GraphCacheOptimisticMutationResolver<MutationUpdateRequestArgs, WithTypename<TeamRequest>>,
  updateTeamCollection?: GraphCacheOptimisticMutationResolver<MutationUpdateTeamCollectionArgs, WithTypename<TeamCollection>>,
  updateTeamEnvironment?: GraphCacheOptimisticMutationResolver<MutationUpdateTeamEnvironmentArgs, WithTypename<TeamEnvironment>>,
  updateTeamMemberRole?: GraphCacheOptimisticMutationResolver<MutationUpdateTeamMemberRoleArgs, WithTypename<TeamMember>>,
  updateUserCollection?: GraphCacheOptimisticMutationResolver<MutationUpdateUserCollectionArgs, WithTypename<UserCollection>>,
  updateUserCollectionOrder?: GraphCacheOptimisticMutationResolver<MutationUpdateUserCollectionOrderArgs, Scalars['Boolean']>,
  updateUserEnvironment?: GraphCacheOptimisticMutationResolver<MutationUpdateUserEnvironmentArgs, WithTypename<UserEnvironment>>,
  updateUserGlobalEnvironment?: GraphCacheOptimisticMutationResolver<MutationUpdateUserGlobalEnvironmentArgs, WithTypename<UserEnvironment>>,
  updateUserSettings?: GraphCacheOptimisticMutationResolver<MutationUpdateUserSettingsArgs, WithTypename<UserSettings>>,
  updateWhitelistedDomains?: GraphCacheOptimisticMutationResolver<MutationUpdateWhitelistedDomainsArgs, Array<Scalars['String']>>
};

export type GraphCacheUpdaters = {
  Query?: {
    aiChatEnabled?: GraphCacheUpdateResolver<{ aiChatEnabled: Scalars['Boolean'] }, Record<string, never>>,
    aiChatModelOptions?: GraphCacheUpdateResolver<{ aiChatModelOptions: Array<WithTypename<AiChatModelOption>> }, Record<string, never>>,
    aiChatSkills?: GraphCacheUpdateResolver<{ aiChatSkills: Array<WithTypename<AiSkill>> }, Record<string, never>>,
    aiProviderConnections?: GraphCacheUpdateResolver<{ aiProviderConnections: Array<WithTypename<AiProviderConnection>> }, QueryAiProviderConnectionsArgs>,
    aiProviderPresets?: GraphCacheUpdateResolver<{ aiProviderPresets: Array<WithTypename<AiProviderPreset>> }, QueryAiProviderPresetsArgs>,
    aiSettings?: GraphCacheUpdateResolver<{ aiSettings: WithTypename<AiSettings> }, QueryAiSettingsArgs>,
    aiSkills?: GraphCacheUpdateResolver<{ aiSkills: Array<WithTypename<AiSkill>> }, QueryAiSkillsArgs>,
    collection?: GraphCacheUpdateResolver<{ collection: Maybe<WithTypename<TeamCollection>> }, QueryCollectionArgs>,
    collectionsOfTeam?: GraphCacheUpdateResolver<{ collectionsOfTeam: Array<WithTypename<TeamCollection>> }, QueryCollectionsOfTeamArgs>,
    exportCollectionToJSON?: GraphCacheUpdateResolver<{ exportCollectionToJSON: Scalars['String'] }, QueryExportCollectionToJsonArgs>,
    exportCollectionsToJSON?: GraphCacheUpdateResolver<{ exportCollectionsToJSON: Scalars['String'] }, QueryExportCollectionsToJsonArgs>,
    exportUserCollectionToJSON?: GraphCacheUpdateResolver<{ exportUserCollectionToJSON: Scalars['String'] }, QueryExportUserCollectionToJsonArgs>,
    exportUserCollectionsToJSON?: GraphCacheUpdateResolver<{ exportUserCollectionsToJSON: WithTypename<UserCollectionExportJsonData> }, QueryExportUserCollectionsToJsonArgs>,
    getOrgInviteDetails?: GraphCacheUpdateResolver<{ getOrgInviteDetails: WithTypename<InvitedUser> }, QueryGetOrgInviteDetailsArgs>,
    invitedOrganizationMembers?: GraphCacheUpdateResolver<{ invitedOrganizationMembers: Array<WithTypename<InvitedUser>> }, QueryInvitedOrganizationMembersArgs>,
    me?: GraphCacheUpdateResolver<{ me: WithTypename<User> }, Record<string, never>>,
    mockServer?: GraphCacheUpdateResolver<{ mockServer: WithTypename<MockServer> }, QueryMockServerArgs>,
    mockServerLogs?: GraphCacheUpdateResolver<{ mockServerLogs: Array<WithTypename<MockServerLog>> }, QueryMockServerLogsArgs>,
    myMockServers?: GraphCacheUpdateResolver<{ myMockServers: Array<WithTypename<MockServer>> }, QueryMyMockServersArgs>,
    myOrganizations?: GraphCacheUpdateResolver<{ myOrganizations: Array<WithTypename<UserOrganizationMembership>> }, Record<string, never>>,
    myShortcodes?: GraphCacheUpdateResolver<{ myShortcodes: Array<WithTypename<Shortcode>> }, QueryMyShortcodesArgs>,
    myTeams?: GraphCacheUpdateResolver<{ myTeams: Array<WithTypename<Team>> }, QueryMyTeamsArgs>,
    organization?: GraphCacheUpdateResolver<{ organization: WithTypename<Organization> }, QueryOrganizationArgs>,
    organizationActiveBanner?: GraphCacheUpdateResolver<{ organizationActiveBanner: Maybe<WithTypename<OrganizationBanner>> }, QueryOrganizationActiveBannerArgs>,
    organizationAllowedAuthProviders?: GraphCacheUpdateResolver<{ organizationAllowedAuthProviders: Array<WithTypename<OrgAuthProviderStatus>> }, Record<string, never>>,
    organizationByDomain?: GraphCacheUpdateResolver<{ organizationByDomain: Scalars['String'] }, QueryOrganizationByDomainArgs>,
    organizationByDomainV2?: GraphCacheUpdateResolver<{ organizationByDomainV2: WithTypename<OrganizationSummary> }, QueryOrganizationByDomainV2Args>,
    organizationConfigs?: GraphCacheUpdateResolver<{ organizationConfigs: Array<WithTypename<OrgConfig>> }, QueryOrganizationConfigsArgs>,
    organizationMember?: GraphCacheUpdateResolver<{ organizationMember: WithTypename<OrganizationMember> }, QueryOrganizationMemberArgs>,
    organizationMembers?: GraphCacheUpdateResolver<{ organizationMembers: Array<WithTypename<OrganizationMember>> }, QueryOrganizationMembersArgs>,
    organizationMembersCount?: GraphCacheUpdateResolver<{ organizationMembersCount: Scalars['Float'] }, QueryOrganizationMembersCountArgs>,
    organizationPendingTierChange?: GraphCacheUpdateResolver<{ organizationPendingTierChange: Maybe<WithTypename<PendingTierChange>> }, QueryOrganizationPendingTierChangeArgs>,
    organizationScimSettings?: GraphCacheUpdateResolver<{ organizationScimSettings: WithTypename<OrganizationScimSettings> }, Record<string, never>>,
    organizationTeamCollectionsCount?: GraphCacheUpdateResolver<{ organizationTeamCollectionsCount: Scalars['Float'] }, QueryOrganizationTeamCollectionsCountArgs>,
    organizationTeamInfo?: GraphCacheUpdateResolver<{ organizationTeamInfo: WithTypename<Team> }, QueryOrganizationTeamInfoArgs>,
    organizationTeamRequestsCount?: GraphCacheUpdateResolver<{ organizationTeamRequestsCount: Scalars['Float'] }, QueryOrganizationTeamRequestsCountArgs>,
    organizationTeams?: GraphCacheUpdateResolver<{ organizationTeams: Array<WithTypename<Team>> }, QueryOrganizationTeamsArgs>,
    organizationTeamsCount?: GraphCacheUpdateResolver<{ organizationTeamsCount: Scalars['Float'] }, QueryOrganizationTeamsCountArgs>,
    organizationTokens?: GraphCacheUpdateResolver<{ organizationTokens: Array<WithTypename<OrganizationToken>> }, QueryOrganizationTokensArgs>,
    organizationWorkingBanner?: GraphCacheUpdateResolver<{ organizationWorkingBanner: Maybe<WithTypename<OrganizationBanner>> }, QueryOrganizationWorkingBannerArgs>,
    previewOrganizationTierChange?: GraphCacheUpdateResolver<{ previewOrganizationTierChange: WithTypename<TierChangePreview> }, QueryPreviewOrganizationTierChangeArgs>,
    publishedDoc?: GraphCacheUpdateResolver<{ publishedDoc: WithTypename<PublishedDocs> }, QueryPublishedDocArgs>,
    request?: GraphCacheUpdateResolver<{ request: Maybe<WithTypename<TeamRequest>> }, QueryRequestArgs>,
    requestsInCollection?: GraphCacheUpdateResolver<{ requestsInCollection: Array<WithTypename<TeamRequest>> }, QueryRequestsInCollectionArgs>,
    rootCollectionsOfTeam?: GraphCacheUpdateResolver<{ rootCollectionsOfTeam: Array<WithTypename<TeamCollection>> }, QueryRootCollectionsOfTeamArgs>,
    rootGQLUserCollections?: GraphCacheUpdateResolver<{ rootGQLUserCollections: Array<WithTypename<UserCollection>> }, QueryRootGqlUserCollectionsArgs>,
    rootRESTUserCollections?: GraphCacheUpdateResolver<{ rootRESTUserCollections: Array<WithTypename<UserCollection>> }, QueryRootRestUserCollectionsArgs>,
    searchForRequest?: GraphCacheUpdateResolver<{ searchForRequest: Array<WithTypename<TeamRequest>> }, QuerySearchForRequestArgs>,
    shortcode?: GraphCacheUpdateResolver<{ shortcode: Maybe<WithTypename<Shortcode>> }, QueryShortcodeArgs>,
    team?: GraphCacheUpdateResolver<{ team: Maybe<WithTypename<Team>> }, QueryTeamArgs>,
    teamInvitation?: GraphCacheUpdateResolver<{ teamInvitation: WithTypename<TeamInvitation> }, QueryTeamInvitationArgs>,
    teamMockServers?: GraphCacheUpdateResolver<{ teamMockServers: Array<WithTypename<MockServer>> }, QueryTeamMockServersArgs>,
    teamPublishedDocsList?: GraphCacheUpdateResolver<{ teamPublishedDocsList: Array<WithTypename<PublishedDocs>> }, QueryTeamPublishedDocsListArgs>,
    user?: GraphCacheUpdateResolver<{ user: Maybe<WithTypename<User>> }, QueryUserArgs>,
    userCollection?: GraphCacheUpdateResolver<{ userCollection: WithTypename<UserCollection> }, QueryUserCollectionArgs>,
    userGQLRequests?: GraphCacheUpdateResolver<{ userGQLRequests: Array<WithTypename<UserRequest>> }, QueryUserGqlRequestsArgs>,
    userPublishedDocsList?: GraphCacheUpdateResolver<{ userPublishedDocsList: Array<WithTypename<PublishedDocs>> }, QueryUserPublishedDocsListArgs>,
    userRESTRequests?: GraphCacheUpdateResolver<{ userRESTRequests: Array<WithTypename<UserRequest>> }, QueryUserRestRequestsArgs>,
    userRequest?: GraphCacheUpdateResolver<{ userRequest: WithTypename<UserRequest> }, QueryUserRequestArgs>
  },
  Mutation?: {
    acceptOrganizationInvitation?: GraphCacheUpdateResolver<{ acceptOrganizationInvitation: WithTypename<OrganizationMember> }, MutationAcceptOrganizationInvitationArgs>,
    acceptTeamInvitation?: GraphCacheUpdateResolver<{ acceptTeamInvitation: WithTypename<TeamMember> }, MutationAcceptTeamInvitationArgs>,
    addOrganizationMember?: GraphCacheUpdateResolver<{ addOrganizationMember: WithTypename<OrganizationMember> }, MutationAddOrganizationMemberArgs>,
    addTeamMemberByEmail?: GraphCacheUpdateResolver<{ addTeamMemberByEmail: WithTypename<TeamMember> }, MutationAddTeamMemberByEmailArgs>,
    addUserToTeamByAdmin?: GraphCacheUpdateResolver<{ addUserToTeamByAdmin: WithTypename<TeamMember> }, MutationAddUserToTeamByAdminArgs>,
    cancelOrganizationSubscription?: GraphCacheUpdateResolver<{ cancelOrganizationSubscription: Scalars['Boolean'] }, MutationCancelOrganizationSubscriptionArgs>,
    cancelScheduledTierChange?: GraphCacheUpdateResolver<{ cancelScheduledTierChange: Scalars['Boolean'] }, MutationCancelScheduledTierChangeArgs>,
    changeOrganizationTier?: GraphCacheUpdateResolver<{ changeOrganizationTier: WithTypename<TierChangeResult> }, MutationChangeOrganizationTierArgs>,
    clearGlobalEnvironments?: GraphCacheUpdateResolver<{ clearGlobalEnvironments: WithTypename<UserEnvironment> }, MutationClearGlobalEnvironmentsArgs>,
    createAIProviderConnection?: GraphCacheUpdateResolver<{ createAIProviderConnection: WithTypename<AiProviderConnection> }, MutationCreateAiProviderConnectionArgs>,
    createAISkill?: GraphCacheUpdateResolver<{ createAISkill: WithTypename<AiSkill> }, MutationCreateAiSkillArgs>,
    createChildCollection?: GraphCacheUpdateResolver<{ createChildCollection: WithTypename<TeamCollection> }, MutationCreateChildCollectionArgs>,
    createDuplicateEnvironment?: GraphCacheUpdateResolver<{ createDuplicateEnvironment: WithTypename<TeamEnvironment> }, MutationCreateDuplicateEnvironmentArgs>,
    createGQLChildUserCollection?: GraphCacheUpdateResolver<{ createGQLChildUserCollection: WithTypename<UserCollection> }, MutationCreateGqlChildUserCollectionArgs>,
    createGQLRootUserCollection?: GraphCacheUpdateResolver<{ createGQLRootUserCollection: WithTypename<UserCollection> }, MutationCreateGqlRootUserCollectionArgs>,
    createGQLUserRequest?: GraphCacheUpdateResolver<{ createGQLUserRequest: WithTypename<UserRequest> }, MutationCreateGqlUserRequestArgs>,
    createMockServer?: GraphCacheUpdateResolver<{ createMockServer: WithTypename<MockServer> }, MutationCreateMockServerArgs>,
    createOrganizationBanner?: GraphCacheUpdateResolver<{ createOrganizationBanner: WithTypename<OrganizationBanner> }, MutationCreateOrganizationBannerArgs>,
    createOrganizationToken?: GraphCacheUpdateResolver<{ createOrganizationToken: WithTypename<CreateOrganizationTokenResponse> }, MutationCreateOrganizationTokenArgs>,
    createPublishedDoc?: GraphCacheUpdateResolver<{ createPublishedDoc: WithTypename<PublishedDocs> }, MutationCreatePublishedDocArgs>,
    createRESTChildUserCollection?: GraphCacheUpdateResolver<{ createRESTChildUserCollection: WithTypename<UserCollection> }, MutationCreateRestChildUserCollectionArgs>,
    createRESTRootUserCollection?: GraphCacheUpdateResolver<{ createRESTRootUserCollection: WithTypename<UserCollection> }, MutationCreateRestRootUserCollectionArgs>,
    createRESTUserRequest?: GraphCacheUpdateResolver<{ createRESTUserRequest: WithTypename<UserRequest> }, MutationCreateRestUserRequestArgs>,
    createRequestInCollection?: GraphCacheUpdateResolver<{ createRequestInCollection: WithTypename<TeamRequest> }, MutationCreateRequestInCollectionArgs>,
    createRootCollection?: GraphCacheUpdateResolver<{ createRootCollection: WithTypename<TeamCollection> }, MutationCreateRootCollectionArgs>,
    createShortcode?: GraphCacheUpdateResolver<{ createShortcode: WithTypename<Shortcode> }, MutationCreateShortcodeArgs>,
    createTeam?: GraphCacheUpdateResolver<{ createTeam: WithTypename<Team> }, MutationCreateTeamArgs>,
    createTeamByAdmin?: GraphCacheUpdateResolver<{ createTeamByAdmin: WithTypename<Team> }, MutationCreateTeamByAdminArgs>,
    createTeamEnvironment?: GraphCacheUpdateResolver<{ createTeamEnvironment: WithTypename<TeamEnvironment> }, MutationCreateTeamEnvironmentArgs>,
    createTeamInvitation?: GraphCacheUpdateResolver<{ createTeamInvitation: WithTypename<TeamInvitation> }, MutationCreateTeamInvitationArgs>,
    createUserEnvironment?: GraphCacheUpdateResolver<{ createUserEnvironment: WithTypename<UserEnvironment> }, MutationCreateUserEnvironmentArgs>,
    createUserGlobalEnvironment?: GraphCacheUpdateResolver<{ createUserGlobalEnvironment: WithTypename<UserEnvironment> }, MutationCreateUserGlobalEnvironmentArgs>,
    createUserHistory?: GraphCacheUpdateResolver<{ createUserHistory: WithTypename<UserHistory> }, MutationCreateUserHistoryArgs>,
    createUserSettings?: GraphCacheUpdateResolver<{ createUserSettings: WithTypename<UserSettings> }, MutationCreateUserSettingsArgs>,
    deactivateOrganizationMember?: GraphCacheUpdateResolver<{ deactivateOrganizationMember: Scalars['Boolean'] }, MutationDeactivateOrganizationMemberArgs>,
    deleteAIProviderConnection?: GraphCacheUpdateResolver<{ deleteAIProviderConnection: Scalars['Boolean'] }, MutationDeleteAiProviderConnectionArgs>,
    deleteAISkill?: GraphCacheUpdateResolver<{ deleteAISkill: Scalars['Boolean'] }, MutationDeleteAiSkillArgs>,
    deleteAllUserHistory?: GraphCacheUpdateResolver<{ deleteAllUserHistory: WithTypename<UserHistoryDeletedManyData> }, MutationDeleteAllUserHistoryArgs>,
    deleteAllVariablesFromTeamEnvironment?: GraphCacheUpdateResolver<{ deleteAllVariablesFromTeamEnvironment: WithTypename<TeamEnvironment> }, MutationDeleteAllVariablesFromTeamEnvironmentArgs>,
    deleteCollection?: GraphCacheUpdateResolver<{ deleteCollection: Scalars['Boolean'] }, MutationDeleteCollectionArgs>,
    deleteMockServer?: GraphCacheUpdateResolver<{ deleteMockServer: Scalars['Boolean'] }, MutationDeleteMockServerArgs>,
    deleteMockServerLog?: GraphCacheUpdateResolver<{ deleteMockServerLog: Scalars['Boolean'] }, MutationDeleteMockServerLogArgs>,
    deletePublishedDoc?: GraphCacheUpdateResolver<{ deletePublishedDoc: Scalars['Boolean'] }, MutationDeletePublishedDocArgs>,
    deleteRequest?: GraphCacheUpdateResolver<{ deleteRequest: Scalars['Boolean'] }, MutationDeleteRequestArgs>,
    deleteTeam?: GraphCacheUpdateResolver<{ deleteTeam: Scalars['Boolean'] }, MutationDeleteTeamArgs>,
    deleteTeamByAdmin?: GraphCacheUpdateResolver<{ deleteTeamByAdmin: Scalars['Boolean'] }, MutationDeleteTeamByAdminArgs>,
    deleteTeamEnvironment?: GraphCacheUpdateResolver<{ deleteTeamEnvironment: Scalars['Boolean'] }, MutationDeleteTeamEnvironmentArgs>,
    deleteUser?: GraphCacheUpdateResolver<{ deleteUser: Scalars['Boolean'] }, Record<string, never>>,
    deleteUserCollection?: GraphCacheUpdateResolver<{ deleteUserCollection: Scalars['Boolean'] }, MutationDeleteUserCollectionArgs>,
    deleteUserEnvironment?: GraphCacheUpdateResolver<{ deleteUserEnvironment: Scalars['Boolean'] }, MutationDeleteUserEnvironmentArgs>,
    deleteUserEnvironments?: GraphCacheUpdateResolver<{ deleteUserEnvironments: Scalars['Float'] }, MutationDeleteUserEnvironmentsArgs>,
    deleteUserRequest?: GraphCacheUpdateResolver<{ deleteUserRequest: Scalars['Boolean'] }, MutationDeleteUserRequestArgs>,
    demoteOrganizationMembersAsAdmin?: GraphCacheUpdateResolver<{ demoteOrganizationMembersAsAdmin: Scalars['Boolean'] }, MutationDemoteOrganizationMembersAsAdminArgs>,
    duplicateTeamCollection?: GraphCacheUpdateResolver<{ duplicateTeamCollection: Scalars['Boolean'] }, MutationDuplicateTeamCollectionArgs>,
    duplicateUserCollection?: GraphCacheUpdateResolver<{ duplicateUserCollection: WithTypename<UserCollectionExportJsonData> }, MutationDuplicateUserCollectionArgs>,
    enableAndDisableOrganizationAuth?: GraphCacheUpdateResolver<{ enableAndDisableOrganizationAuth: Array<WithTypename<OrgAuthProviderStatus>> }, MutationEnableAndDisableOrganizationAuthArgs>,
    importCollectionFromUserFirestore?: GraphCacheUpdateResolver<{ importCollectionFromUserFirestore: WithTypename<TeamCollection> }, MutationImportCollectionFromUserFirestoreArgs>,
    importCollectionsFromJSON?: GraphCacheUpdateResolver<{ importCollectionsFromJSON: Scalars['Boolean'] }, MutationImportCollectionsFromJsonArgs>,
    importUserCollectionsFromJSON?: GraphCacheUpdateResolver<{ importUserCollectionsFromJSON: WithTypename<UserCollectionExportJsonData> }, MutationImportUserCollectionsFromJsonArgs>,
    initiateOrganizationPurchase?: GraphCacheUpdateResolver<{ initiateOrganizationPurchase: Scalars['String'] }, MutationInitiateOrganizationPurchaseArgs>,
    inviteNewUser?: GraphCacheUpdateResolver<{ inviteNewUser: WithTypename<InvitedUser> }, MutationInviteNewUserArgs>,
    leaveTeam?: GraphCacheUpdateResolver<{ leaveTeam: Scalars['Boolean'] }, MutationLeaveTeamArgs>,
    makeOrganizationMemberAnAdmin?: GraphCacheUpdateResolver<{ makeOrganizationMemberAnAdmin: WithTypename<OrganizationMember> }, MutationMakeOrganizationMemberAnAdminArgs>,
    makeOrganizationMembersAdmin?: GraphCacheUpdateResolver<{ makeOrganizationMembersAdmin: Scalars['Boolean'] }, MutationMakeOrganizationMembersAdminArgs>,
    moveCollection?: GraphCacheUpdateResolver<{ moveCollection: WithTypename<TeamCollection> }, MutationMoveCollectionArgs>,
    moveRequest?: GraphCacheUpdateResolver<{ moveRequest: WithTypename<TeamRequest> }, MutationMoveRequestArgs>,
    moveUserCollection?: GraphCacheUpdateResolver<{ moveUserCollection: WithTypename<UserCollection> }, MutationMoveUserCollectionArgs>,
    moveUserRequest?: GraphCacheUpdateResolver<{ moveUserRequest: WithTypename<UserRequest> }, MutationMoveUserRequestArgs>,
    removeMemberFromTeamByAdmin?: GraphCacheUpdateResolver<{ removeMemberFromTeamByAdmin: Scalars['Boolean'] }, MutationRemoveMemberFromTeamByAdminArgs>,
    removeOrganizationMember?: GraphCacheUpdateResolver<{ removeOrganizationMember: WithTypename<OrganizationMember> }, MutationRemoveOrganizationMemberArgs>,
    removeRequestFromHistory?: GraphCacheUpdateResolver<{ removeRequestFromHistory: WithTypename<UserHistory> }, MutationRemoveRequestFromHistoryArgs>,
    removeTeamMember?: GraphCacheUpdateResolver<{ removeTeamMember: Scalars['Boolean'] }, MutationRemoveTeamMemberArgs>,
    renameCollection?: GraphCacheUpdateResolver<{ renameCollection: WithTypename<TeamCollection> }, MutationRenameCollectionArgs>,
    renameTeam?: GraphCacheUpdateResolver<{ renameTeam: WithTypename<Team> }, MutationRenameTeamArgs>,
    renameTeamByAdmin?: GraphCacheUpdateResolver<{ renameTeamByAdmin: WithTypename<Team> }, MutationRenameTeamByAdminArgs>,
    replaceCollectionsWithJSON?: GraphCacheUpdateResolver<{ replaceCollectionsWithJSON: Scalars['Boolean'] }, MutationReplaceCollectionsWithJsonArgs>,
    revokeOrganizationMemberAdminAccess?: GraphCacheUpdateResolver<{ revokeOrganizationMemberAdminAccess: WithTypename<OrganizationMember> }, MutationRevokeOrganizationMemberAdminAccessArgs>,
    revokeOrganizationMemberInvitationsByAdmin?: GraphCacheUpdateResolver<{ revokeOrganizationMemberInvitationsByAdmin: Scalars['Boolean'] }, MutationRevokeOrganizationMemberInvitationsByAdminArgs>,
    revokeOrganizationTeamInviteByAdmin?: GraphCacheUpdateResolver<{ revokeOrganizationTeamInviteByAdmin: Scalars['Boolean'] }, MutationRevokeOrganizationTeamInviteByAdminArgs>,
    revokeOrganizationToken?: GraphCacheUpdateResolver<{ revokeOrganizationToken: Scalars['Boolean'] }, MutationRevokeOrganizationTokenArgs>,
    revokeShortcode?: GraphCacheUpdateResolver<{ revokeShortcode: Scalars['Boolean'] }, MutationRevokeShortcodeArgs>,
    revokeTeamInvitation?: GraphCacheUpdateResolver<{ revokeTeamInvitation: Scalars['Boolean'] }, MutationRevokeTeamInvitationArgs>,
    sortTeamCollections?: GraphCacheUpdateResolver<{ sortTeamCollections: Scalars['Boolean'] }, MutationSortTeamCollectionsArgs>,
    sortUserCollections?: GraphCacheUpdateResolver<{ sortUserCollections: Scalars['Boolean'] }, MutationSortUserCollectionsArgs>,
    testAIProviderConnection?: GraphCacheUpdateResolver<{ testAIProviderConnection: Array<WithTypename<AiProviderTestResult>> }, MutationTestAiProviderConnectionArgs>,
    toggleDomainWhitelisting?: GraphCacheUpdateResolver<{ toggleDomainWhitelisting: Scalars['Boolean'] }, MutationToggleDomainWhitelistingArgs>,
    toggleHistoryStarStatus?: GraphCacheUpdateResolver<{ toggleHistoryStarStatus: WithTypename<UserHistory> }, MutationToggleHistoryStarStatusArgs>,
    updateAIProviderConnection?: GraphCacheUpdateResolver<{ updateAIProviderConnection: WithTypename<AiProviderConnection> }, MutationUpdateAiProviderConnectionArgs>,
    updateAISettings?: GraphCacheUpdateResolver<{ updateAISettings: WithTypename<AiSettings> }, MutationUpdateAiSettingsArgs>,
    updateAISkill?: GraphCacheUpdateResolver<{ updateAISkill: WithTypename<AiSkill> }, MutationUpdateAiSkillArgs>,
    updateCollectionOrder?: GraphCacheUpdateResolver<{ updateCollectionOrder: Scalars['Boolean'] }, MutationUpdateCollectionOrderArgs>,
    updateEmbedProperties?: GraphCacheUpdateResolver<{ updateEmbedProperties: WithTypename<Shortcode> }, MutationUpdateEmbedPropertiesArgs>,
    updateGQLUserRequest?: GraphCacheUpdateResolver<{ updateGQLUserRequest: WithTypename<UserRequest> }, MutationUpdateGqlUserRequestArgs>,
    updateLookUpRequestOrder?: GraphCacheUpdateResolver<{ updateLookUpRequestOrder: Scalars['Boolean'] }, MutationUpdateLookUpRequestOrderArgs>,
    updateMockServer?: GraphCacheUpdateResolver<{ updateMockServer: WithTypename<MockServer> }, MutationUpdateMockServerArgs>,
    updateOrganizationBanner?: GraphCacheUpdateResolver<{ updateOrganizationBanner: WithTypename<OrganizationBanner> }, MutationUpdateOrganizationBannerArgs>,
    updateOrganizationBillingCycle?: GraphCacheUpdateResolver<{ updateOrganizationBillingCycle: Scalars['Boolean'] }, MutationUpdateOrganizationBillingCycleArgs>,
    updateOrganizationConfigs?: GraphCacheUpdateResolver<{ updateOrganizationConfigs: Array<WithTypename<OrgConfig>> }, MutationUpdateOrganizationConfigsArgs>,
    updateOrganizationSeats?: GraphCacheUpdateResolver<{ updateOrganizationSeats: Scalars['Boolean'] }, MutationUpdateOrganizationSeatsArgs>,
    updateOrganizationTeamMemberRoleByAdmin?: GraphCacheUpdateResolver<{ updateOrganizationTeamMemberRoleByAdmin: WithTypename<TeamMember> }, MutationUpdateOrganizationTeamMemberRoleByAdminArgs>,
    updatePublishedDoc?: GraphCacheUpdateResolver<{ updatePublishedDoc: WithTypename<PublishedDocs> }, MutationUpdatePublishedDocArgs>,
    updateRESTUserRequest?: GraphCacheUpdateResolver<{ updateRESTUserRequest: WithTypename<UserRequest> }, MutationUpdateRestUserRequestArgs>,
    updateRequest?: GraphCacheUpdateResolver<{ updateRequest: WithTypename<TeamRequest> }, MutationUpdateRequestArgs>,
    updateTeamCollection?: GraphCacheUpdateResolver<{ updateTeamCollection: WithTypename<TeamCollection> }, MutationUpdateTeamCollectionArgs>,
    updateTeamEnvironment?: GraphCacheUpdateResolver<{ updateTeamEnvironment: WithTypename<TeamEnvironment> }, MutationUpdateTeamEnvironmentArgs>,
    updateTeamMemberRole?: GraphCacheUpdateResolver<{ updateTeamMemberRole: WithTypename<TeamMember> }, MutationUpdateTeamMemberRoleArgs>,
    updateUserCollection?: GraphCacheUpdateResolver<{ updateUserCollection: WithTypename<UserCollection> }, MutationUpdateUserCollectionArgs>,
    updateUserCollectionOrder?: GraphCacheUpdateResolver<{ updateUserCollectionOrder: Scalars['Boolean'] }, MutationUpdateUserCollectionOrderArgs>,
    updateUserEnvironment?: GraphCacheUpdateResolver<{ updateUserEnvironment: WithTypename<UserEnvironment> }, MutationUpdateUserEnvironmentArgs>,
    updateUserGlobalEnvironment?: GraphCacheUpdateResolver<{ updateUserGlobalEnvironment: WithTypename<UserEnvironment> }, MutationUpdateUserGlobalEnvironmentArgs>,
    updateUserSettings?: GraphCacheUpdateResolver<{ updateUserSettings: WithTypename<UserSettings> }, MutationUpdateUserSettingsArgs>,
    updateWhitelistedDomains?: GraphCacheUpdateResolver<{ updateWhitelistedDomains: Array<Scalars['String']> }, MutationUpdateWhitelistedDomainsArgs>
  },
  Subscription?: {
    collectionOrderUpdated?: GraphCacheUpdateResolver<{ collectionOrderUpdated: WithTypename<CollectionReorderData> }, SubscriptionCollectionOrderUpdatedArgs>,
    myShortcodesCreated?: GraphCacheUpdateResolver<{ myShortcodesCreated: WithTypename<Shortcode> }, Record<string, never>>,
    myShortcodesRevoked?: GraphCacheUpdateResolver<{ myShortcodesRevoked: WithTypename<Shortcode> }, Record<string, never>>,
    myShortcodesUpdated?: GraphCacheUpdateResolver<{ myShortcodesUpdated: WithTypename<Shortcode> }, Record<string, never>>,
    organizationCreated?: GraphCacheUpdateResolver<{ organizationCreated: Scalars['String'] }, Record<string, never>>,
    organizationMemberAdded?: GraphCacheUpdateResolver<{ organizationMemberAdded: WithTypename<OrganizationMember> }, SubscriptionOrganizationMemberAddedArgs>,
    organizationMemberRemoved?: GraphCacheUpdateResolver<{ organizationMemberRemoved: WithTypename<OrganizationMember> }, SubscriptionOrganizationMemberRemovedArgs>,
    organizationTierChanged?: GraphCacheUpdateResolver<{ organizationTierChanged: OrganizationTier }, SubscriptionOrganizationTierChangedArgs>,
    requestMoved?: GraphCacheUpdateResolver<{ requestMoved: WithTypename<TeamRequest> }, SubscriptionRequestMovedArgs>,
    requestOrderUpdated?: GraphCacheUpdateResolver<{ requestOrderUpdated: WithTypename<RequestReorderData> }, SubscriptionRequestOrderUpdatedArgs>,
    teamChildCollectionsSorted?: GraphCacheUpdateResolver<{ teamChildCollectionsSorted: Scalars['ID'] }, SubscriptionTeamChildCollectionsSortedArgs>,
    teamCollectionAdded?: GraphCacheUpdateResolver<{ teamCollectionAdded: WithTypename<TeamCollection> }, SubscriptionTeamCollectionAddedArgs>,
    teamCollectionMoved?: GraphCacheUpdateResolver<{ teamCollectionMoved: WithTypename<TeamCollection> }, SubscriptionTeamCollectionMovedArgs>,
    teamCollectionRemoved?: GraphCacheUpdateResolver<{ teamCollectionRemoved: Scalars['ID'] }, SubscriptionTeamCollectionRemovedArgs>,
    teamCollectionUpdated?: GraphCacheUpdateResolver<{ teamCollectionUpdated: WithTypename<TeamCollection> }, SubscriptionTeamCollectionUpdatedArgs>,
    teamEnvironmentCreated?: GraphCacheUpdateResolver<{ teamEnvironmentCreated: WithTypename<TeamEnvironment> }, SubscriptionTeamEnvironmentCreatedArgs>,
    teamEnvironmentDeleted?: GraphCacheUpdateResolver<{ teamEnvironmentDeleted: WithTypename<TeamEnvironment> }, SubscriptionTeamEnvironmentDeletedArgs>,
    teamEnvironmentUpdated?: GraphCacheUpdateResolver<{ teamEnvironmentUpdated: WithTypename<TeamEnvironment> }, SubscriptionTeamEnvironmentUpdatedArgs>,
    teamInvitationAdded?: GraphCacheUpdateResolver<{ teamInvitationAdded: WithTypename<TeamInvitation> }, SubscriptionTeamInvitationAddedArgs>,
    teamInvitationRemoved?: GraphCacheUpdateResolver<{ teamInvitationRemoved: Scalars['ID'] }, SubscriptionTeamInvitationRemovedArgs>,
    teamMemberAdded?: GraphCacheUpdateResolver<{ teamMemberAdded: WithTypename<TeamMember> }, SubscriptionTeamMemberAddedArgs>,
    teamMemberRemoved?: GraphCacheUpdateResolver<{ teamMemberRemoved: Scalars['ID'] }, SubscriptionTeamMemberRemovedArgs>,
    teamMemberUpdated?: GraphCacheUpdateResolver<{ teamMemberUpdated: WithTypename<TeamMember> }, SubscriptionTeamMemberUpdatedArgs>,
    teamRequestAdded?: GraphCacheUpdateResolver<{ teamRequestAdded: WithTypename<TeamRequest> }, SubscriptionTeamRequestAddedArgs>,
    teamRequestDeleted?: GraphCacheUpdateResolver<{ teamRequestDeleted: Scalars['ID'] }, SubscriptionTeamRequestDeletedArgs>,
    teamRequestUpdated?: GraphCacheUpdateResolver<{ teamRequestUpdated: WithTypename<TeamRequest> }, SubscriptionTeamRequestUpdatedArgs>,
    teamRootCollectionsSorted?: GraphCacheUpdateResolver<{ teamRootCollectionsSorted: Scalars['Boolean'] }, SubscriptionTeamRootCollectionsSortedArgs>,
    userCollectionCreated?: GraphCacheUpdateResolver<{ userCollectionCreated: WithTypename<UserCollection> }, Record<string, never>>,
    userCollectionDuplicated?: GraphCacheUpdateResolver<{ userCollectionDuplicated: WithTypename<UserCollectionDuplicatedData> }, Record<string, never>>,
    userCollectionMoved?: GraphCacheUpdateResolver<{ userCollectionMoved: WithTypename<UserCollection> }, Record<string, never>>,
    userCollectionOrderUpdated?: GraphCacheUpdateResolver<{ userCollectionOrderUpdated: WithTypename<UserCollectionOrderUpdatedData> }, Record<string, never>>,
    userCollectionRemoved?: GraphCacheUpdateResolver<{ userCollectionRemoved: WithTypename<UserCollectionRemovedData> }, Record<string, never>>,
    userCollectionUpdated?: GraphCacheUpdateResolver<{ userCollectionUpdated: WithTypename<UserCollection> }, Record<string, never>>,
    userDeleted?: GraphCacheUpdateResolver<{ userDeleted: WithTypename<User> }, Record<string, never>>,
    userEnvironmentCreated?: GraphCacheUpdateResolver<{ userEnvironmentCreated: WithTypename<UserEnvironment> }, Record<string, never>>,
    userEnvironmentDeleteMany?: GraphCacheUpdateResolver<{ userEnvironmentDeleteMany: Scalars['Float'] }, Record<string, never>>,
    userEnvironmentDeleted?: GraphCacheUpdateResolver<{ userEnvironmentDeleted: WithTypename<UserEnvironment> }, Record<string, never>>,
    userEnvironmentUpdated?: GraphCacheUpdateResolver<{ userEnvironmentUpdated: WithTypename<UserEnvironment> }, Record<string, never>>,
    userHistoryCreated?: GraphCacheUpdateResolver<{ userHistoryCreated: WithTypename<UserHistory> }, Record<string, never>>,
    userHistoryDeleted?: GraphCacheUpdateResolver<{ userHistoryDeleted: WithTypename<UserHistory> }, Record<string, never>>,
    userHistoryDeletedMany?: GraphCacheUpdateResolver<{ userHistoryDeletedMany: WithTypename<UserHistoryDeletedManyData> }, Record<string, never>>,
    userHistoryUpdated?: GraphCacheUpdateResolver<{ userHistoryUpdated: WithTypename<UserHistory> }, Record<string, never>>,
    userInvited?: GraphCacheUpdateResolver<{ userInvited: WithTypename<InvitedUser> }, Record<string, never>>,
    userRequestCreated?: GraphCacheUpdateResolver<{ userRequestCreated: WithTypename<UserRequest> }, Record<string, never>>,
    userRequestDeleted?: GraphCacheUpdateResolver<{ userRequestDeleted: WithTypename<UserRequest> }, Record<string, never>>,
    userRequestMoved?: GraphCacheUpdateResolver<{ userRequestMoved: WithTypename<UserRequestReorderData> }, Record<string, never>>,
    userRequestUpdated?: GraphCacheUpdateResolver<{ userRequestUpdated: WithTypename<UserRequest> }, Record<string, never>>,
    userSettingsCreated?: GraphCacheUpdateResolver<{ userSettingsCreated: WithTypename<UserSettings> }, Record<string, never>>,
    userSettingsUpdated?: GraphCacheUpdateResolver<{ userSettingsUpdated: WithTypename<UserSettings> }, Record<string, never>>
  },
  AIChatModelOption?: {
    connectionID?: GraphCacheUpdateResolver<Maybe<WithTypename<AiChatModelOption>>, Record<string, never>>,
    connectionLabel?: GraphCacheUpdateResolver<Maybe<WithTypename<AiChatModelOption>>, Record<string, never>>,
    isDefault?: GraphCacheUpdateResolver<Maybe<WithTypename<AiChatModelOption>>, Record<string, never>>,
    model?: GraphCacheUpdateResolver<Maybe<WithTypename<AiChatModelOption>>, Record<string, never>>,
    preset?: GraphCacheUpdateResolver<Maybe<WithTypename<AiChatModelOption>>, Record<string, never>>
  },
  AIProviderConnection?: {
    baseURL?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    defaultModel?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    enabled?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    hasApiKey?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    isDefault?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    models?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    preset?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>,
    updatedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderConnection>>, Record<string, never>>
  },
  AIProviderPreset?: {
    baseURLHint?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderPreset>>, Record<string, never>>,
    defaultBaseURL?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderPreset>>, Record<string, never>>,
    dialect?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderPreset>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderPreset>>, Record<string, never>>,
    requiresBaseURL?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderPreset>>, Record<string, never>>,
    suggestedModels?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderPreset>>, Record<string, never>>,
    verified?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderPreset>>, Record<string, never>>
  },
  AIProviderTestResult?: {
    detail?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderTestResult>>, Record<string, never>>,
    latencyMs?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderTestResult>>, Record<string, never>>,
    model?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderTestResult>>, Record<string, never>>,
    ok?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderTestResult>>, Record<string, never>>,
    reason?: GraphCacheUpdateResolver<Maybe<WithTypename<AiProviderTestResult>>, Record<string, never>>
  },
  AISettings?: {
    acknowledgedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    editable?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    enabled?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    maxRetries?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    promptCaching?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    reasoningEffort?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    timeoutMs?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>,
    toolSearch?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSettings>>, Record<string, never>>
  },
  AISkill?: {
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSkill>>, Record<string, never>>,
    description?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSkill>>, Record<string, never>>,
    enabled?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSkill>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSkill>>, Record<string, never>>,
    prompt?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSkill>>, Record<string, never>>,
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSkill>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSkill>>, Record<string, never>>,
    updatedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<AiSkill>>, Record<string, never>>
  },
  CollectionReorderData?: {
    collection?: GraphCacheUpdateResolver<Maybe<WithTypename<CollectionReorderData>>, Record<string, never>>,
    nextCollection?: GraphCacheUpdateResolver<Maybe<WithTypename<CollectionReorderData>>, Record<string, never>>
  },
  CreateOrganizationTokenResponse?: {
    info?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateOrganizationTokenResponse>>, Record<string, never>>,
    token?: GraphCacheUpdateResolver<Maybe<WithTypename<CreateOrganizationTokenResponse>>, Record<string, never>>
  },
  DowngradeImpact?: {
    activeTokenCount?: GraphCacheUpdateResolver<Maybe<WithTypename<DowngradeImpact>>, Record<string, never>>,
    scimEnabled?: GraphCacheUpdateResolver<Maybe<WithTypename<DowngradeImpact>>, Record<string, never>>,
    ssoMemberCount?: GraphCacheUpdateResolver<Maybe<WithTypename<DowngradeImpact>>, Record<string, never>>
  },
  InvitedUser?: {
    adminEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    adminName?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    adminUid?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    inviteID?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    invitedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    inviteeEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>,
    orgName?: GraphCacheUpdateResolver<Maybe<WithTypename<InvitedUser>>, Record<string, never>>
  },
  MockServer?: {
    collection?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    creator?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    delayInMs?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    isActive?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    isPublic?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    serverUrlDomainBased?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    serverUrlPathBased?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    subdomain?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    updatedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    workspaceID?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>,
    workspaceType?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServer>>, Record<string, never>>
  },
  MockServerCollection?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerCollection>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerCollection>>, Record<string, never>>
  },
  MockServerLog?: {
    executedAt?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    ipAddress?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    mockServerID?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    requestBody?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    requestHeaders?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    requestMethod?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    requestPath?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    requestQuery?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    responseBody?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    responseHeaders?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    responseStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    responseTime?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>,
    userAgent?: GraphCacheUpdateResolver<Maybe<WithTypename<MockServerLog>>, Record<string, never>>
  },
  OrgAuthProviderStatus?: {
    provider?: GraphCacheUpdateResolver<Maybe<WithTypename<OrgAuthProviderStatus>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<OrgAuthProviderStatus>>, Record<string, never>>
  },
  OrgConfig?: {
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<OrgConfig>>, Record<string, never>>,
    value?: GraphCacheUpdateResolver<Maybe<WithTypename<OrgConfig>>, Record<string, never>>
  },
  Organization?: {
    billingAddress?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    billingCycle?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    billingEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    checkoutUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    nextBillingDate?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgDomain?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgLogo?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgMetadata?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgName?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    orgStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    seats?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>,
    tier?: GraphCacheUpdateResolver<Maybe<WithTypename<Organization>>, Record<string, never>>
  },
  OrganizationBanner?: {
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBanner>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBanner>>, Record<string, never>>,
    message?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBanner>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBanner>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBanner>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBanner>>, Record<string, never>>
  },
  OrganizationBillingAddress?: {
    city?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    country?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    line1?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    line2?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    postal_code?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>,
    state?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationBillingAddress>>, Record<string, never>>
  },
  OrganizationMember?: {
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    invitedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    inviteeUserUID?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    isAdmin?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    lastActiveOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    membershipStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    photoURL?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    userEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    userName?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>,
    userUID?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationMember>>, Record<string, never>>
  },
  OrganizationScimSettings?: {
    baseUrl?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationScimSettings>>, Record<string, never>>,
    enabled?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationScimSettings>>, Record<string, never>>
  },
  OrganizationSummary?: {
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationSummary>>, Record<string, never>>,
    tier?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationSummary>>, Record<string, never>>
  },
  OrganizationToken?: {
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationToken>>, Record<string, never>>,
    expiresOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationToken>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationToken>>, Record<string, never>>,
    label?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationToken>>, Record<string, never>>,
    lastUsedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<OrganizationToken>>, Record<string, never>>
  },
  PendingTierChange?: {
    effectiveAt?: GraphCacheUpdateResolver<Maybe<WithTypename<PendingTierChange>>, Record<string, never>>,
    tier?: GraphCacheUpdateResolver<Maybe<WithTypename<PendingTierChange>>, Record<string, never>>
  },
  PublishedDocs?: {
    autoSync?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    collection?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    creator?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    documentTree?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    environmentName?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    environmentVariables?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    metadata?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    updatedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    version?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    versions?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    workspaceID?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>,
    workspaceType?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocs>>, Record<string, never>>
  },
  PublishedDocsCollection?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocsCollection>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocsCollection>>, Record<string, never>>
  },
  PublishedDocsVersion?: {
    autoSync?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocsVersion>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocsVersion>>, Record<string, never>>,
    slug?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocsVersion>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocsVersion>>, Record<string, never>>,
    url?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocsVersion>>, Record<string, never>>,
    version?: GraphCacheUpdateResolver<Maybe<WithTypename<PublishedDocsVersion>>, Record<string, never>>
  },
  RequestReorderData?: {
    nextRequest?: GraphCacheUpdateResolver<Maybe<WithTypename<RequestReorderData>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<RequestReorderData>>, Record<string, never>>
  },
  Shortcode?: {
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>,
    properties?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<Shortcode>>, Record<string, never>>
  },
  Team?: {
    editorsCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    members?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, TeamMembersArgs>,
    myRole?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    orgDomain?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    orgID?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    orgName?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    ownersCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    teamEnvironments?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    teamInvitations?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    teamMembers?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>,
    viewersCount?: GraphCacheUpdateResolver<Maybe<WithTypename<Team>>, Record<string, never>>
  },
  TeamCollection?: {
    children?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, TeamCollectionChildrenArgs>,
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>,
    parent?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>,
    team?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamCollection>>, Record<string, never>>
  },
  TeamEnvironment?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamEnvironment>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamEnvironment>>, Record<string, never>>,
    teamID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamEnvironment>>, Record<string, never>>,
    variables?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamEnvironment>>, Record<string, never>>
  },
  TeamInvitation?: {
    creator?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    creatorUid?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    inviteeEmail?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    inviteeRole?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    team?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>,
    teamID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamInvitation>>, Record<string, never>>
  },
  TeamMember?: {
    membershipID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamMember>>, Record<string, never>>,
    role?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamMember>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamMember>>, Record<string, never>>
  },
  TeamRequest?: {
    collection?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    collectionID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    team?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    teamID?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<TeamRequest>>, Record<string, never>>
  },
  TierChangePreview?: {
    amountDueNow?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangePreview>>, Record<string, never>>,
    currency?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangePreview>>, Record<string, never>>,
    downgradeImpact?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangePreview>>, Record<string, never>>,
    effectiveAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangePreview>>, Record<string, never>>,
    nextPeriodAmount?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangePreview>>, Record<string, never>>,
    targetTier?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangePreview>>, Record<string, never>>
  },
  TierChangeResult?: {
    effectiveAt?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangeResult>>, Record<string, never>>,
    paymentURL?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangeResult>>, Record<string, never>>,
    status?: GraphCacheUpdateResolver<Maybe<WithTypename<TierChangeResult>>, Record<string, never>>
  },
  User?: {
    GQLHistory?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserGqlHistoryArgs>,
    RESTHistory?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, UserRestHistoryArgs>,
    displayName?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    email?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    environments?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    globalEnvironments?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    photoURL?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    settings?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>,
    uid?: GraphCacheUpdateResolver<Maybe<WithTypename<User>>, Record<string, never>>
  },
  UserCollection?: {
    childrenGQL?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, UserCollectionChildrenGqlArgs>,
    childrenREST?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, UserCollectionChildrenRestArgs>,
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, Record<string, never>>,
    parent?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, UserCollectionParentArgs>,
    requests?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, UserCollectionRequestsArgs>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollection>>, Record<string, never>>
  },
  UserCollectionDuplicatedData?: {
    childCollections?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionDuplicatedData>>, Record<string, never>>,
    data?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionDuplicatedData>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionDuplicatedData>>, Record<string, never>>,
    parentID?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionDuplicatedData>>, Record<string, never>>,
    requests?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionDuplicatedData>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionDuplicatedData>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionDuplicatedData>>, Record<string, never>>,
    userID?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionDuplicatedData>>, Record<string, never>>
  },
  UserCollectionExportJSONData?: {
    collectionType?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionExportJsonData>>, Record<string, never>>,
    exportedCollection?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionExportJsonData>>, Record<string, never>>
  },
  UserCollectionOrderUpdatedData?: {
    nextUserCollection?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionOrderUpdatedData>>, Record<string, never>>,
    userCollection?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionOrderUpdatedData>>, Record<string, never>>
  },
  UserCollectionRemovedData?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionRemovedData>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<UserCollectionRemovedData>>, Record<string, never>>
  },
  UserEnvironment?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEnvironment>>, Record<string, never>>,
    isGlobal?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEnvironment>>, Record<string, never>>,
    name?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEnvironment>>, Record<string, never>>,
    userUid?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEnvironment>>, Record<string, never>>,
    variables?: GraphCacheUpdateResolver<Maybe<WithTypename<UserEnvironment>>, Record<string, never>>
  },
  UserHistory?: {
    executedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistory>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistory>>, Record<string, never>>,
    isStarred?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistory>>, Record<string, never>>,
    reqType?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistory>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistory>>, Record<string, never>>,
    responseMetadata?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistory>>, Record<string, never>>,
    userUid?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistory>>, Record<string, never>>
  },
  UserHistoryDeletedManyData?: {
    count?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistoryDeletedManyData>>, Record<string, never>>,
    reqType?: GraphCacheUpdateResolver<Maybe<WithTypename<UserHistoryDeletedManyData>>, Record<string, never>>
  },
  UserOrganizationMembership?: {
    invitedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<UserOrganizationMembership>>, Record<string, never>>,
    isAdmin?: GraphCacheUpdateResolver<Maybe<WithTypename<UserOrganizationMembership>>, Record<string, never>>,
    membershipID?: GraphCacheUpdateResolver<Maybe<WithTypename<UserOrganizationMembership>>, Record<string, never>>,
    membershipStatus?: GraphCacheUpdateResolver<Maybe<WithTypename<UserOrganizationMembership>>, Record<string, never>>,
    organization?: GraphCacheUpdateResolver<Maybe<WithTypename<UserOrganizationMembership>>, Record<string, never>>
  },
  UserRequest?: {
    collectionID?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequest>>, Record<string, never>>,
    createdOn?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequest>>, Record<string, never>>,
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequest>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequest>>, Record<string, never>>,
    title?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequest>>, Record<string, never>>,
    type?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequest>>, Record<string, never>>,
    user?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequest>>, Record<string, never>>
  },
  UserRequestReorderData?: {
    nextRequest?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequestReorderData>>, Record<string, never>>,
    request?: GraphCacheUpdateResolver<Maybe<WithTypename<UserRequestReorderData>>, Record<string, never>>
  },
  UserSettings?: {
    id?: GraphCacheUpdateResolver<Maybe<WithTypename<UserSettings>>, Record<string, never>>,
    properties?: GraphCacheUpdateResolver<Maybe<WithTypename<UserSettings>>, Record<string, never>>,
    updatedOn?: GraphCacheUpdateResolver<Maybe<WithTypename<UserSettings>>, Record<string, never>>,
    userUid?: GraphCacheUpdateResolver<Maybe<WithTypename<UserSettings>>, Record<string, never>>
  },
};

export type GraphCacheConfig = Parameters<typeof cacheExchange>[0] & {
  updates?: GraphCacheUpdaters,
  keys?: GraphCacheKeysConfig,
  optimistic?: GraphCacheOptimisticUpdaters,
  resolvers?: GraphCacheResolvers,
};